/* build 1784729381 */
/* 2D bracelet builder (bb2d). Ported from the reference prototype; the layout
   maths (single free arc, chord widths, arcCapacity) is the load-bearing part,
   keep it byte-faithful to the prototype when editing.
   Data contract: #bb2d-data JSON island provides filesBase, wrists[], pixiu
   image URLs, the raw custom.builder_addons choices, and spacer URLs.
   Crystal photos = filesBase + id + '.png' (version-free; never store ?v=). */
(function(){
  'use strict';
  var rootEl=document.querySelector('[data-bb2d]');
  var dataEl=document.getElementById('bb2d-data');
  if(!rootEl||!dataEl) return;
  var D; try{ D=JSON.parse(dataEl.textContent); }catch(e){ return; }

  // ── CDN sizing, applied ONCE at the source ───────────────────────────────
  // Every bead, pearl and charm photo was served at full upload size - 583KB
  // across 26 images on a phone, for art that renders at 38-50px. Walk the
  // data blob and ask Shopify's CDN for a sensible width instead. Doing it
  // here rather than at the dozen places that build <img> markup means no
  // call site can be missed. The files themselves are untouched.
  //
  // 160 is sized for the LIST: beads never draw wider than 41px on the ring
  // and 52px in a picker tile, so 160 still covers 3x retina. The info panel
  // draws at 150px and asks for its own larger copy when opened, so that
  // fetch only happens if someone actually taps a name.
  (function sizeAllImages(node){
    var CDN=/(cdn\.shopify\.com|\/cdn\/shop\/)/;
    function fix(v){
      if(typeof v!=='string') return v;
      if(!CDN.test(v)) return v;
      if(!/\.(png|jpe?g|webp)(\?|$)/i.test(v)) return v;
      if(/[?&]width=/.test(v)) return v;
      return v + (v.indexOf('?')<0 ? '?' : '&') + 'width=160';
    }
    (function walk(o){
      if(!o || typeof o!=='object') return;
      Object.keys(o).forEach(function(k){
        var v=o[k];
        if(typeof v==='string') o[k]=fix(v);
        else if(v && typeof v==='object') walk(v);
      });
    })(node);
  })(D);
  function $id(n){ return document.getElementById('bb2d-'+n); }
  // Drops Shopify's ?v= cache-buster but KEEPS ?width=, which is how these
  // images get served at a sane size - stripping the whole query string
  // silently undid the CDN sizing and the originals were fetched instead.
  function noV(u){
    if(!u) return u;
    var str=String(u), q=str.indexOf('?');
    if(q<0) return str;
    var base=str.slice(0,q);
    var w=/[?&]width=(\d+)/.exec(str);
    return w ? base+'?width='+w[1] : base;
  }

  /* the popup layer lives on <body> so ancestor transforms/overflow never trap it */
  var overlaysWrap=document.querySelector('[data-bb2d-overlays]');
  if(overlaysWrap && overlaysWrap.parentNode!==document.body) document.body.appendChild(overlaysWrap);

  var FILES=(D.filesBase||'https://cdn.shopify.com/s/files/1/0528/5517/7368/files/');
  var CRYSTALS=[{"id":"G-RAG-10","name":"RED AGATE","dname":"Red Agate","el":"fire","colour":"red","tagline":"The Stone of Steady Vitality","summary":"Red Agate is a banded chalcedony coloured by iron oxides, prized since antiquity for its protective layered structure. In feng shui it is associated with steady vitality, the kind that endures across seasons rather than flaring up and burning out.","chakra":"Root (Muladhara), Sacral (Svadhisthana)","benefits":["Steadies fluctuating energy through long efforts","Anchors the fire element without overheating","Forms a protective layered shield around the wearer","Carries the warm earth-fire bridge in 五行","Eases anxious physical tension in the body"],"tip":"Red Agate is traditionally worn on long journeys or during periods of sustained effort.","intentions":["stamina","steadiness","protection"],"origin":"Formed as silica-rich groundwater seeped into gas hollows left in cooling lava, settling out of solution one microscopic band at a time over millions of years."},{"id":"G-AMA-10","name":"AMAZONITE","dname":"Amazonite","el":"wood","colour":"green","tagline":"The Stone of Truthful Speech","summary":"Amazonite, named after the Amazon river, is known for its captivating turquoise-green color. This gemstone symbolizes harmony and balance, reflecting its soothing hues. It is often associated with truth, communication, and courage, offering a sense of calm and reducing stress in those who wear it.","chakra":"Throat (Vishuddha) · Heart (Anahata)","benefits":["Calms anxious thoughts and steadies the heart","Encourages honest, courageous communication","Soothes 怒 (anger / liver fire) in the wood element","Balances feminine and masculine energy","Filters environmental and emotional stress"],"tip":"Amazonite is traditionally associated with truthful, calming speech.","intentions":["truth","communication","harmony"],"origin":"A feldspar that crystallised slowly inside cooling granite deep underground, its colour fixed by traces of lead and water sealed in as the crystal grew."},{"id":"G-AME-10","name":"AMETHYST","dname":"Amethyst","el":"water","colour":"purple","tagline":"The Stone of Spiritual Clarity","summary":"Amethyst, famed for its captivating violet hue, is widely regarded for its beauty and enduring popularity. This gemstone symbolizes clarity of mind and calmness, often associated with promoting sobriety and stability. Its rich coloration is thought to inspire creativity, making it a cherished choice for artistic expression.","chakra":"Third Eye (Ajna) · Crown (Sahasrara)","benefits":["Quiets the mind for meditation and sleep","Strengthens intuition and clear thinking","Transmutes negative energy into protective light","Aids in releasing addictive patterns","Anchors the wisdom of the water element"],"tip":"Amethyst is traditionally associated with restful sleep and clear thought.","intentions":["calm","intuition","clarity"],"origin":"Quartz grown inside gas pockets of ancient lava flows. Traces of iron in the crystal, irradiated over geological time by the surrounding rock, slowly turned it violet."},{"id":"G-AQM-10","name":"AQUAMARINE","dname":"Aquamarine","el":"water","colour":"blue","tagline":"The Stone of Courageous Voice","summary":"Aquamarine is a gemstone cherished for its stunning blue to blue-green colors of the ocean. This gemstone embodies the calming energies of the sea, symbolizing clarity, purity, and emotional tranquility. It is believed to inspire truth and trust, making it a favored stone for soothing the mind and enhancing communication.","chakra":"Throat (Vishuddha)","benefits":["Cools emotional heat and calms reactivity","Opens fluent, truthful communication","Eases the heart through grief and change","Supports travellers, especially over water","Refreshes stagnant qi in the chest"],"tip":"Aquamarine carries the cooling quality of moving water.","intentions":["courage","expression","clarity"],"origin":"A beryl born in pegmatites, the final watery pockets of a cooling granite magma, where rare beryllium gathers and grows into long six-sided crystals."},{"id":"G-OBS-10","name":"OBSIDIAN","dname":"Obsidian","el":"water","colour":"black","tagline":"The Stone of Protection","summary":"Black Obsidian, with its glossy, jet-black appearance, is recognized for its protective qualities. This gemstone symbolizes strength and clarity, often associated with shielding against negativity and promoting emotional cleansing. Its smooth, reflective surface is thought to encourage introspection and truth, making it a powerful stone for personal discovery.","chakra":"Root (Muladhara)","benefits":["Forms a strong shield against negative qi","Reveals hidden truths and self-deceptions","Grounds scattered or overwhelmed energy","Cleanses lingering emotional debris","Strengthens willpower and resolve"],"tip":"Black Obsidian has been carried since antiquity as a grounding, shielding stone.","intentions":["protection","grounding","cleansing"],"origin":"Volcanic glass, made when silica-rich lava meets air or water and chills too fast for any crystal to form. The golden sheen is millions of tiny gas bubbles caught mid-flow at the moment the lava froze."},{"id":"G-QZC-10","name":"CLEAR QUARTZ","dname":"Clear Quartz","el":"metal","colour":"white","tagline":"The Master Healer","summary":"Clear Quartz is renowned for its crystal-clear transparency and versatility, making it a staple in jewelry making. It is celebrated for its durability and the ability to enhance the properties of other stones. Symbolically, it stands for clarity, focus, and amplification of energy, offering a sleek, pure aesthetic.","chakra":"Crown (Sahasrara) · all chakras","benefits":["Amplifies the energy of every other crystal","Brings mental clarity and focus","Channels and directs healing intention","Cleanses the aura and clears stagnant qi","Programs easily to your specific intention"],"tip":"Clear Quartz is the amplifier of the crystal family.","intentions":["clarity","amplification","focus"],"origin":"Silicon and oxygen bonded into crystal inside hot mineral-water veins, grown atom by atom, sometimes over millions of years, into the most abundant crystal on Earth."},{"id":"G-GNT-10","name":"GARNET","dname":"Garnet","el":"fire","colour":"red","tagline":"The Stone of Passionate Commitment","summary":"Garnet, renowned for its deep red color, is a gemstone highly valued across various cultures for its durability and lustrous beauty. This gemstone symbolizes commitment and passion, often associated with lasting relationships and perseverance. Its rich hue is thought to inspire love and devotion.","chakra":"Root (Muladhara) · Sacral (Svadhisthana)","benefits":["Ignites passion in love and creative work","Anchors lasting commitments and devotion","Restores vitality after burnout","Strengthens the fire element","Builds courage to act on your desires"],"tip":"In feng shui, the right wrist projects energy outward.","intentions":["passion","commitment","love"],"origin":"Forged where colliding continents bury clay-rich rock miles deep. Heat and pressure re-knit the minerals into dense crystal, so most garnet is as old as a mountain range."},{"id":"G-JDG-10","name":"GREEN JADE","dname":"Green Jade","el":"wood","colour":"green","tagline":"The Imperial Stone of Prosperity (玉)","summary":"Green Jade, with its soothing shades of green, embodies harmony, balance, and tranquility. This cherished gemstone, particularly revered in Asia for its exceptional quality and vibrant hues, has been a symbol of purity and serenity throughout the ages. Green Jade is not only appreciated for its aesthetic beauty but also for its connection to wisdom, prosperity, and longevity.","chakra":"Heart (Anahata)","benefits":["Invites wealth and lasting prosperity","Soothes the heart and harmonises relationships","Carries the longevity of the wood element","Protects from misfortune across generations","Inspires patient, wise decision-making"],"tip":"Jade is traditionally passed within the family. It is said to take on the qi of those who wear it over time.","intentions":["prosperity","luck","harmony"],"origin":"Born in subduction zones, where an ocean plate dives beneath a continent. Immense pressure at surprisingly cool temperatures knits the stone into interlocking fibres, which is why jade is famously tough to break."},{"id":"G-LAB-10","name":"LABRADORITE","dname":"Labradorite","el":"water","colour":"grey","tagline":"The Stone of Magic and Transformation","summary":"Labradorite is renowned for its mesmerizing play of colors, with blues, greens, and golds that shimmer in the light. This gemstone symbolizes transformation and creativity, often associated with inspiring change and stimulating imagination. Its captivating appearance is believed to protect and enhance mental and intuitive abilities, making it popular for those seeking inspiration and personal growth.","chakra":"Third Eye (Ajna) · Throat (Vishuddha)","benefits":["Awakens latent intuition and inner sight","Carries you through major life transitions","Shields the aura from psychic depletion","Sparks creativity and original thought","Reveals serendipity in everyday moments"],"tip":"Labradorite is associated with thresholds and transformation. Traditionally worn during periods of change.","intentions":["magic","transformation","intuition"],"origin":"A feldspar from slow-cooling basaltic magma. As it cooled over millennia the crystal separated into microscopic internal layers, and those layers are what scatter light within the stone."},{"id":"G-LPL-10","name":"LAPIS LAZULI","dname":"Lapis Lazuli","el":"water","colour":"blue","tagline":"The Stone of Royal Wisdom","summary":"Lapis Lazuli, with its deep celestial blue speckled with pyrite that mimics a starry night, has been a symbol of royalty, wisdom, and honor for thousands of years. Revered for its rich, ultramarine color, this gemstone is often associated with truth and enlightenment. It is believed to offer protection, as well as promote self-awareness and the harmonious expression of one's truth and beliefs.","chakra":"Third Eye (Ajna) · Throat (Vishuddha)","benefits":["Deepens wisdom and self-awareness","Encourages honesty without harshness","Stimulates the desire for knowledge","Soothes inflammation of the throat and head","Connects you to ancestral and spiritual guidance"],"tip":"Lapis Lazuli has been carried since antiquity by scholars and seekers.","intentions":["wisdom","truth","enlightenment"],"origin":"A metamorphic rock made where magma bakes ancient limestone. The heat fuses lazurite with flecks of pyrite and calcite, a recipe that has been mined from the same Afghan valleys for over six thousand years."},{"id":"G-MST-10","name":"MOONSTONE","dname":"Moonstone","el":"water","colour":"white","tagline":"The Stone of the Moon (月光石)","summary":"Moonstone, cherished for its ethereal glow and play of light, symbolizes inner clarity and cyclical change. This gemstone is valued for its calming and soothing qualities, often associated with enhancing emotional balance and harmony. Its subtle, shifting colors are thought to reflect the wearer's true nature, encouraging self-discovery and growth.","chakra":"Crown (Sahasrara) · Third Eye (Ajna)","benefits":["Aligns with the lunar cycle and feminine yin energy","Heightens intuition and inner knowing","Soothes emotional turbulence","Supports new beginnings and fresh starts","Balances hormones and reproductive flow"],"tip":"Its sheen brightens after a night bathed in moonlight.","intentions":["new beginnings","intuition","balance"],"origin":"A feldspar that cooled so slowly that two minerals within it separated into alternating layers finer than a hair, formed deep in the quiet of old magma chambers."},{"id":"G-QZR-10","name":"ROSE QUARTZ","dname":"Rose Quartz","el":"fire","colour":"pink","tagline":"The Stone of Unconditional Love","summary":"Rose Quartz, with its gentle pink essence, is admired for its connection to love and harmony. This gemstone symbolizes compassion and peace, often associated with fostering close bonds and encouraging self-esteem. Its soft color and translucent quality are thought to promote healing and comfort, making it a favorite for jewelry.","chakra":"Heart (Anahata)","benefits":["Opens and heals the heart chakra","Encourages self-love and self-acceptance","Attracts love and strengthens relationships","Calms emotions and reduces stress","Promotes forgiveness and compassion"],"tip":"Rose Quartz is the heart-stone of the quartz family.","intentions":["love","compassion","healing"],"origin":"Quartz from the massive cores of granite pegmatites, tinted by microscopic mineral fibres threaded through the crystal as it grew."},{"id":"G-SUN-10","name":"SUNSTONE","dname":"Sunstone","el":"fire","colour":"orange","tagline":"The Stone of Sovereign Joy","summary":"Sunstone, with its warm shades of orange, red, and pink, glitters with a spangled appearance due to light-reflecting inclusions. This gemstone symbolizes vitality and originality, often associated with invigorating the wearer with a sense of brightness and enthusiasm. Its radiant sparkle and coloration make it a favored choice for adding a cheerful and energizing element to jewelry.","chakra":"Sacral (Svadhisthana) · Solar Plexus (Manipura)","benefits":["Restores vitality and zest for life","Invites abundance and good fortune","Lifts depression and seasonal lows","Strengthens the fire element and 阳 (yang) energy","Sparks confident leadership"],"tip":"Sunstone is associated with the warmth of morning.","intentions":["joy","leadership","vitality"],"origin":"A feldspar grown in slowly cooling lava, where dissolved copper separated into countless microscopic metal platelets suspended in the crystal."},{"id":"G-JDW-10","name":"WHITE JADE","dname":"White Jade","el":"metal","colour":"white","tagline":"The Stone of Pure Beginnings (白玉)","summary":"White Jade, a gemstone renowned for its serene and pure aesthetic, exudes an atmosphere of peace and calm. This variant of jade is celebrated for its smooth, creamy texture and uniform color. It has been associated with light, purity, and protection, not only offering physical beauty but also promoting harmony and balance.","chakra":"Crown (Sahasrara) · Heart (Anahata)","benefits":["Carries purifying metal-element energy","Brings peace and clear-mindedness","Offers gentle, steady protection","Promotes balance in body and mind","Refines speech and intention"],"tip":"White Jade is the most refined member of the jade family in traditional feng shui. Its benefits depend on the wearer's own chart, so wear with intention rather than expectation.","intentions":["purity","gentleness","serenity"],"origin":"Nephrite jade, pressed into being at plate boundaries where sustained pressure weaves the stone into a dense felt of microscopic fibres over millions of years."},{"id":"G-ABS-10","name":"AFRICAN BLOODSTONE","dname":"African Bloodstone","el":"earth","colour":"green","tagline":"The Stone of Resilient Courage","summary":"African Bloodstone, prized for its deep forest-green color punctuated with vivid red inclusions, has long been revered as a talisman of courage and endurance. This gemstone promotes physical vitality and resilience, while its grounding energy steadies the mind and strengthens resolve. It is a powerful stone for those seeking protection and perseverance.","chakra":"Root (Muladhara) · Heart (Anahata)","benefits":["Builds physical stamina and resilience","Grounds anxious or scattered energy","Encourages courage under pressure","Cleanses and revitalises blood qi (氣)","Anchors the earth element"],"tip":"Bloodstone is traditionally carried by those undertaking difficult work. The red flecks represent endurance and renewal.","intentions":["endurance","courage","purification"],"origin":"Chalcedony laid down from silica-rich waters, stained by iron oxides as it hardened, a stone assembled slowly in the quiet of ancient seabeds."},{"id":"G-JDA-10","name":"AFRICAN JADE","dname":"African Jade","el":"wood","colour":"green","tagline":"The Stone of Steady Growth (非洲玉)","summary":"African Jade, known for its rich mottled greens, brings the nourishing energy of the earth with a distinctly vibrant character. Valued for its connection to nature and renewal, this gemstone is associated with prosperity, growth, and the wisdom to recognize opportunity. It is believed to encourage harmony and invite good fortune to those who wear it.","chakra":"Heart (Anahata)","benefits":["Encourages slow, sustainable growth","Smooths interpersonal harmony","Strengthens the wood element","Renews tired or burnt-out energy","Protects from envy and ill intent"],"tip":"African Jade is associated with steady, patient growth. Worn daily, it deepens its connection with the wearer.","intentions":["renewal","resilience","prosperity"],"origin":"Not a true jade but grossular garnet, formed where limestone was cooked and compressed by regional metamorphism until new green crystal grew in its place."},{"id":"G-APT-10","name":"APATITE","dname":"Apatite","el":"water","colour":"blue","tagline":"The Stone of Inspired Motivation","summary":"Apatite, particularly in its blue variety, is celebrated for its vibrant blue hues reminiscent of tropical seas. This gemstone is often associated with motivation and personal growth, symbolizing a drive for achievement and a hunger for knowledge. Its clarity and color are thought to inspire creativity and learning.","chakra":"Throat (Vishuddha) · Third Eye (Ajna)","benefits":["Spurs creative drive and motivation","Clears mental fog and procrastination","Inspires fresh ideas and growth","Aligns intention with action","Supports clear, persuasive communication"],"tip":"Apatite carries forward motion and clarity.","intentions":["motivation","ambition","inspiration"],"origin":"Calcium phosphate, the same mineral family your bones and teeth are built from, crystallised here by igneous heat instead of a living body."},{"id":"G-AVN-10","name":"AVENTURINE","dname":"Aventurine","el":"wood","colour":"green","tagline":"The Stone of Opportunity (东陵玉)","summary":"Green Aventurine, known for its shimmering, translucent green color, is a gemstone highly valued for its aesthetic appeal. This gemstone symbolizes prosperity and luck, often associated with opportunities for success. Its soothing green tones are also thought to encourage emotional calm and resilience.","chakra":"Heart (Anahata)","benefits":["Attracts luck, prosperity, and timely opportunities","Soothes the heart from old wounds","Encourages resilient optimism","Strengthens the wood element","Builds confidence to seize new openings"],"tip":"In feng shui, the left wrist receives incoming energy.","intentions":["luck","opportunity","prosperity"],"origin":"Sandstone that was buried, heated, and re-fused into quartzite, picking up sparkling flecks of green mica as the rock recrystallised."},{"id":"G-JDB-10","name":"DARK GREEN JADE","dname":"Dark Green Jade","el":"wood","colour":"green","tagline":"The Stone of Shadow Protection (墨玉)","summary":"Black Jade, with its sleek, lustrous appearance, is revered for its powerful protective qualities. Unlike other jade varieties, its deep opaque black color is associated with warding off negative energies and promoting inner strength. This gemstone is believed to offer grounding support, clarity of purpose, and the resilience needed to face adversity.","chakra":"Root (Muladhara)","benefits":["Strong protective shield against ill intent","Grounds and purifies the qi field","Reveals hidden truths beneath surface","Strengthens wisdom and resolve","Pairs deep water energy with steady purpose"],"tip":"Dark Green Jade is associated with absorbing heavy energy.","intentions":["protection","endurance","calm"],"origin":"Nephrite from convergent plate boundaries, where slow tectonic pressure over millions of years interlocks the crystal fibres so tightly the stone rings when struck."},{"id":"G-BRZ-10","name":"BRONZITE","dname":"Bronzite","el":"earth","colour":"brown","tagline":"The Stone of Quiet Strength","summary":"Bronzite, named for its warm metallic bronze sheen, is a gemstone valued for its grounding and protective properties. With its rich earthy tones and natural chatoyant luster, it is considered a stone of courtesy and harmony, helping to resolve indecision and instill a sense of confidence and self-assurance.","chakra":"Root (Muladhara) · Solar Plexus (Manipura)","benefits":["Anchors the earth element with calm resolve","Sharpens decision-making under pressure","Deflects negativity back to its source","Restores confidence after setbacks","Promotes harmony in group dynamics"],"tip":"Bronzite carries the steady warmth of grounded action. Traditionally worn during decisions requiring calm conviction.","intentions":["composure","courtesy","protection"],"origin":"An iron-bearing pyroxene from deep magma chambers, a mineral so primordial it also arrives on Earth inside meteorites."},{"id":"G-JDM-10","name":"BURMESE JADE","dname":"Burmese Jade","el":"wood","colour":"green","tagline":"The Imperial Burmese Stone (缅甸玉)","summary":"Burmese Jade, regarded as the finest jade in the world, is renowned for its exceptional translucency and vivid imperial green hues. Sourced primarily from Myanmar, this prized jadeite has been treasured for centuries as a symbol of purity, nobility, and good fortune. It is believed to attract prosperity and blessings while promoting harmony and longevity.","chakra":"Heart (Anahata)","benefits":["Highest grade of jadeite, invites prosperity and longevity","Harmonises wood element with vibrant clarity","Carries auspicious 福 (fú) blessings","Wards off misfortune across generations","Inspires moral integrity and noble action"],"tip":"Burmese Jade is considered the finest jadeite in the feng shui tradition. Cared for, it deepens its glow over generations.","intentions":["serenity","purity","abundance"],"origin":"Jadeite, the rarer of the two true jades, formed only in subduction zones under crushing pressure and low heat, conditions found in few places on Earth beyond northern Myanmar."},{"id":"G-CAR-10","name":"CARNELIAN","dname":"Carnelian","el":"fire","colour":"orange","tagline":"The Stone of Vitality and Courage","summary":"Carnelian is a warm orange-red variety of chalcedony, prized since antiquity for its bold colour and protective qualities. Egyptian and Roman warriors wore it for courage. In feng shui it activates the fire element to bring vitality, motivation, and creative drive to its wearer.","chakra":"Sacral (Svadhisthana), Root (Muladhara)","benefits":["Restores vitality and physical energy","Awakens creativity and bold self-expression","Strengthens courage in new ventures","Activates the sacral chakra for healthy passion","Anchors the fire element to dispel stagnation"],"tip":"The right wrist projects outward in feng shui. Carnelian worn there is traditionally associated with creative courage.","intentions":["creativity","boldness","vitality"],"origin":"Chalcedony coloured by iron, deposited layer by layer from silica waters moving through cooling volcanic rock, then warmed over ages to its ember tones."},{"id":"G-CHA-10","name":"CHALCEDONY","dname":"Chalcedony","el":"water","colour":"blue","tagline":"The Stone of Gentle Speech","summary":"Blue Chalcedony is a soft milky-blue quartz mineral, prized in feng shui for its cooling and calming presence. It belongs to the water element and is believed to balance emotional reactivity, ease communication, and dissolve hostility between people.","chakra":"Throat (Vishuddha)","benefits":["Cools anger and reactive emotions","Encourages thoughtful, gentle speech","Promotes group harmony and mediation","Soothes the throat chakra","Anchors the water element for emotional balance"],"tip":"Chalcedony has been carried since antiquity as a stone of harmonious speech.","intentions":["goodwill","gentle speech","calm"],"origin":"Quartz in its most patient form, precipitated from silica-rich water at low temperature as crystals too fine for the eye, packed into smooth translucent stone."},{"id":"G-CHR-10","name":"CHRYSOPRASE","dname":"Chrysoprase","el":"wood","colour":"green","tagline":"The Stone of New Beginnings","summary":"Chrysoprase is a vibrant apple-green chalcedony coloured by nickel inclusions. In feng shui it embodies fresh wood energy, encouraging growth, optimism, and emotional renewal. Long associated with hope and the courage to begin again after loss.","chakra":"Heart (Anahata)","benefits":["Encourages emotional renewal and fresh starts","Opens the heart to joy and optimism","Soothes nervous tension and self-doubt","Supports growth in love and relationships","Anchors the wood element for new beginnings"],"tip":"Chrysoprase is associated with renewal and hope.","intentions":["hope","renewal","joy"],"origin":"Chalcedony coloured by nickel, created where tropical weathering slowly broke down serpentine rock and its dissolved minerals resettled into stone."},{"id":"G-CIT-10","name":"CITRINE","dname":"Citrine","el":"earth","colour":"yellow","tagline":"The Merchant's Stone of Abundance","summary":"Citrine is a golden-yellow variety of quartz, famed as the merchant's stone for its association with prosperity, abundance, and sunny optimism. Unlike most crystals it does not absorb negative energy. Instead it transmutes that energy into joyful warmth. In feng shui it is placed in the wealth corner to attract financial flow.","chakra":"Solar Plexus (Manipura), Sacral (Svadhisthana)","benefits":["Attracts prosperity and abundance","Strengthens self-confidence and willpower","Transmutes negative energy into joy","Activates the solar plexus for personal power","Energises the earth element for stable manifestation"],"tip":"In feng shui, Citrine is traditionally placed in the southeast (wealth corner) of a home or workspace.","intentions":["abundance","manifestation","joy"],"origin":"Quartz warmed into gold by iron and heat. Most natural citrine began underground as amethyst, then was gently reheated by later geological events."},{"id":"G-FLU-10","name":"FLUORITE","dname":"Fluorite","el":"wood","colour":"multi","tagline":"The Stone of Mental Clarity","summary":"Fluorite is a brilliantly banded crystal showing zones of purple, green, and blue colour. In feng shui it is treasured for organising scattered thoughts, sharpening focus, and harmonising the energies of multiple elements at once. A study stone for students and decision-makers.","chakra":"Third Eye (Ajna), Heart (Anahata)","benefits":["Sharpens mental focus and clarity","Organises scattered or anxious thoughts","Supports learning and steady decision-making","Balances chaotic energy in shared spaces","Harmonises multiple elemental energies"],"tip":"Fluorite carries mental clarity in tradition.","intentions":["focus","order","learning"],"origin":"Calcium fluoride crystallised from hot mineral waters moving through veins and cavities, often alongside metal ores, cooling slowly into perfect cubes and octahedra."},{"id":"G-HWK-10","name":"HAWK'S EYE","dname":"Hawk's Eye","el":"water","colour":"blue","tagline":"The Stone of Far Vision","summary":"Hawk's Eye is the blue cousin of Tiger Eye, formed when the asbestos fibres in the stone retain their original blue-grey colour rather than oxidising to gold. In feng shui it sharpens vision both literal and figurative, helps the wearer see threats and opportunities clearly, and offers protection during travel.","chakra":"Third Eye (Ajna), Throat (Vishuddha)","benefits":["Sharpens focus and clear-sighted decision-making","Lifts perspective above immediate worries","Protects travellers and those crossing thresholds","Strengthens intuition for spotting deception","Cools fire-element overactivity and frustration"],"tip":"The left wrist receives in feng shui.","intentions":["vision","insight","focus"],"origin":"Quartz that seeped into blue crocidolite fibres and sealed them before they could oxidise, preserving the mineral's original deep blue inside the crystal."},{"id":"G-HMT-10","name":"HEMATITE","dname":"Hematite","el":"metal","colour":"grey","tagline":"The Stone of Grounded Strength","summary":"Hematite is an iron-oxide stone with a heavy metallic silver-grey sheen. Used since antiquity as a protective stone for warriors and labourers. In feng shui it anchors the wearer firmly to earth, dispels scattered energy, and forms a shielding boundary against absorbed stress from others.","chakra":"Root (Muladhara)","benefits":["Grounds scattered or overstimulated energy","Forms a protective boundary against external stress","Strengthens willpower and physical endurance","Anchors the metal element for clear discernment","Returns focus to the body and present moment"],"tip":"Hematite has been worn since antiquity as a grounding stone.","intentions":["grounding","strength","resolve"],"origin":"Iron oxide, much of it laid down more than two billion years ago in banded iron formations, when the first oxygen made by early life quite literally rusted the oceans."},{"id":"G-HMQ-10","name":"HEMATOID QUARTZ","dname":"Hematoid Quartz","el":"fire","colour":"red","tagline":"The Stone of Grounded Fire","summary":"Hematoid Quartz, also called Fire Quartz, is clear quartz shot through with rust-red hematite inclusions, blending the amplifying clarity of quartz with the grounding strength of hematite. In feng shui it activates fire energy while keeping it tethered to the earth, fuelling courageous action without recklessness.","chakra":"Root (Muladhara), Sacral (Svadhisthana)","benefits":["Fuels courageous action with steady grounding","Amplifies intentions through the clear quartz base","Transmutes anger into focused vitality","Strengthens willpower during transformation","Bridges fire and earth elements for stable change"],"tip":"Hematoid Quartz combines amplification and grounding.","intentions":["drive","balance","vitality"],"origin":"Quartz that grew around and through clouds of hematite, sealing the iron mineral's fire inside the crystal as it formed."},{"id":"G-HOW-10","name":"HOWLITE","dname":"Howlite","el":"metal","colour":"white","tagline":"The Stone of Stillness","summary":"Howlite is a chalky white stone with distinctive grey-black veining, named after the geologist who discovered it. In feng shui it is treasured as a calming stone for those with anxious or quick-tempered minds, helping the wearer slow racing thoughts, release old anger, and rest deeply.","chakra":"Crown (Sahasrara)","benefits":["Quiets racing thoughts and anxious mind chatter","Releases old anger and resentments held in the body","Supports deep restful sleep","Strengthens patience and emotional regulation","Refines metal element clarity for self-awareness"],"tip":"Howlite is associated with stillness.","intentions":["restful sleep","patience","stillness"],"origin":"A borate mineral crystallised in evaporating boron-rich desert basins, settling out as ancient lakes slowly dried away."},{"id":"G-LAV-10","name":"LAVA ROCK","dname":"Lava Rock","el":"fire","colour":"black","tagline":"The Stone of Fierce Becoming","summary":"Lava Rock is born of volcanic eruption, the cooled flow of liquid fire. In feng shui it carries the raw transformative energy of fire combined with the grounding density of earth, supporting wearers through profound life change. Its porous surface holds essential oils, making it a vessel for personal intention.","chakra":"Root (Muladhara), Sacral (Svadhisthana)","benefits":["Anchors the wearer through major transformation","Strengthens courage to begin again after upheaval","Holds intentions and essential oils within its pores","Channels raw fire energy into steady grounded action","Connects to ancestral and primal strength"],"tip":"Lava Rock is porous and holds a drop of essential oil. Add your chosen scent to carry intention through the day.","intentions":["rebirth","raw strength","grounding"],"origin":"Basalt from a living eruption. Every pore in the stone is a bubble of volcanic gas caught escaping at the instant the lava hardened."},{"id":"G-LEP-10","name":"LEPIDOLITE","dname":"Lepidolite","el":"water","colour":"purple","tagline":"The Stone of Smooth Passage","summary":"Lepidolite is a soft lilac-purple lithium mica, the only mineral naturally containing lithium. In feng shui it is the stone of emotional smoothing, prized for steadying mood and easing transitions. Its silvery mica platelets reflect light like still water, soothing overactive minds.","chakra":"Third Eye (Ajna), Heart (Anahata)","benefits":["Steadies mood swings and emotional turbulence","Eases major life transitions with calm","Supports release of old grief and dependencies","Promotes deep restful sleep","Balances water-element flow when overwhelmed"],"tip":"Lepidolite carries the lithium of the earth in its structure. Traditionally worn during periods of significant change.","intentions":["transition","stress relief","sleep"],"origin":"A lithium mica from pegmatites, the same crystal pockets mined for the lithium in modern batteries, grown in the last mineral-rich waters of cooling granite."},{"id":"G-LOD-10","name":"LODOLITE","dname":"Lodolite","el":"wood","colour":"multi","tagline":"The Stone of Inner Landscapes","summary":"Lodolite, also called Garden Quartz, is clear quartz with mineral inclusions suspended inside, forming tiny landscapes of green, red, and brown. In feng shui it is the dream-walker stone, treasured by shamans for journey work and lucid dreaming, helping the wearer connect with inner worlds.","chakra":"Crown (Sahasrara), Heart (Anahata)","benefits":["Deepens meditation and dream awareness","Connects the wearer to inner guidance and ancestors","Amplifies intentions through the clear quartz base","Supports lucid dreaming and visualisation","Bridges multiple elements through its mineral inclusions"],"tip":"Lodolite is treasured for its inner landscapes.","intentions":["inner journeys","meditation","lucid dreams"],"origin":"Quartz that grew slowly enough to seal whole gardens of other minerals inside itself, each inclusion a record of the chamber it grew in."},{"id":"G-MAL-10","name":"MALACHITE","dname":"Malachite","el":"wood","colour":"green","tagline":"The Stone of Bold Transformation","summary":"Malachite is a vivid green copper-carbonate banded in distinctive concentric rings. In feng shui it is the stone of bold transformation, drawing out emotional patterns that need to shift and protecting the heart through change. A powerful absorber of negative energy that must be cleansed often.","chakra":"Heart (Anahata), Solar Plexus (Manipura)","benefits":["Catalyses deep emotional transformation","Absorbs negative energy and electromagnetic stress","Reveals patterns ready for release","Strengthens heart courage during change","Activates wood-element growth through challenge"],"tip":"Malachite absorbs heavily in tradition.","intentions":["deep change","heart healing","protection"],"origin":"Copper carbonate deposited ring by ring by copper-laden water dripping through limestone above ore bodies, each band one episode of ancient rainfall."},{"id":"G-MAP-10","name":"MAP STONE","dname":"Map Stone","el":"earth","colour":"grey","tagline":"The Stone of Wide Perspective","summary":"Map Stone, also called Grey Crazy Lace Agate or Map Jasper, is a chalcedony patterned with curving maze-like veining that resembles aerial maps. In feng shui it grounds wandering thoughts, offers perspective on life journeys, and supports those navigating complex decisions or paths.","chakra":"Solar Plexus (Manipura), Root (Muladhara)","benefits":["Grants perspective on tangled or complex situations","Grounds anxious thoughts into steady patience","Supports travellers and pilgrims of any kind","Reveals hidden patterns and connections","Anchors earth-element steadiness through change"],"tip":"Map Stone carries the long view.","intentions":["perspective","journey","patience"],"origin":"A jasper, built from iron-stained silica sediments compacted and cemented over immense spans of time, its patterns tracing how those sediments settled."},{"id":"G-MOR-10","name":"MORGANITE","dname":"Morganite","el":"fire","colour":"pink","tagline":"The Stone of Divine Love","summary":"Morganite is a pink-peach variety of beryl, related to emerald and aquamarine. In feng shui it is the stone of divine love, treasured for opening the heart not only to others but to oneself, dissolving old grief, and inviting tender compassion. A gentle but powerful heart-opener.","chakra":"Heart (Anahata)","benefits":["Opens the heart to receive love and tenderness","Dissolves old grief held in the chest","Strengthens self-compassion and gentle self-acceptance","Eases the heart through loss and longing","Softens fire-element intensity into warm devotion"],"tip":"Morganite is the heart-stone of the beryl family. Traditionally worn during periods of grief or learning to receive.","intentions":["divine love","grace","compassion"],"origin":"A beryl from pegmatites tinted by manganese, a rare pink cousin of aquamarine and emerald grown in the final pockets of crystallising granite."},{"id":"G-PYR-10","name":"PYRITE","dname":"Pyrite","el":"metal","colour":"yellow","tagline":"The Stone of Resourceful Action","summary":"Pyrite, called \"fool's gold\" for its brassy metallic shine, is treasured in feng shui as a wealth stone whose dense iron-sulphide structure forms perfect cubes. It is associated with the manifestation of resources and the protective armour of decisive action.","chakra":"Solar Plexus (Manipura)","benefits":["Carries the brightness of cast gold without the cost","Reflects scattered energy back into the wearer","Strengthens willpower for sustained effort","Anchors the metal element with discerning focus","Traditionally placed near the till of a shop"],"tip":"Pyrite is traditionally kept in a desk drawer or the wealth corner of a workspace.","intentions":["wealth","willpower","shielding"],"origin":"Iron and sulfur bonded into brassy cubic crystal, formed in oxygen-poor sediments and hot veins. Miners named it fool's gold, geologists treasure its perfect cubes."},{"id":"G-RJP-10","name":"RED JASPER","dname":"Red Jasper","el":"fire","colour":"red","tagline":"The Stone of Grounded Endurance","summary":"Red Jasper is a microcrystalline quartz coloured by iron, often called the \"supreme nurturer\" in lapidary tradition. In feng shui it is associated with the warm grounding of fire-into-earth, a stone that holds the wearer steady while still moving forward.","chakra":"Root (Muladhara)","benefits":["Grounds restless energy into productive endurance","Carries the warm bridge from fire to earth element","Steadies the body through demanding physical work","Traditionally worn by warriors and athletes","Encourages slow, sustained action over haste"],"tip":"Red Jasper is traditionally carried during long physical tasks or hikes.","intentions":["endurance","stamina","grounding"],"origin":"Opaque chalcedony from iron-rich silica sediments, compacted and cemented into dense stone on ancient sea floors."},{"id":"G-RHO-10","name":"RHODONITE","dname":"Rhodonite","el":"fire","colour":"pink","tagline":"The Stone of Heart Reconciliation","summary":"Rhodonite is a manganese silicate whose rose-pink body is veined with black manganese-oxide lacing. In feng shui tradition it is associated with the work of the heart, gently dissolving resentment and supporting the wearer through forgiveness, both of others and of themselves.","chakra":"Heart (Anahata)","benefits":["Softens the heart toward old grievances","Carries the slow patience of mineral veining","Supports the work of self-forgiveness","Balances fire-element intensity with quiet warmth","Traditionally worn during reconciliation"],"tip":"Rhodonite is traditionally worn during periods when forgiveness, of self or others, is at the centre of inner work.","intentions":["forgiveness","emotional balance","compassion"],"origin":"A manganese silicate born where manganese ore bodies were caught in metamorphism and recrystallised into rose-coloured stone."},{"id":"G-RUT-10","name":"RUTILATED QUARTZ","dname":"Rutilated Quartz","el":"metal","colour":"yellow","tagline":"The Stone of Threaded Intention","summary":"Rutilated Quartz is clear quartz threaded with fine needles of golden rutile (titanium dioxide). In feng shui tradition it is treasured as a stone that carries both the amplification of clear quartz and the directing nature of the metal element, threaded into a single form.","chakra":"Crown (Sahasrara), Solar Plexus (Manipura)","benefits":["Amplifies intention through the clear quartz body","The golden needles are associated with directed focus","Bridges metal and amplification in 五行","Traditionally carried by those weaving long-term plans","Brings spaciousness and structure together"],"tip":"Rutilated Quartz is traditionally paired with a clear written intention.","intentions":["manifestation","acceleration","illumination"],"origin":"Needles of golden rutile crystallised first, then quartz grew around them, sealing the titanium threads inside like straw in amber."},{"id":"G-SEL-10","name":"SELENITE","dname":"Selenite","el":"metal","colour":"white","tagline":"The Stone of Moonlit Clarity","summary":"Selenite is a transparent fibrous variety of gypsum, named after the Greek moon goddess. In feng shui it is treasured as a self-cleansing stone whose striated structure carries the quiet authority of moonlight on still water.","chakra":"Crown (Sahasrara)","benefits":["Does not require cleansing in tradition (cleanses itself)","Carries the still, silvery quality of moonlight","Refines metal-element discernment","Traditionally placed in a room to clear stagnant qi","Soothes overstimulated minds"],"tip":"Selenite is traditionally kept in a room to settle the energy. It dissolves slowly in water, so cleanse with intention rather than rinsing.","intentions":["cleansing","light","peace"],"origin":"Gypsum crystallised from evaporating shallow seas. It grows unusually fast for a mineral, and in one Mexican cave has formed crystals the size of trees."},{"id":"G-SMQ-10","name":"SMOKY QUARTZ","dname":"Smoky Quartz","el":"earth","colour":"brown","tagline":"The Stone of Quiet Transmutation","summary":"Smoky Quartz is a translucent brown-grey quartz coloured by trace radiation in the earth. In feng shui it is associated with grounding and the gentle transmutation of heavy emotions, the smoky tone said to absorb and dissolve what no longer serves.","chakra":"Root (Muladhara)","benefits":["Absorbs and gently transmutes heavy energy","Anchors floaty or anxious thinking in the body","Carries the warm grounding of the earth element","Supports release of old emotional weight","Traditionally placed at the entrance of a home"],"tip":"Smoky Quartz is traditionally cleansed under running water after intensive use.","intentions":["release","grounding","protection"],"origin":"Quartz darkened by natural radiation. Trace aluminium in the crystal, exposed to the faint radioactivity of surrounding granite for millions of years, slowly smoked the stone."},{"id":"G-SOD-10","name":"SODALITE","dname":"Sodalite","el":"water","colour":"blue","tagline":"The Stone of Honest Knowing","summary":"Sodalite is a deep royal-blue silicate veined with white calcite, named for its sodium content. In feng shui tradition it bridges the rational and intuitive, supporting clear honest communication between thought and feeling.","chakra":"Throat (Vishuddha), Third Eye (Ajna)","benefits":["Bridges logical and intuitive understanding","Supports honest communication of inner truth","Carries deep water-element wisdom","Steadies the mind during research and writing","Eases the anxiety that comes from inner conflict"],"tip":"Sodalite is traditionally worn during sustained mental work or honest conversations with oneself.","intentions":["logic","self-expression","truth"],"origin":"A sodium-rich silicate from unusual magmas poor in silica, a chemistry rare enough that sodalite forms in only a handful of places."},{"id":"G-SQR-10","name":"STRAWBERRY QUARTZ","dname":"Strawberry Quartz","el":"fire","colour":"pink","tagline":"The Stone of Heart Sweetness","summary":"Strawberry Quartz is rosy quartz speckled with tiny dark hematite or goethite inclusions, giving it a strawberry-seed appearance. In feng shui it carries a softer warmth than Rose Quartz, the heart-stone of gratitude and small pleasures.","chakra":"Heart (Anahata)","benefits":["Carries the warm sweetness of gratitude","Opens the heart to small, daily joys","Softens fire-element intensity into tender warmth","Traditionally worn after periods of grief","Encourages gentle self-love rather than striving"],"tip":"Strawberry Quartz is traditionally worn close to the heart, where its warmth is said to settle most easily.","intentions":["gratitude","sweetness","love"],"origin":"Quartz seeded through with flecks of iron minerals that were swept up and sealed inside as the crystal grew."},{"id":"G-TIG-10","name":"TIGER EYE","dname":"Tiger Eye","el":"earth","colour":"brown","tagline":"The Stone of Discerning Courage","summary":"Tiger Eye is a chatoyant quartz pseudomorph after crocidolite asbestos, the fibres replaced by silica to produce its golden silken bands. In feng shui it is treasured as a stone of discerning courage, the eye that watches without blinking.","chakra":"Solar Plexus (Manipura), Root (Muladhara)","benefits":["Sharpens discernment in uncertain situations","Carries the watchful steadiness of a tiger","Bridges earth and metal elements with golden warmth","Strengthens resolve through long undertakings","Traditionally worn by leaders and decision-makers"],"tip":"Tiger Eye is traditionally carried into negotiations or moments asking for steady judgment.","intentions":["confidence","discernment","courage"],"origin":"Quartz that slowly replaced golden crocidolite fibres after they oxidised, preserving the silky fibre structure in stone. Geologists call it a pseudomorph, one mineral wearing the shape of another."},{"id":"G-WAG-10","name":"WHITE AGATE","dname":"White Agate","el":"metal","colour":"white","tagline":"The Stone of Quiet Beginning","summary":"White Agate is a soft milky banded chalcedony, prized in feng shui for its quiet purifying presence. Of all the agate family it carries the most settled energy, the kind found in pre-dawn mist before the day takes shape.","chakra":"Crown (Sahasrara)","benefits":["Carries the still presence of pre-dawn mist","Settles the energy of a room without sharp edges","Refines metal-element clarity without coldness","Traditionally placed by the bed for restful sleep","Supports gentle new beginnings"],"tip":"White Agate is traditionally placed at a bedside or worn on the first morning of a fresh undertaking.","intentions":["poise","inner peace","clarity"],"origin":"Banded chalcedony assembled in lava cavities, where mineral water deposited silica in pale layer after pale layer."},{"id":"G-YEQ-10","name":"YELLOW ELLENSBURG QUARTZ","dname":"Yellow Ellensburg Quartz","el":"earth","colour":"yellow","tagline":"The Stone of Honey Warmth","summary":"Yellow Ellensburg Quartz is honey-coloured quartz sourced from the Ellensburg region of Washington state, prized in lapidary tradition for its mellow warmth. In feng shui it carries the same prosperity associations as citrine but with a more grounded, sun-warmed quality.","chakra":"Solar Plexus (Manipura)","benefits":["Carries a mellow, settled prosperity energy","Less fiery than citrine, more like late afternoon sun","Anchors the earth element with golden warmth","Traditionally kept on a desk for steady focus","Eases the anxiety of striving"],"tip":"Yellow Ellensburg Quartz is traditionally placed where it catches afternoon sunlight, where it is said to glow most fully.","intentions":["warmth","optimism","abundance"],"origin":"Quartz coloured golden by iron hydroxides that entered the crystal as it formed in silica-rich groundwater."},{"id":"W-SDW-10","name":"SANDALWOOD","dname":"Sandalwood","el":"wood","colour":"brown","tagline":"The Wood of Quiet Devotion","summary":"Sandalwood (檀香) is a fragrant warm hardwood used in temples and prayer beads across Buddhist, Hindu, and Daoist traditions for over two thousand years. In feng shui it carries the steady warmth of the wood element, the natural fragrance softening as the bead is worn close to the skin.","chakra":"Root (Muladhara), Heart (Anahata)","benefits":["Carries the natural fragrance of devotional practice","Pure wood element, traditionally used for prayer beads","Warms gently with body heat as it is worn","Grounds restless or scattered attention","Traditionally paired with meditation or chanting"],"tip":"Sandalwood gently warms and brightens its fragrance with body heat.","intentions":["sacred calm","meditation","protection"],"origin":"Not a stone at all but heartwood. A sandalwood tree spends decades concentrating fragrant oils into its core, and the wood keeps that scent for a lifetime."},{"id":"G-UNA-10","name":"UNAKITE","dname":"Unakite","el":"earth","colour":"green","tagline":"The Stone of Integrated Growth","summary":"Unakite is a granite-family stone of olive-green epidote mingled with rosy pink feldspar, a mix that reads in feng shui as the union of heart (pink) and growth (green). It is associated with integrating opposites in oneself.","chakra":"Heart (Anahata), Root (Muladhara)","benefits":["Integrates the heart (pink) and growth (green) energies","Carries the slow patience of granite-family stone","Bridges earth grounding and wood expansion in 五行","Traditionally worn during inner reconciliation","Eases anxious striving into steady becoming"],"tip":"Unakite is traditionally worn during periods of reconciling two parts of yourself that have been at odds.","intentions":["integration","heart-balance","patience"],"origin":"Granite transformed. During metamorphism, green epidote infused the feldspar, and the two minerals now share the stone in mottled balance."},{"id":"S-SHE-10","name":"SHELL","dname":"Shell","el":"water","colour":"white","tagline":"The Bead of Gathered Pieces","summary":"Crushed shell beads are formed by pressing small fragments of shell into a polished sphere, each fragment a tiny mosaic of the sea. The pieces carry the patient layering of mollusc growth, broken and rebuilt into a single form. In feng shui they are associated with the gathering of small things over long time, the way tide and breath together shape what they touch.","chakra":"Crown (Sahasrara), Sacral (Svadhisthana)","benefits":["Each fragment is associated with patient layering over time","Carries water-element softness without volatility","Reminds the wearer that wholeness is made of small pieces","Traditionally worn near water or during seasons of slow rebuilding","Pairs the sea's gentle qi with the wearer's breath"],"tip":"Crushed shell is traditionally cleansed under the moon and dried gently. Avoid prolonged soaking, the fragments soften with constant water.","intentions":["flow","feminine energy","intuition"],"origin":"Built by a living mollusc, layer upon layer of nacre laid down over its lifetime, the same material as pearl."},{"id":"G-JDGM-10","name":"MEDIUM GREEN JADE","dname":"Medium Green Jade","el":"wood","colour":"green","tagline":"The Living Green of Growth (翠玉)","summary":"Medium Green Jade carries the full, vibrant green that jade is loved for, sitting between the pale glow of classic Green Jade and the depth of Dark Green Jade. Its steady wood energy nourishes growth in wealth, health, and relationships. It is worn as an everyday companion stone, keeping fortune moving and the heart in balance.","chakra":"Heart (Anahata)","benefits":["Nourishes steady growth in wealth and career","Keeps the heart open and emotionally balanced","Draws everyday luck the way jade has for centuries","Supports new beginnings taking firm root","Carries the vital energy of the wood element"],"tip":"Jade is a companion stone, and its steady energy builds with time spent on the wrist.","intentions":["growth","balance","good fortune"],"origin":"Jade from convergent plate margins, where steady pressure over geological time weaves microscopic crystal fibres into one of the toughest stones known."},{"id":"G-RED-10","name":"RED CINNABAR","dname":"Red Cinnabar","el":"fire","colour":"red","tagline":"The Stone of Vermilion Protection (朱砂)","summary":"Red cinnabar has been treasured in China for centuries, ground into the vermilion ink that sealed imperial edicts and temple talismans. In feng shui it is regarded as one of the strongest protective stones, kept to steady the spirit and turn away what drains it. Its deep vermilion red carries the fire element, long associated with vitality and clear, decisive focus.","chakra":"Root (Muladhara)","benefits":["Long kept as a guardian stone against negative influence","Steadies the spirit in unfamiliar places","Carries the fire element's vitality and drive","Supports clear, decisive focus","Worn to anchor courage through change"],"tip":"Red cinnabar is traditionally worn on the left wrist as a guardian through travel and change.","intentions":["protection","focus","wisdom"],"origin":"Traditional cinnabar beads are crafted from powdered vermilion mineral set and polished in layers of lacquer, the same craft that has coloured temple seals and talismans for over a thousand years."}];
  // Crystal photos are built at runtime, so they never pass through the
  // data-blob walker above - size them here or they load at full upload
  // size (G-RAG-10.png is 1009px for art drawn at 41px).
  CRYSTALS.forEach(function(c){ c.img=FILES+c.id+'.png?width=160'; });

  var PIX_IMG=D.pixiu||{};
  var PIX_SIDE=D.pixiuSide||{};   // side profiles, used for a facing pair
  var TIMES='×';
  // 'None' is still a valid STATE (no dragon on the bracelet) but it no longer
  // gets its own tile: tapping the selected dragon clears it instead.
  var PIX_NONE={v:'None',label:'NONE',img:null,len:0};
  // Tile labels read 'GOLD CLASSIC' etc: first word is the metal, the rest is
  // the size. Shown as size on top, colour smaller beneath.
  function pixColourOf(p){ return String(p.label||'').split(' ')[0]; }
  // Pearl tiles read like the pixiu ones: the DESIGN on top, the metal smaller
  // beneath. 'Gold'/'Silver' are the classic ball, so they show as CLASSIC, and
  // 'Coin Gold Large' drops the Large (its mm line already says 12).
  // Display only - the metafield names are untouched, so the cart and order
  // still say exactly what the shop calls them.
  function pearlColourOf(pl){
    var n=String(pl.name||'');
    var m=n.match(/\b(gold|silver)\b/i);
    return m ? m[1].toUpperCase() : '';
  }
  function pearlDesignOf(pl){
    var n=String(pl.name||'').replace(/\b(gold|silver)\b/ig,'').replace(/\blarge\b/ig,'');
    n=n.replace(/\s+/g,' ').trim();
    if(!n) n='Classic';                 // plain 'Gold' / 'Silver' = the classic ball
    return n.toUpperCase();
  }
  function pixSizeOf(p){
    var parts=String(p.label||'').split(' ');
    return parts.length>1 ? parts.slice(1).join(' ') : (p.label||'');
  }
  var PIXIUS=[
    {v:'Silver Mini - 17 '+TIMES+' 9mm',label:'SILVER MINI',img:noV(PIX_IMG.silverMini),side:noV(PIX_SIDE.silverMini),len:17},
    {v:'Gold Mini - 17 '+TIMES+' 9mm',label:'GOLD MINI',img:noV(PIX_IMG.goldMini),side:noV(PIX_SIDE.goldMini),len:17},
    // Midi (20 x 9mm) sits between Mini and Classic. Photos reuse the Classic
    // art (same trick as the grande silver reusing the mini photo); drawn size
    // comes from len. Variants/prices are pending in another chat - until they
    // exist, currentVariant() returns null and ATC shows UNAVAILABLE, so the
    // size is visible but not buyable.
    {v:'Silver Midi - 20 '+TIMES+' 9mm',label:'SILVER MIDI',img:noV(PIX_IMG.silverClassic),side:noV(PIX_SIDE.silverClassic),len:20},
    {v:'Gold Midi - 20 '+TIMES+' 9mm',label:'GOLD MIDI',img:noV(PIX_IMG.goldClassic),side:noV(PIX_SIDE.goldClassic),len:20},
    {v:'Silver Classic - 26 '+TIMES+' 11mm',label:'SILVER CLASSIC',img:noV(PIX_IMG.silverClassic),side:noV(PIX_SIDE.silverClassic),len:26},
    {v:'Gold Classic - 26 '+TIMES+' 11mm',label:'GOLD CLASSIC',img:noV(PIX_IMG.goldClassic),side:noV(PIX_SIDE.goldClassic),len:26},
    {v:'Silver Grande - 28 '+TIMES+' 13mm',label:'SILVER GRANDE',img:noV(PIX_IMG.silverGrande),side:noV(PIX_SIDE.silverGrande),len:28},
    {v:'Gold Grande - 28 '+TIMES+' 13mm',label:'GOLD GRANDE',img:noV(PIX_IMG.goldGrande),side:noV(PIX_SIDE.goldGrande),len:28}
  ];

  /* Charms come from the shop metafield custom.builder_addons (never hardcoded).
     kind: 'push' cylinders thread BETWEEN beads (reserve no bead slot);
     'replace' charms stand in for a bead at their mm. The push set is the one
     physics fact the metafield doesn't carry. charmSizes = sizes the charm
     itself comes in (mantras are bead-shaped; obsidian matches any bead size). */
  function slug(n){ return String(n).toLowerCase().replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-+|-+$/g,''); }
  var PUSH_KEYS={'protection':1,'protection-and-wealth':1,'zodiac-guardian-ring':1,'zodiac-ring':1};
  var addonChoices=[];
  (D.addons||[]).forEach(function(a){ (a.choices||[]).forEach(function(c){ if(c&&c.image) addonChoices.push(c); }); });
  var CHARMS=addonChoices.map(function(ch){
    var key=slug(ch.name), nm=String(ch.name).toLowerCase();
    var entry={key:key,mm:(ch.bead_mm||[8,10,12]).slice(),kind:(ch.kind||(PUSH_KEYS[key]?'push':'replace')),
      name:(function(n){var l=n.toLowerCase();
        if(l.indexOf('guan yin')>=0) return 'GODDESS OF LOVE';
        if(l.indexOf('zodiac guardian')>=0) return 'ZODIAC GUARDIAN';
        if(l.indexOf('mantra')>=0&&l.indexOf('cinnabar')<0) return 'MANTRA';
        return n.toUpperCase();})(String(ch.name)),rawName:String(ch.name),img:noV(ch.image),popup:ch.popup||null,
      info:ch.info||'',story:ch.story||'',group:String(ch.group||'')};
    if(nm.indexOf('mantra')>=0){
      entry.charmSizes = nm.indexOf('obsidian')>=0 ? [8,10,12] : (ch.bead_mm||[12]).slice();
    }
    return entry;
  });

  /* zodiac sign -> guardian map from the metafield popup; prototype data as fallback */
  var ZODIAC=[['Rat','guanyin'],['Ox','akasagarbha'],['Tiger','akasagarbha'],['Rabbit','manjushri'],
    ['Dragon','samantabhadra'],['Snake','samantabhadra'],['Horse','mahasthamaprapta'],['Goat','vairocana'],
    ['Monkey','vairocana'],['Rooster','acala'],['Dog','amitabha'],['Pig','amitabha']];
  var GUARDIANS={guanyin:['Thousand-Armed Guanyin','千手觀音'],akasagarbha:['Akasagarbha','虛空藏菩薩'],
    manjushri:['Manjushri','文殊菩薩'],samantabhadra:['Samantabhadra','普賢菩薩'],
    mahasthamaprapta:['Mahasthamaprapta','大勢至菩薩'],vairocana:['Vairocana','大日如來'],
    acala:['Acala','不動明王'],amitabha:['Amitabha','阿彌陀佛']};
  (function(){
    var pop=null;
    CHARMS.forEach(function(c){ if(!pop&&c.popup&&c.popup.zodiac&&c.popup.guardians) pop=c.popup; });
    if(!pop) return;
    ZODIAC=pop.zodiac.map(function(z){ return [z.name,z.guardian]; });
    var g={}; pop.guardians.forEach(function(x){ g[x.key]=[x.name,x.character]; });
    GUARDIANS=g;
  })();

  // charms sold in more than one size get a size row on their card
  // Charms sold in more than one size get a size row on their card. The zodiac
  // ring and cube come in 8mm and 10mm (the round is single size).
  var CHARM_SIZE_OPTIONS={'mantra-obsidian':[8,10,12],'protection-and-wealth':[10,12],
    'zodiac-guardian-ring':[8,10],'zodiac-guardian-cube':[8,10]};
  var charmSizePref={};
  // per-pixiu photo scale, drawing only (the silver classic photo reads large
  // against the others, so it is pulled back 5%)
  var PIX_DISPLAY={};
  PIX_DISPLAY['Silver Classic - 26 '+TIMES+' 11mm']=0.95;
  // Midi reuses the Classic photos, so it inherits the same per-photo
  // corrections - without this the silver Midi read large exactly like the
  // silver classic used to
  PIX_DISPLAY['Silver Midi - 20 '+TIMES+' 9mm']=0.95;
  // the gold mini photo carries more transparent padding than the silver, so
  // at the same box it READS smaller; +10% drawing only, physics untouched
  PIX_DISPLAY['Gold Mini - 17 '+TIMES+' 9mm']=1.10;

  // pinned by LABEL, not index: removing the NONE tile shifted every index and
  // silently changed the default dragon
  var PIX_DEFAULT=PIXIUS.filter(function(p){return p.label==='GOLD CLASSIC';})[0]||PIXIUS[0];
  // Colour filters shown NEXT TO the section titles (PIXIU / PEARL OF
  // WISDOM): ALL | SILVER | GOLD, active choice underlined. ALL shows every
  // tile; a colour narrows the strip to that metal. Display filter only -
  // the chosen piece is never deselected by filtering it out of view.
  var pixColourFilter='ALL', pearlColourFilter='ALL', charmGroupFilter='ALL';
  function charmGroupKey(g){
    g=String(g||'').toLowerCase();
    if(g.indexOf('protection')>=0) return 'PROTECTION';
    if(g.indexOf('mantra')>=0) return 'MANTRA';
    if(g.indexOf('deit')>=0||g.indexOf('guardian')>=0&&g.indexOf('zodiac')<0) return 'DEITIES';
    if(g.indexOf('zodiac')>=0) return 'ZODIAC';
    return 'OTHER';
  }
  // small public API so the MOBILE sheets can drive the same filters -
  // call the API, never poke the DOM (the strips rebuild on every render)
  window.bb2dColourFilter=function(kind,c){
    if(kind==='pixiu') pixColourFilter=String(c||'ALL').toUpperCase();
    else if(kind==='pearl') pearlColourFilter=String(c||'ALL').toUpperCase();
    render(false); syncControls();
  };
  window.bb2dColourFilterGet=function(kind){
    return kind==='pixiu'?pixColourFilter:pearlColourFilter;
  };
  function colourSwitch(cellsId, cur, onpick){
    var cells=document.getElementById(cellsId); if(!cells) return;
    var field=cells.closest('.bb2d-field'); if(!field) return;
    var lab=field.querySelector('.lab'); if(!lab) return;
    var sw=lab.querySelector('.bb2d-colsw');
    if(!sw){
      sw=document.createElement('span'); sw.className='bb2d-colsw';
      lab.appendChild(sw);
    }
    sw.innerHTML=(arguments.length>3&&arguments[3]?arguments[3]:['ALL','SILVER','GOLD']).map(function(c){
      return '<button type="button" class="bb2d-colsw-btn'+(c===cur?' on':'')
        +'" data-col="'+c+'">'+c+'</button>'; }).join('');
    sw.onclick=function(e){
      var b=e.target.closest('[data-col]'); if(!b) return;
      e.preventDefault(); e.stopPropagation();
      onpick(b.getAttribute('data-col'));
    };
  }
  var state={pixCount:1,wrist:16,pix:PIX_NONE,charms:[],counts:{},order:[],seq:[],sizes:{},spacerType:'gold',spacerSize:null,spacerPos:[],
    // The pair's CENTRE slot holds exactly one piece: 'pearl', a crystal id
    // if one is dragged in, or null when empty. Starts EMPTY -- the pearl
    // only appears once the customer picks one from the Pearl of Wisdom row.
    pairCentre:null,
    // the pair's bridge beads (one each side of the centre) are the customer's
    // choice too (customer report, 14 Oct 2026: "didn't let me change anything
    // at the 2 of pixiu"); null falls back to the first crystal in the mix
    bridgeL:null,bridgeR:null};
  // Pearl URLs come from Liquid's file_img_url, which carries Shopify's CURRENT
  // ?v= token. Do NOT strip it here: editing a file in place (crop / remove
  // background) keeps the filename and only bumps that token, so the bare URL
  // serves the stale pre-edit copy. The no-?v= rule still applies to metafield
  // image URLs, which are hand-entered and can pin an old version.
  var SPACER_IMG={gold:(D.spacers&&D.spacers.gold)||FILES+'Wealth_Charm_transparent.png?width=160',
                  silver:(D.spacers&&D.spacers.silver)||FILES+'Silver_Wealth_Charm_Photo.png?width=160'};
  // Pearl of Wisdom designs come from the shop metafield custom.builder_pearls.
  // Sizes are per design (mm), and a design may offer several sizes.
  var PEARLS=(D.pearls&&D.pearls.length?D.pearls:[
    {key:'gold',name:'Gold',image:SPACER_IMG.gold,mm:9},
    {key:'silver',name:'Silver',image:SPACER_IMG.silver,mm:9}
  ]).map(function(p){
    var img=String(p.image||'');
    if(p.key==='gold') img=SPACER_IMG.gold;        // these two keep the Liquid-
    if(p.key==='silver') img=SPACER_IMG.silver;    // resolved (versioned) URL
    return {key:p.key||String(p.name||'').toLowerCase().replace(/[^a-z0-9]+/g,'-'),
            name:String(p.name||p.key||'Pearl'),
            img:img, mm:parseFloat(p.mm)||9,
            sizes:(p.sizes&&p.sizes.length?p.sizes.map(parseFloat):null)};
  });
  function pearlByKey(k){
    for(var i=0;i<PEARLS.length;i++) if(PEARLS[i].key===k) return PEARLS[i];
    return PEARLS[0];
  }
  function currentPearl(){ return pearlByKey(state.spacerType); }
  // the pair's centre pearl is a real pearl on the bracelet, so the picker
  // count and the spec line must include it
  function hasPair(){ return !!(state.pix.img&&state.pixCount>1); }
  function pairPearlCount(){ return (hasPair()&&state.pairCentre==='pearl')?1:0; }
  function pairCentreMm(){
    if(!hasPair()||!state.pairCentre) return 0;
    return state.pairCentre==='pearl' ? pearlMm() : sizeOf(state.pairCentre);
  }
  function totalPearlCount(){ return state.spacerPos.length + pairPearlCount(); }
  function pearlMm(){
    var p=currentPearl();
    return state.spacerSize||p.mm||9;
  }
  var SPACER_MM=9;
  // measured sphere-fill of each pearl photo (share of canvas the pearl occupies)
  // Fallback framing for the two original pearls, used only until the async
  // photo scan lands. Everything else (incl. any pearl added later) is measured
  // from the image itself, so CROP AND EXPORT SIZE DO NOT MATTER.
  // ── CDN sizing ───────────────────────────────────────────────────────────
  // Every bead, pearl and charm photo is served at its full upload size -
  // measured 583KB across 26 images on a phone, for art that renders at
  // 38-50px. Shopify's CDN resizes and caches on demand, so ask it for a
  // sensible width instead of the original. The files are untouched.
  //   pearl_coin_gold_12mm.png: 108KB -> ~12KB at 240px
  // 240 covers the largest case (a 111px pixiu on the ring) at 2x retina.
  function cdn(src, w){
    if(!src || typeof src!=='string') return src;
    if(!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return src;  // not a CDN url
    if(/[?&]width=/.test(src)) return src;                            // already sized
    return src + (src.indexOf('?')<0 ? '?' : '&') + 'width=' + (w||240);
  }
  window.bb2dCdn = cdn;

  // The info panel draws art at 150px, so it asks for a 400px copy when it
  // opens. Everything in the lists stays at 160px - this bigger fetch only
  // happens if someone actually taps a name for the story.
  function bigImg(src){
    if(!src || typeof src!=='string') return src;
    return src.replace(/([?&])width=\d+/, '$1width=400');
  }

  var PEARL_FILL={gold:0.692,silver:0.745};
  function fillOf(src,fallback){
    var f=fillRatio(src);                 // measured share of canvas, or null
    return f||fallback||REF_FILL;
  }
  // side-profile dragons draw (and reserve) this share of their real length
  // How a side-profile dragon is DRAWN, as a share of its real length. 1.0
  // because the side photo is a thin silhouette while the single-pixiu photo is
  // a chunky 3/4 view: matching them by measurement (0.72, both 131px) still
  // read visibly smaller to the eye. Approved against a local render.
  var SIDE_FORESHORTEN_W=1.0;
  // How much strand the pair RESERVES per dragon. Kept lower than the drawn
  // width so the beads sit tight against the dragons: reserving the full length
  // left obvious empty gaps either side of each one. Independent of the drawn
  // size on purpose -- coupling the two made bigger dragons spread further
  // apart, which defeated several earlier attempts at this.
  var SIDE_RESERVE_W=0.72;
  // LAYOUT slot for each dragon of a pair - tighter than the capacity
  // reserve above so the cluster sits closer (owner, 20 Aug: "gap a lil
  // smaller"). Counts still use SIDE_RESERVE_W. Register preview's
  // sideSlotW() carries the same value; change both files together.
  var SIDE_LAYOUT_W=0.66;
  // Same idea for a lone top-down pixiu: it was reserving its full 26mm and
  // leaving a gap to the neighbouring beads.
  // A lone dragon is DRAWN at its full length but only RESERVES this share of
  // arc. Set to 0.80 to pull the beads in, which made it overhang its slot by
  // ~5 degrees each side; because the photo's art is not centred in its canvas
  // the two overhangs read unevenly (left bead tight, right bead far). Measured
  // in a local copy across 0.80-1.00: 0.95 is where the visible gap on the left
  // matches the right (-33px vs -32px). Do not lower this to close gaps.
  var SINGLE_RESERVE_W=0.95;
  var MAX_CRYSTALS=99;  // no mix cap (owner, 9 Aug): every bead can differ; physical room is the only limit
  // Sizes offered per crystal (owner's availability list, 12 Oct 2026):
  // 6mm exists only for these stones; everything else is 8/10/12.
  var SIXMM={'G-OBS-10':1,'G-SMQ-10':1,'G-AQM-10':1,'G-AME-10':1,'G-LPL-10':1,
             'G-AVN-10':1,'G-QZR-10':1,'G-TIG-10':1,'G-CIT-10':1,'G-JDG-10':1,
             'G-LAB-10':1};
  // Stones whose made sizes differ from both standard ladders. Source of
  // truth: the live listings (Red Cinnabar sells as 6mm and 8mm only -
  // Fortune/Prosperity Charm bead options, checked 13 Oct 2026).
  var SIZES_ONLY={'G-RED-10':[6,8]};
  var SIZES_AVAILABLE=function(id){ return SIZES_ONLY[id]||(SIXMM[id]?[6,8,10,12]:[8,10,12]); };
  function crystalById(id){ return CRYSTALS.filter(function(c){return c.id===id;})[0]; }
  function activeIds(){ return state.order.filter(function(id){return (state.counts[id]||0)>0;}); }
  function sizeOf(id){ return state.sizes[id]||10; }
  function charmMmSize(){
    // FIXED 10mm (owner, 9 Aug): charms without a size choice (Four Divine
    // Beasts, Guan Yin, Zodiac Round...) are one physical size, so they draw
    // at a constant 10mm regardless of the beads around them. Charms WITH a
    // size picker still use their chosen size via attachedCharmMm().
    return 10; }
  function charmKind(){ if(!state.charms.length) return null;
    var c=CHARMS.filter(function(x){return x.key===state.charms[0].key;})[0];
    return c&&c.kind?c.kind:'replace'; }
  function attachedCharmMm(){
    var a=state.charms[0];
    if(a&&a.size) return a.size;
    return charmMmSize();
  }
  function charmReserveMm(){ return state.charms.length ? (charmKind()==='push'?0:attachedCharmMm()) : 0; }
  function charmStrandMm(){ return state.charms.length ? (charmKind()==='push'?6:attachedCharmMm()) : 0; }
  // A PAIR of pixiu sit nose to nose at the front, bridged by
  // bead + pearl + bead. Those three pieces are part of the front cluster,
  // not the free arc, so they are reserved here and drawn explicitly.
  function bridgeId(side){
    var want=(side==='R')?state.bridgeR:state.bridgeL;
    if(want && (state.counts[want]||0)>0) return want;   // must still be in the mix
    var ids=activeIds();
    return ids.length?ids[0]:null;
  }
  function bridgeMm(side){ var id=bridgeId(side); return id?sizeOf(id):10; }
  function pixiuBlockMm(){
    if(!state.pix.img) return 0;
    // A single pixiu is drawn from a top-down photo whose dragon occupies only
    // part of the frame, so reserving its full length leaves visible gaps
    // either side (same problem the pair had). Reserve the narrower width for
    // both; the DRAWN size is unchanged.
    var one=state.pix.len*((state.pixCount>1&&state.pix.side)?SIDE_RESERVE_W:SINGLE_RESERVE_W);
    if(state.pixCount<2) return one;
    // dragon bead pearl bead dragon, or dragon bead dragon once the centre
    // pearl is removed (a single bead bridges the two dragons)
    if(state.pairCentre) return one*2 + bridgeMm('L') + bridgeMm('R') + pairCentreMm();
    return one*2 + bridgeMm('L');
  }
  // Each pearl eats into capacityMm, so the bead count trims itself as pearls
  // are added. These two keep that sane: never let pearls crowd the strand out
  // entirely, and space new ones as evenly as the current bead count allows.
  function canAddPearl(){
    // keep at least 4 real beads on the strand
    var beadsLeft=Math.floor((capacityMm()-pearlMm())/Math.max(1,avgBeadMm()));
    return beadsLeft>=4;
  }
  function avgBeadMm(){
    var ids=activeIds();
    if(!ids.length) return 10;
    var t=0; ids.forEach(function(id){ t+=sizeOf(id); });
    return t/ids.length;
  }
  // The first pearl sits at position 1: just in front of the pixiu's mouth,
  // one bead away, which is where it has always gone. Extra pearls stack to
  // its LEFT (2, 3, 4...) rather than spreading around the ring.
  var PEARL_HOME=1;
  function pearlSpread(k,n){
    var out=[];
    for(var i=0;i<k;i++) out.push(Math.max(0,Math.min(n,PEARL_HOME+i)));
    return out;
  }
  function addPearl(){
    var n=state.seq.length||1;
    state.spacerPos=pearlSpread(state.spacerPos.length+1, n);
  }
  function nextPearlPos(){ return PEARL_HOME; }
  function capacityMm(){
    return Math.max(0,(state.wrist*10+29)-pixiuBlockMm()-charmReserveMm()-state.spacerPos.length*pearlMm());
  }
  function seqWidthMm(){ return state.seq.reduce(function(a,id){return a+sizeOf(id);},0); }
  function rebuildSeq(protectId){
    var ids=activeIds();
    if(!ids.length){ state.seq=[]; return; }
    var cap=capacityMm();
    var totalW=ids.reduce(function(a,id){return a+state.counts[id]*sizeOf(id);},0);
    if(totalW>0){
      var scale=cap/totalW;
      ids.forEach(function(id){ state.counts[id]=Math.max(1,Math.round(state.counts[id]*scale)); });
    }
    function width(){ return ids.reduce(function(a,id){return a+state.counts[id]*sizeOf(id);},0); }
    var guard=0;
    while(width()>cap && guard++<400){
      var trimCands=ids.slice().sort(function(a,b){return state.counts[b]-state.counts[a];})
        .filter(function(id){return id!==protectId&&state.counts[id]>1;});
      if(!trimCands.length) trimCands=ids.slice().sort(function(a,b){return state.counts[b]-state.counts[a];}).filter(function(id){return state.counts[id]>1;});
      if(!trimCands.length) break;
      state.counts[trimCands[0]]--;
    }
    guard=0;
    while(guard++<400){
      var byCount=ids.slice().sort(function(a,b){return state.counts[b]-state.counts[a];});
      if(protectId) byCount=byCount.filter(function(id){return id!==protectId;}).concat(protectId&&state.counts[protectId]?[protectId]:[]);
      var added=false;
      for(var q=0;q<byCount.length;q++){ if(width()+sizeOf(byCount[q])<=cap){ state.counts[byCount[q]]++; added=true; break; } }
      if(!added) break;
    }
    var N=ids.reduce(function(a,id){return a+state.counts[id];},0);
    var placed={}; ids.forEach(function(id){placed[id]=0;});
    state.seq=[];
    for(var i=0;i<N;i++){
      var best=ids[0],bs=-1e9;
      ids.forEach(function(id){ var sc2=state.counts[id]*(i+1)/N - placed[id]; if(sc2>bs+1e-9){bs=sc2;best=id;} });
      placed[best]++; state.seq.push(best);
    }
  }
  function maybeRebuild(){
    var ids=activeIds();
    if(!ids.length){ state.seq=[]; return; }
    if(!state.seq.length){ rebuildSeq(); return; }
    var cap=capacityMm(), used=seqWidthMm();
    var mn=Math.min.apply(null,ids.map(sizeOf));
    if(used>cap || cap-used>=mn) rebuildSeq();
  }
  function replaceOneBead(fromId,toId){
    var idxs=[]; state.seq.forEach(function(id,i){ if(id===fromId) idxs.push(i); });
    if(!idxs.length) return false;
    state.seq[idxs[Math.floor(idxs.length/2)]]=toId;
    return true;
  }
  function removeCrystalPreserving(id){
    var others=activeIds().filter(function(d){return d!==id;});
    if(!others.length){ state.counts={}; state.order=[]; state.sizes={}; state.seq=[]; return; }
    var k=0;
    state.seq=state.seq.map(function(x){ return x===id? others[k++%others.length] : x; });
    delete state.counts[id]; delete state.sizes[id];
    state.order=state.order.filter(function(d){return d!==id;});
    syncCountsFromSeq();
    if(seqWidthMm()>capacityMm()) rebuildSeq();
  }
  function syncCountsFromSeq(){
    var c={}; state.seq.forEach(function(id){c[id]=(c[id]||0)+1;});
    state.counts=c;
    state.order=state.order.filter(function(id){return c[id];});
    state.seq.forEach(function(id){ if(state.order.indexOf(id)<0) state.order.push(id); });
  }
  // The stepper must land on a state maybeRebuild() accepts (full to within
  // the smallest bead), or render re-levels the counts and the tap visibly
  // undoes itself (customer, 17 Oct 2026: Red Cinnabar 8mm beside 10mm stones
  // never stepped down - 10 cinnabar has NO valid partner count at 18cm, so
  // the old one-bead swap always bounced back). Search outward from the
  // current count for the nearest count of this crystal that the OTHER
  // crystals can pad to a valid width, skipping the impossible counts.
  function stepTrial(id,delta){
    var ids=activeIds();
    if(ids.indexOf(id)<0) ids=ids.concat([id]);
    var others=ids.filter(function(d){return d!==id;});
    if(!others.length) return null;
    var cap=capacityMm();
    var cur=state.counts[id]||0;
    var wants=[];
    if(delta>0){ for(var w2=cur+1;w2<=cur+4;w2++) wants.push(w2); }
    else { for(var w3=cur-1;w3>=1;w3--) wants.push(w3); }
    for(var q=0;q<wants.length;q++){
      var trial={}; ids.forEach(function(d){ trial[d]=(d===id)?wants[q]:(state.counts[d]||0); });
      var width=function(){ var s2=0; ids.forEach(function(d){ s2+=trial[d]*sizeOf(d); }); return s2; };
      var g2=0;
      while(width()>cap && g2++<400){     // trim others, most numerous first
        var t2=others.filter(function(d){return trial[d]>1;}).sort(function(a,b){return trial[b]-trial[a];})[0];
        if(!t2) break;
        trial[t2]--;
      }
      g2=0;
      var grew=true;
      while(grew && g2++<400){            // pad with others only, never this one
        grew=false;
        var cands=others.slice().sort(function(a,b){return trial[b]-trial[a];});
        for(var k2=0;k2<cands.length;k2++){ if(width()+sizeOf(cands[k2])<=cap){ trial[cands[k2]]++; grew=true; break; } }
      }
      var mn=Math.min.apply(null,ids.filter(function(d){return trial[d]>0;}).map(sizeOf));
      if(width()<=cap && cap-width()<mn) return trial;
    }
    return null;
  }
  // Apply new counts with the least movement: in-place swaps first, then
  // middle-occurrence removals, then insertions beside a middle occurrence.
  function applyCountDiff(trial){
    var inc=[], dec=[];
    Object.keys(trial).forEach(function(d){
      var df=(trial[d]||0)-(state.counts[d]||0);
      if(df>0) inc.push({id:d,n:df});
      if(df<0) dec.push({id:d,n:-df});
    });
    inc.forEach(function(g){
      while(g.n>0){
        var src=dec.filter(function(x){return x.n>0;})[0];
        if(!src || !replaceOneBead(src.id,g.id)) break;
        src.n--; g.n--;
      }
    });
    dec.forEach(function(x){
      while(x.n-->0){
        var occ=[]; state.seq.forEach(function(q2,i2){ if(q2===x.id) occ.push(i2); });
        if(!occ.length) break;
        state.seq.splice(occ[Math.floor(occ.length/2)],1);
      }
    });
    inc.forEach(function(g){
      while(g.n-->0){
        var occ2=[]; state.seq.forEach(function(q3,i3){ if(q3===g.id) occ2.push(i3); });
        if(occ2.length) state.seq.splice(occ2[Math.floor(occ2.length/2)],0,g.id);
        else state.seq.push(g.id);
      }
    });
    syncCountsFromSeq();
  }
  function changeCount(id,delta){
    if(delta>0 && !state.seq.length){   // first crystal: fill the bracelet
      state.counts[id]=1; if(state.order.indexOf(id)<0) state.order.push(id);
      rebuildSeq(id); return;
    }
    if(delta<0 && !(state.counts[id]>0)) return;
    var trial=stepTrial(id,delta);
    if(!trial) return;                  // last crystal: use the x to remove entirely
    if(state.order.indexOf(id)<0) state.order.push(id);
    applyCountDiff(trial);
  }
  var beadEls=[], renderWalk=null, renderG=null, centreEl=null, bridgeEls=[];
  function insertionFromPoint(x,y){
    if(!renderG||!renderWalk) return 1;
    var t=(angleAt(x,y)-renderG.start+360)%360;
    var count=0;
    renderWalk.forEach(function(sl){ if(!sl.sp && !sl.ch && sl.t<t) count++; });
    return count;
  }
  // is (x,y) over the pair's centre piece? crystal drags land there.
  function overCentre(x,y){
    if(!centreEl) return false;
    var r=centreEl.getBoundingClientRect();
    return Math.hypot(x-(r.left+r.width/2), y-(r.top+r.height/2)) <= r.width*0.8;
  }
  // is (x,y) over one of the pair's bridge beads? returns 'L' / 'R' / null
  function bridgeAt(x,y){
    for(var k=0;k<bridgeEls.length;k++){
      var r=bridgeEls[k].el.getBoundingClientRect();
      if(Math.hypot(x-(r.left+r.width/2), y-(r.top+r.height/2)) <= r.width*0.8) return bridgeEls[k].side;
    }
    return null;
  }
  function setBridge(side,id){ if(side==='R') state.bridgeR=id; else state.bridgeL=id; }
  function beadAt(x,y){
    for(var k=0;k<beadEls.length;k++){
      var r=beadEls[k].el.getBoundingClientRect();
      if(Math.hypot(x-(r.left+r.width/2), y-(r.top+r.height/2)) <= r.width*0.7) return beadEls[k].idx;
    }
    return null;
  }

  /* wrist sizes come from the product's real Wrist Size option values */
  var WRISTS=(D.wrists&&D.wrists.length)?D.wrists:
    ['13-13.5cm | 5.1-5.3"','14-14.5cm | 5.5-5.7"','15-15.5cm | 5.9-6.1"','16-16.5cm | 6.3-6.5"',
     '17-17.5cm | 6.7-6.9"','18-18.5cm | 7.1-7.3"','19-19.5cm | 7.5-7.7"','20-20.5cm | 7.9-8.1"',
     '21-21.5cm | 8.3-8.5"','22-22.5cm | 8.7-8.9"','23-23.5cm | 9.1-9.3"','24-24.5cm | 9.4-9.6"'];
  var wristSel=$id('wrist');
  WRISTS.forEach(function(label){
    var lower=parseFloat(label), o=document.createElement('option');
    o.value=lower; o.textContent=label;
    if(lower===16) o.selected=true;
    wristSel.appendChild(o);
  });
  state.wrist=parseFloat(wristSel.value)||16;
  state.wristLabel=(wristSel.options[wristSel.selectedIndex]||{}).textContent||WRISTS[3];
  wristSel.addEventListener('change',function(){
    state.wrist=parseFloat(this.value);
    state.wristLabel=(this.options[this.selectedIndex]||{}).textContent;
    render(false);syncControls();
  });

  // ── add to cart: map (pixiu, wrist) to the real variant, carry the design as properties ──
  var VARIANTS=D.variants||[];
  var ATC=D.atcLabels||{};
  var atcBtn=$id('atc'), atcPrice=$id('price'), atcNote=$id('atcNote');
  function currentVariant(){
    if(!state.pix.img) return null;
    for(var i=0;i<VARIANTS.length;i++){
      var v=VARIANTS[i];
      if((v.o1===state.pix.v&&v.o2===state.wristLabel)||(v.o2===state.pix.v&&v.o1===state.wristLabel)) return v;
    }
    return null;
  }
  // ── computed pricing (owner's model, approved 28 Jul, built 9 Aug) ───────
  // Base per bead size is the full-bracelet price prorated by the SPACE each
  // bead fills (her call: "space filled is good"), so a uniform bracelet hits
  // the flat base at ANY wrist size and mixed sizes land in between. Premium
  // stones add a per-bead fee scaled the same way (REF beads = a 16cm wrist),
  // which reproduces her approved table exactly: Lapis 10mm $484, Moonstone
  // 10mm $468, Burmese Jade 12mm $683. Pearls and charms are free ("no
  // everything is free it's fine"); a second pixiu adds its size fee.
  // Checkout charges this number via the hidden $1-a-unit product
  // custom-pixiu-bracelet (quantity = whole dollars), because the Worker
  // deliberately charges only real variant prices and variants cannot price a
  // crystal mix.
  var PENNY_VARIANT=49662022680728;
  var PRICE_BASE={6:250,8:300,10:388,12:488};
  var PRICE_REF_BEADS={6:27,8:20,10:16,12:13};
  var PRICE_FEES=[                        // first match wins, so Burmese
    [/burmese/i,{6:3,8:5,10:6,12:15}],    // outranks the generic jade row
    [/lapis|garnet/i,{8:5,10:6,12:8}],
    [/moonstone/i,{8:4,10:5,12:8}],
    [/jade/i,{8:5,10:6,12:12}]
  ];
  var PIX2_FEE={MINI:15,MIDI:20,CLASSIC:25,GRANDE:30};
  function priceStepAt(mm){               // nearest priced size for fee lookups
    return [6,8,10,12].reduce(function(a,b){ return Math.abs(b-mm)<Math.abs(a-mm)?b:a; });
  }
  function priceBaseAt(mm){               // linear between the four flat bases
    if(PRICE_BASE[mm]) return PRICE_BASE[mm];
    if(mm<=6) return PRICE_BASE[6];
    if(mm>=12) return PRICE_BASE[12];
    var lo=mm<8?6:(mm<10?8:10), hi=lo+2;
    return PRICE_BASE[lo]+(PRICE_BASE[hi]-PRICE_BASE[lo])*(mm-lo)/(hi-lo);
  }
  function computedPrice(){
    var ids=state.seq||[]; if(!ids.length) return null;
    var mmSum=0;
    ids.forEach(function(id){ mmSum+=sizeOf(id); });
    if(!mmSum) return null;
    var sum=0;
    ids.forEach(function(id){
      var s=sizeOf(id), share=s/mmSum, c=crystalById(id), fee=0;
      for(var i=0;i<PRICE_FEES.length;i++){
        if(c && PRICE_FEES[i][0].test(c.dname||'')){ fee=PRICE_FEES[i][1][priceStepAt(s)]||0; break; }
      }
      sum+=share*(priceBaseAt(s)+fee*(PRICE_REF_BEADS[priceStepAt(s)]||16));
    });
    if(state.pixCount>1&&state.pix.label){
      var m=String(state.pix.label).match(/MINI|MIDI|CLASSIC|GRANDE/i);
      if(m) sum+=PIX2_FEE[m[0].toUpperCase()]||0;
    }
    return Math.round(sum);
  }
  function computedPriceText(){
    var p=computedPrice();
    return p==null?'':('$'+p.toFixed(2)+' AUD');
  }
  // 22 Sep 2026 (owner): orders must be ONE item at the real variant's own
  // price, not 268 x $1. The computed model above is no longer charged; the
  // price shown is the variant's price plus the pair upgrade line (same
  // product the register adds, $15/20/25/30 by dragon size).
  var PIX2_VARIANT={MINI:49663526535320,MIDI:49663526568088,CLASSIC:49663526600856,GRANDE:49663526633624};
  function pairSizeKey(){
    if(!(state.pixCount>1&&state.pix.label)) return null;
    var m=String(state.pix.label).match(/MINI|MIDI|CLASSIC|GRANDE/i);
    return m?m[0].toUpperCase():null;
  }
  function pairFee(){ var k=pairSizeKey(); return k?(PIX2_FEE[k]||0):0; }
  function shownPriceText(v){
    if(!v||!v.price) return '';
    var fee=pairFee(); if(!fee) return v.price;
    var m=String(v.price).match(/[\d,]+(?:\.\d+)?/);
    if(!m) return v.price;
    var base=parseFloat(m[0].replace(/,/g,''));
    // keep the variant's own format ("$252.75" or "$252.75 AUD"), swap the number
    return isNaN(base)?v.price:String(v.price).replace(m[0],(base+fee).toFixed(2));
  }
  window.BB2D_PRICE=computedPrice;
  function updateAtc(){
    if(!atcBtn) return;
    var ids=activeIds();
    if(!ids.length){ atcBtn.disabled=true; atcBtn.textContent=ATC.empty||'CHOOSE YOUR CRYSTALS'; atcPrice.textContent=''; return; }
    if(!state.pix.img){ atcBtn.disabled=true; atcBtn.textContent=ATC.noPixiu||'CHOOSE YOUR PIXIU';
      atcPrice.textContent='';
      return; }
    var v=currentVariant();
    // The real variant is what gets charged (22 Sep), so a missing or
    // unavailable variant blocks buying, exactly as before 9 Aug.
    if(!v||!v.available){ atcBtn.disabled=true; atcBtn.textContent=ATC.unavailable||'UNAVAILABLE'; atcPrice.textContent=shownPriceText(v); return; }
    atcBtn.disabled=false; atcBtn.textContent=ATC.add||'ADD TO CART'; atcPrice.textContent=shownPriceText(v);
  }
  // ── capture the ring as a PNG ────────────────────────────────────────────
  // The 3D builder can call toDataURL on its BabylonJS canvas; this ring is
  // plain <img> elements, so we composite them into a canvas ourselves using
  // each element's OWN laid-out position. Reading the DOM rather than
  // recomputing the geometry means the capture can never drift from what the
  // customer is looking at.
  // Shopify's CDN sends CORS headers (verified), so the canvas stays untainted
  // and toDataURL works. If any image ever fails that, we return null and the
  // caller falls back to adding the design without a picture.
  function captureRing(){
    try{
      var stageEl=$id('stage'); if(!stageEl) return Promise.resolve(null);
      var els=[].slice.call(ring.querySelectorAll('img'));
      if(!els.length) return Promise.resolve(null);
      // tight bounding box of what is actually drawn, plus a little padding
      var minX=Infinity,minY=Infinity,maxX=-Infinity,maxY=-Infinity;
      els.forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.width<1||r.height<1) return;
        if(r.left<minX)minX=r.left; if(r.top<minY)minY=r.top;
        if(r.right>maxX)maxX=r.right; if(r.bottom>maxY)maxY=r.bottom;
      });
      if(!isFinite(minX)) return Promise.resolve(null);
      // Crop to the artwork plus a proportional margin. A fixed 14px hugged the
      // ring so tightly that every piece read larger than it does in the
      // builder, where the bracelet sits in a roomy square. 9% of the ring's
      // size reproduces that framing at any bracelet size.
      var _w0=maxX-minX, _h0=maxY-minY;
      // Measured on the live builder: the stage is 556px, the ring 355px, so
      // the margin each side is 28% of the ring's width and it fills ~64% of
      // the frame. Match that exactly so the cart photo is framed like the
      // preview the customer designed in.
      var PAD=Math.round(Math.max(_w0,_h0)*0.28), SCALE=2;   // 2x keeps it crisp
      var w=Math.ceil((maxX-minX)+PAD*2), h=Math.ceil((maxY-minY)+PAD*2);
      if(w<8||h<8||w>4000||h>4000) return Promise.resolve(null);
      var cv=document.createElement('canvas');
      cv.width=w*SCALE; cv.height=h*SCALE;
      var ctx=cv.getContext('2d');
      ctx.scale(SCALE,SCALE);
      ctx.fillStyle='#f8f8f8'; ctx.fillRect(0,0,w,h);
      // draw in DOM order so overlaps match the on-screen stacking
      var jobs=els.map(function(el){
        return new Promise(function(res){
          var r=el.getBoundingClientRect();
          if(r.width<1||r.height<1) return res();
          // Size the draw from the element's own CSS box, NOT from
          // getBoundingClientRect (which returns the ROTATED box and made
          // rotated charms ~54% too big) and NOT from offsetWidth (which for
          // these auto-height images is the layout box, not what is painted).
          // getComputedStyle gives the painted width; height follows the
          // photo's aspect so nothing is stretched.
          // getBoundingClientRect is in SCREEN pixels, so it already includes
          // the ring's CSS scale and IS the painted size. getComputedStyle
          // returns the UNSCALED width, which drew the pixiu 2.4x too wide and
          // swamped the beads. Only a genuinely ROTATED piece needs different
          // handling, because its rect is the enclosing box of the turned
          // image; the matrix tells us (b or c non-zero), not the mere
          // presence of a transform - every piece carries translate(-50%,-50%).
          var im=new Image(); im.crossOrigin='anonymous';
          im.onload=function(){
            var x=r.left-minX+PAD, y=r.top-minY+PAD;
            ctx.save();
            // Reproduce the element's own transform about its centre, and draw
            // at the RECT size. getBoundingClientRect is already in screen
            // pixels, so it is exactly what is painted. Every attempt to be
            // cleverer here (offsetWidth, getComputedStyle, ring-scale maths)
            // made it worse: pieces came out 1.5-2.4x too big, or every bead
            // shrank, or the pixiu was drawn twice. Leave this alone.
            var cs=getComputedStyle(el), t=cs.transform;
            if(t&&t!=='none'){
              var m=t.match(/matrix\(([^)]+)\)/);
              if(m){
                var v=m[1].split(',').map(parseFloat);
                ctx.translate(x+r.width/2, y+r.height/2);
                ctx.transform(v[0],v[1],v[2],v[3],0,0);
                ctx.drawImage(im, -r.width/2, -r.height/2, r.width, r.height);
                ctx.restore(); return res();
              }
            }
            ctx.drawImage(im, x, y, r.width, r.height);
            ctx.restore(); res();
          };
          im.onerror=function(){ res(); };
          im.src=el.src;
        });
      });
      return Promise.all(jobs).then(function(){
        // Downscale before encoding. The capture composites at 2x for crisp
        // edges (~890px), but this image is ONLY ever a cart thumbnail: 110px
        // in the drawer, 160px on the cart page. Uploading 890px was ~26KB of
        // base64 and it is 95% of the /design request body, which is the
        // single slowest step of add-to-cart (measured 2.4s on desktop, worse
        // on mobile data).
        // 320px = 2x the largest slot, so it stays sharp on a retina phone,
        // and lands at ~6KB (-76%). Verified by rendering 890/320/220 side by
        // side at both display sizes: 320 is indistinguishable from 890, while
        // 220 visibly softens the bead edges and the pixiu's face. Do not drop
        // below 320 without re-running that comparison.
        var TARGET=320, out=cv;
        if(cv.width>TARGET){
          try{
            var sc=document.createElement('canvas');
            sc.width=TARGET; sc.height=Math.round(TARGET*cv.height/cv.width);
            var sx=sc.getContext('2d');
            sx.imageSmoothingEnabled=true; sx.imageSmoothingQuality='high';
            sx.fillStyle='#f8f8f8'; sx.fillRect(0,0,sc.width,sc.height);
            sx.drawImage(cv,0,0,sc.width,sc.height);
            out=sc;
          }catch(e){ out=cv; }   // any failure: fall back to the full-size canvas
        }
        // WebP first, JPEG as the fallback for anything that cannot encode it;
        // both are opaque, which is fine because the canvas is already filled
        // with the page colour.
        try{
          var w=out.toDataURL('image/webp',0.8);
          if(w && w.indexOf('data:image/webp')===0) return w;
        }catch(e){}
        try{ return out.toDataURL('image/jpeg',0.85); }catch(e){}
        try{ return out.toDataURL('image/png'); }catch(e){ return null; }
      });
    }catch(e){ return Promise.resolve(null); }
  }

  // Everything the Worker needs to describe, price and re-render this design
  // WITHOUT reading the shop's metafields. state.seq holds bare crystal ids
  // (G-RAG-10), which only resolve against this page's data island, so the
  // resolved block is denormalised on purpose: a stored design stays readable
  // even if a crystal is later renamed or retired.
  function designPayload(){
    var v=currentVariant();
    return {
      kind:'2d',
      version:1,
      state:{
        wrist:state.wrist, wristLabel:state.wristLabel,
        pixCount:state.pixCount, pixV:state.pix.v,
        seq:state.seq.slice(), counts:JSON.parse(JSON.stringify(state.counts)),
        sizes:JSON.parse(JSON.stringify(state.sizes)),
        spacerType:state.spacerType, spacerSize:state.spacerSize,
        spacerPos:state.spacerPos.slice(), pairCentre:state.pairCentre,
        bridgeL:state.bridgeL, bridgeR:state.bridgeR,
        charms:JSON.parse(JSON.stringify(state.charms))
      },
      resolved:{
        crystals:activeIds().map(function(id){
          var c=crystalById(id);
          return {id:id, name:c?c.dname:id, mm:sizeOf(id), qty:state.counts[id]};
        }),
        beadOrder:state.seq.map(function(id){
          var c=crystalById(id);
          return {id:id, name:c?c.dname:id, mm:sizeOf(id)};
        }),
        beads:BEADS_ON_RING,
        pixiu:state.pix.label, pixiuCount:state.pixCount,
        pearl: totalPearlCount()? {name:currentPearl().name, mm:pearlMm(), qty:totalPearlCount()} : null,
        charm: state.charms.length? (function(){
          var ac=CHARMS.filter(function(x){return x.key===state.charms[0].key;})[0];
          return ac? {name:ac.rawName, mm:state.charms[0].size||null,
                      zodiac:state.charms[0].zodiac||null,
                      guardian:state.charms[0].guardian||null} : null;
        })() : null,
        variantId: v?v.id:null,
        price: v?v.price:null
      }
    };
  }
  window.BB2D_CAPTURE=captureRing;
  window.BB2D_PAYLOAD=designPayload;

  function designProperties(){
    var props={};
    props['Crystals']=activeIds().map(function(id){
      var c=crystalById(id);
      return c.dname+' '+sizeOf(id)+'mm ×'+state.counts[id];
    }).join(' + ');
    // Exactly the number the preview drew, set by render(). This is what gets
    // strung, so it must never be re-derived separately from the picture.
    // Internal: the strung bead count is for fulfilment, not the shopper, so it
    // rides as a _ property (Shopify hides those in cart and checkout).
    props['_Beads']=BEADS_ON_RING+' beads';
    // state.pix.label is upper-cased for the tiles; the cart should read like
    // the other properties, so title-case it here.
    if(state.pix.img){
      var _pl=String(state.pix.label||'').toLowerCase().replace(/\b[a-z]/g,function(c){return c.toUpperCase();});
      props['Pixiu']=_pl+(state.pixCount>1?' x2 (facing pair)':'');
    }
    if(hasPair()&&state.pairCentre&&state.pairCentre!=='pearl'){
      var cq=crystalById(state.pairCentre);
      if(cq) props['Centre bead']=cq.dname+' '+sizeOf(state.pairCentre)+'mm';
    }
    // which crystals flank the dragons: fulfilment strings these two beads
    // outside the counted mix, so the order must say them explicitly
    if(hasPair()&&activeIds().length){
      var bL=crystalById(bridgeId('L')), bR=crystalById(bridgeId('R'));
      if(state.pairCentre){
        if(bL&&bR) props['Beside Pixiu']=bL.dname+' '+bridgeMm('L')+'mm (left) / '+bR.dname+' '+bridgeMm('R')+'mm (right)';
      } else if(bL){
        props['Beside Pixiu']=bL.dname+' '+bridgeMm('L')+'mm (between the pair)';
      }
    }
    if(totalPearlCount()) props['Pearl of Wisdom']=currentPearl().name+' '+pearlMm()+'mm ×'+totalPearlCount();
    if(state.charms.length){
      var ac=CHARMS.filter(function(x){return x.key===state.charms[0].key;})[0];
      if(ac){
        // attachedCharmMm() is what the ring actually draws, so the order says
        // the size the customer saw rather than only an explicitly tapped one.
        props['Charm']=ac.rawName+' '+attachedCharmMm()+'mm';
        if(state.charms[0].zodiac) props['Zodiac']=state.charms[0].zodiac+(state.charms[0].guardian?' ('+state.charms[0].guardian+')':'');
      }
    }
    return props;
  }
  // ── add to cart ─────────────────────────────────────────────────────────
  // Preferred path: capture the ring, store the design on the Worker, then ask
  // it for the cart_add payload. Every custom bracelet stays on the ONE
  // "Create Your Own Pixiu Bracelet" listing; the design id and photo URL ride
  // along as line item properties. The Worker never creates products and never
  // trusts our price - Shopify charges the real variant's price.
  // Fallback: if the Worker is unreachable or anything goes wrong, add the
  // normal variant with the text properties, exactly as before. A customer
  // must always be able to buy, even if the photo pipeline is down.
  var WORKER=(D.workerUrl||'https://bracelet-builder-checkout.serenityartnhome.workers.dev').replace(/\/$/,'');

  // set when the customer arrived from the cart's Edit link
  var EDIT_LINE=null;
  // Charge the computed price: the hidden $1 product, quantity = dollars.
  // If the computed price is ever unavailable, fall back to the real variant
  // at its own price - a customer must always be able to buy.
  function chargeLine(v,props){
    // ONE line, quantity 1, at the real variant's own price (owner, 22 Sep
    // 2026: "should be 1 item"). The $1-unit product (PENNY_VARIANT) is no
    // longer charged. The pair upgrade posts as its own line after the add.
    return (v&&v.id)?{id:v.id,quantity:1,properties:props}:null;
  }
  // Second dragon: the same $15/20/25/30 upgrade product the register adds,
  // posted AFTER the bracelet lands so the two adds never race. A failure
  // here never blocks the bracelet; the Pixiu property still says "x2".
  function addPairLine(){
    var k=pairSizeKey(), vid=k&&PIX2_VARIANT[k];
    if(!vid) return Promise.resolve();
    var post=function(){ return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:vid,quantity:1,properties:{'For':document.title.split(' \u2013 ')[0]}})}); };
    // one retry: a swallowed failure here is an UNCHARGED pair upgrade
    // (order #1678 said "x2 (facing pair)" with no pair line, 4 Oct)
    return post().then(function(r){ return (r&&r.ok)?r:post(); })
      .catch(function(){ return post().catch(function(){}); });
  }
  function plainAdd(v){
    var props=designProperties();
    // fulfilment must see at a glance that no photo exists for this order
    // and that the Crystals property is the full build spec
    props['_Design']='NOT SAVED (design service unreachable at order time; string from the Crystals list above)';
    var line=chargeLine(v,props);
    if(!line) return Promise.reject(new Error('no price and no variant'));
    return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify(line)})
      .then(function(r){ if(!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function(){
        // Editing: the fallback must ALSO drop the line the customer came
        // from, or "save the changes" leaves TWO bracelets in the cart
        // (customer report, 29 Oct 2026). After the add, like workerAdd.
        if(EDIT_LINE){
          var gone=EDIT_LINE; EDIT_LINE=null;
          return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
            body:JSON.stringify({id:gone,quantity:0})}).catch(function(){});
        }
      })
      .then(addPairLine)
      .then(function(){ window.location.href='/cart'; });
  }

  // ── pre-upload the design while the customer is still looking at it ──────
  // Measured on mobile: add-to-cart is three SEQUENTIAL round trips (~1s each)
  // and the customer watches an unchanged button for all of it. The /design
  // write is the slow one (~1s even with an empty body - it is a Cloudflare KV
  // write, not the upload size), and it depends ONLY on the current design, so
  // it does not have to wait for the tap.
  // So: once the design has been still for a moment, capture and store it in
  // the background. If they then tap Add, the id is already in hand and the
  // tap only pays for the fast calls. Any edit invalidates it and re-arms.
  var PRE={ key:null, promise:null, timer:null };
  // A cheap signature of everything the stored design captures. If this is
  // unchanged, a previous upload is still valid.
  function designKey(){
    try{ return JSON.stringify(designPayload().state)+'|'+BEADS_ON_RING; }
    catch(e){ return null; }
  }
  function uploadDesign(){
    var payload=designPayload();
    return captureRing().then(function(shot){
      var body={design:payload};
      if(shot) body.screenshot=shot;      // png | webp | jpeg all accepted
      return fetch(WORKER+'/design',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify(body)});
    }).then(function(r){
      if(!r.ok) throw new Error('design store failed '+r.status);
      return r.json();
    }).then(function(d){
      if(!d||!d.id) throw new Error('no design id');
      return d;
    });
  }
  // Called by render() whenever the design changes. Debounced so dragging a
  // quantity stepper does not fire an upload per step.
  function armPreupload(){
    if(PRE.timer) clearTimeout(PRE.timer);
    PRE.key=null; PRE.promise=null;              // any edit invalidates the last one
    PRE.timer=setTimeout(function(){
      var k=designKey(); if(!k) return;
      var ring=$id('ring');
      if(!ring||!ring.querySelectorAll('img').length) return;   // nothing drawn yet
      PRE.key=k;
      // Swallow failures: this is an optimisation, and workerAdd() will simply
      // do the upload itself if the pre-upload did not land.
      PRE.promise=uploadDesign().catch(function(){ PRE.key=null; PRE.promise=null; return null; });
    },1200);
  }
  window.BB2D_ARM_PREUPLOAD=armPreupload;

  function workerAdd(v){
    var payload=designPayload();
    // Reuse the pre-uploaded design if it is for exactly this design.
    var k=designKey();
    var stored=(k && PRE.key===k && PRE.promise) ? PRE.promise : null;
    // a REJECTED first attempt must still reach the retry below - without the
    // catch, one network blip skipped straight to the no-photo fallback
    // (order #1678 shipped without its design photo this way, 4 Oct)
    return (stored||uploadDesign().catch(function(){return null;})).then(function(d){
      if(d&&d.id) return d;
      return uploadDesign();                     // pre-upload had failed: do it now
    }).then(function(d){
      return checkoutFor(d,payload);
    });
  }

  // Everything after the design is stored: ask the Worker for the cart_add
  // payload, add the line, swap out the edited line, open the drawer.
  function checkoutFor(d,payload){
    return Promise.resolve().then(function(){
      return fetch(WORKER+'/checkout',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          kind:'2d',                       // REQUIRED: without it we get the 3D path
          designId:d.id,
          frontendOrigin:window.location.origin,
          resolved:payload.resolved
        })});
    }).then(function(r){
      if(!r.ok) throw new Error('checkout failed '+r.status);
      return r.json();
    }).then(function(c){
      // The worker no longer creates a one-off product per design (every custom
      // bracelet stays on the one listing). It returns the cart_add payload for
      // the REAL variant instead, carrying the design id and photo URL as line
      // item properties, because a cart permalink cannot carry properties.
      if(!c||!c.cart_add||!c.cart_add.items||!c.cart_add.items.length){
        throw new Error('no cart_add payload');
      }
      var item=c.cart_add.items[0];
      // Keep our own readable spec alongside the worker's Design/Photo keys, so
      // the order shows what to string even if the worker is later unavailable.
      var props=designProperties();
      // The worker's keys are for fulfilment (design ref, render URL, view link),
      // not for the shopper. Shopify hides any property whose name starts with
      // '_', so prefix them; the cart template reads _Photo for the thumbnail.
      // Anything the worker duplicates (Pixiu, Pearl) is dropped - our own
      // designProperties() already states it in the customer's language.
      var WORKER_HIDE={Design:1,Photo:1,_view:1};
      var WORKER_SKIP={Pixiu:1,Pearl:1,Crystals:1,Charm:1};
      Object.keys(item.properties||{}).forEach(function(k){
        var v=item.properties[k];
        if(WORKER_SKIP[k]) return;                       // ours already says it
        if(k.charAt(0)==='_'){ props[k]=v; return; }     // already hidden
        props[WORKER_HIDE[k] ? '_'+k : k]=v;
      });
      var line=chargeLine({id:item.id},props);
      return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify(line)})
        .then(function(r){
          if(!r.ok) throw new Error('cart add failed ('+r.status+')');
          // Editing: drop the line we came from so the cart holds one bracelet,
          // not two. Done AFTER the add succeeds, so a failure can never leave
          // the customer with nothing. If the line was already removed in
          // another tab this quietly no-ops.
          if(EDIT_LINE){
            var gone=EDIT_LINE; EDIT_LINE=null;
            return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},
              body:JSON.stringify({id:gone,quantity:0})}).catch(function(){});
          }
        })
        .then(addPairLine)
        .then(function(){
          // Quiet add: stay on the builder. Tell the theme to refresh its cart
          // count and open its drawer, so the customer sees it went in without
          // losing their design.
          atcBtn.textContent=ATC.added||'ADDED';
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));

          // Open the drawer the way the theme does it for every other
          // product (assets/theme.js): fetch the cart fresh, then hand it to
          // halo.updateSidebarCart. Firing custom events was not enough —
          // nothing repopulates the drawer, so it opened showing an empty
          // cart even though the bracelet was really in there.
          // Open the drawer exactly as the theme's own cart icon does: it is
          // an <a href="/cart" data-cart-sidebar> and the theme's delegated
          // handler fetches the cart fresh and fills .halo-cart-sidebar.
          // Clicking it is far more reliable than reproducing that logic.
          // The drawer is shown by body.cart-sidebar-show (base.css line ~4821);
          // verified in the browser: visibility goes hidden -> visible.
          // Clicking the theme's cart link alone did NOT work - the click is
          // swallowed, so the bracelet went into the cart but the drawer never
          // appeared. Click it to let the theme repopulate the contents, then
          // set the class ourselves so it actually opens.
          var themeCartLink=document.querySelector('a[href*="/cart"][data-cart-sidebar]')
                          ||document.querySelector('.header__icon--cart');
          if(themeCartLink) themeCartLink.click();
          // NOTE (22 Jul): an attempt to hold the drawer shut until the theme
          // had finished filling it - to hide the ~1s empty "0 items" flash -
          // stopped the drawer appearing at all. Two variants were tried (poll
          // for .previewCartList / .cartCount, then a MutationObserver on the
          // subtree) and both failed live. Do NOT gate this line behind a
          // readiness check without proving on a REAL device that the drawer
          // still opens; the flash is cosmetic, a drawer that never opens is
          // not. Open it immediately, exactly as it has always worked.
          document.body.classList.add('cart-sidebar-show');

          setTimeout(function(){ atcBtn.disabled=false; atcBtn.textContent=ATC.add||'ADD TO CART'; },1800);
        });
    });
  }

  if(atcBtn) atcBtn.addEventListener('click',function(){
    var v=currentVariant();
    if(!v||atcBtn.disabled) return;
    atcBtn.disabled=true; atcBtn.textContent=ATC.adding||'ADDING...';
    atcNote.textContent='';
    // The add is 2-3 sequential round trips. On mobile data that is a few
    // seconds of an unchanged button, which reads as a freeze. Say what is
    // happening if it runs long. Cleared in every exit path below.
    var slow=setTimeout(function(){ atcNote.textContent='Saving your design…'; },900);
    var done=function(){ clearTimeout(slow); if(atcNote.textContent==='Saving your design…') atcNote.textContent=''; };
    workerAdd(v).then(done).catch(function(err){
      // Photo pipeline unavailable: still let them buy, just without the image.
      if(window.console&&console.warn) console.warn('bb2d: falling back to plain add:',err);
      return plainAdd(v).then(done).catch(function(){
        done();
        atcBtn.disabled=false; atcBtn.textContent=ATC.add||'ADD TO CART';
        atcNote.textContent='Something went wrong, please try again.';
      });
    });
  });

  function cellRow(el,items,getKey,getLabel,getImg,isSel,onPick,dragPayload){
    el.innerHTML='';
    items.forEach(function(it){
      var l=document.createElement('label'); l.className='cell';
      var im=getImg(it);
      l.innerHTML='<input type="radio"'+(isSel(it)?' checked':'')+'>'+
        '<span class="box">'+(im?'<img src="'+im+'" alt="">':'')+'<span class="cl">'+getLabel(it)+'</span></span>';
      if(dragPayload){ l.style.cursor='grab'; l.style.touchAction='none'; hookDrag(l,dragPayload(it)); }
      else l.addEventListener('click',function(e){e.preventDefault();onPick(it);});
      el.appendChild(l);
    });
  }
  function syncControls(){
    var cc=$id('crystalCells'); cc.innerHTML='';
    activeIds().forEach(function(id){
      var c=crystalById(id), qty=state.counts[id];
      var l=document.createElement('label'); l.className='cell slotcell';
      l.innerHTML='<input type="radio" checked><button type="button" class="slot-x" aria-label="Remove">×</button><span class="box"><img src="'+c.img+'" alt="">'+
        '<span class="cl">'+c.name+'</span>'+
        '<span class="qty"><button type="button" class="qbtn">−</button><span class="qn">'+qty+'</span><button type="button" class="qbtn">+</button></span>'+
        '<span class="sz">'+SIZES_AVAILABLE(id).map(function(m){return '<button type="button" class="szbtn'+(sizeOf(id)===m?' sel':'')+'" data-mm="'+m+'">'+m+'</button>';}).join('')+'</span>'+
        '</span>';
      hookDrag(l,{img:c.img,
        drop:function(x,y){
          if(overCentre(x,y)){ state.pairCentre=c.id; return; }   // pair centre
          var bs=bridgeAt(x,y);
          if(bs){ setBridge(bs,c.id); return; }                   // beside a pixiu
          var t=beadAt(x,y);
          if(t!=null){ state.seq[t]=c.id; syncCountsFromSeq(); }
          else changeCount(c.id,1); },
        tap:function(){}});
      var btns=l.querySelectorAll('.qbtn');
      [0,1].forEach(function(bi){
        ['mousedown','touchstart'].forEach(function(tt){ btns[bi].addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
        btns[bi].addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          changeCount(c.id, bi===0?-1:1);
          render(false); syncControls();
        });
      });
      var xbtn=l.querySelector('.slot-x');
      ['mousedown','touchstart'].forEach(function(tt){ xbtn.addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
      xbtn.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation();
        removeCrystalPreserving(id);
        render(false); syncControls();
      });
      l.querySelectorAll('.szbtn').forEach(function(sb){
        ['mousedown','touchstart'].forEach(function(tt){ sb.addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
        sb.addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          state.sizes[id]=parseInt(sb.getAttribute('data-mm'),10);
          rebuildSeq(); render(false); syncControls();
        });
      });
      cc.appendChild(l);
    });
    $id('arrangeBtn').style.display = activeIds().length>1 ? '' : 'none';
    if(activeIds().length<MAX_CRYSTALS){
      var plus=document.createElement('button'); plus.type='button'; plus.className='cell pluscell';
      plus.innerHTML='<span class="box plusbox">+</span>';
      plus.addEventListener('click',function(){ openLibrary(); });
      cc.appendChild(plus);
    }
    var pc=$id('pixCells'); pc.innerHTML='';
    colourSwitch('bb2d-pixCells', pixColourFilter, function(c){
      pixColourFilter=c; render(false); syncControls(); });
    PIXIUS.forEach(function(p){
      if(pixColourFilter!=='ALL' && pixColourOf(p).toUpperCase()!==pixColourFilter) return;
      // All sizes show everywhere (owner's call 28 Jul): a size whose
      // variants have not landed yet renders and previews normally and the
      // existing ATC guard reads UNAVAILABLE until they exist.
      var sel=p.v===state.pix.v;
      var l=document.createElement('label'); l.className='cell';
      // SINGLE | PAIR on the chosen dragon only (owner picked this over the
      // stepper, 9 Aug: a binary choice shown as a binary control, in the
      // same segmented style as the ALL/SILVER/GOLD filters)
      var qty=(sel&&p.img)?'<span class="pixseg">'+
        '<button type="button" class="pixseg-btn'+(state.pixCount<2?' on':'')+'" data-n="1">1</button>'+
        '<button type="button" class="pixseg-btn'+(state.pixCount>1?' on':'')+'" data-n="2">2</button></span>':'';
      // Tiles show TRUE RELATIVE LENGTH (same idea as the pearl tiles):
      // Grande draws full width and the others scale down from it, inside a
      // fixed-height bay so the whole strip grounds on one line. Without
      // this Midi/Classic/Grande read as identical dragons.
      var tileW=Math.round(64*p.len/28);
      l.innerHTML='<input type="radio"'+(sel?' checked':'')+'>'+
        '<span class="box">'+(p.img?'<span class="pix-bay"><img src="'+p.img+'" style="width:'+tileW+'px" alt=""></span>':'')+
          '<span class="cl cl-link" role="button" aria-label="About the pixiu">'+pixSizeOf(p)+'<span class="pix-colour">'+pixColourOf(p)+'</span></span>'+
          '<span class="pix-mm">'+p.len+'MM</span>'+qty+'</span>';
      // Tapping the CHOSEN dragon again clears it - that is how you get a
      // bracelet with no pixiu now that the NONE tile is gone.
      l.addEventListener('click',function(e){
        e.preventDefault();
        // the name is a link to the story, not a way to select the tile
        if(e.target.closest && e.target.closest('.cl-link')){
          openPixiuInfo(p); return;
        }
        if(sel&&p.img){ state.pix=PIX_NONE; state.pixCount=1; }
        else { state.pix=p; if(!p.img) state.pixCount=1; }
        render(false); syncControls();
      });
      var qb=l.querySelectorAll('.pixseg-btn');
      if(qb.length===2){
        [0,1].forEach(function(bi){
          ['mousedown','touchstart'].forEach(function(tt){ qb[bi].addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
          qb[bi].addEventListener('click',function(e){
            e.preventDefault(); e.stopPropagation();
            var want=parseInt(qb[bi].getAttribute('data-n'),10)||1;
            if(want===state.pixCount) return;
            state.pixCount=want;
            // Pairing does NOT invent a pearl. If the customer already chose
            // one it moves from the strand into the centre, where it belongs;
            // otherwise the centre stays empty until they pick one.
            // Pairing moves ONE pearl into the centre and leaves any others on
            // the strand, rather than throwing the extras away.
            if(state.pixCount>1&&state.spacerPos.length&&!pairPearlCount()){
              state.spacerPos.pop(); state.pairCentre='pearl';
            }
            // unpairing puts the centre pearl back on the strand
            if(state.pixCount<2&&state.pairCentre==='pearl'){
              state.pairCentre=null; state.spacerPos.push(nextPearlPos());
            }
            render(false); syncControls();
          });
        });
      }
      pc.appendChild(l);
    });
    // Pearl of Wisdom cells, one per design in the metafield. Every tile shows
    // a 30px sphere: fillOf cancels each photo's own crop, so designs of
    // different real mm still read as tidy equal tiles in the picker (their
    // true mm is what drives the bracelet).
    var sp=$id('spacerCells'); sp.innerHTML='';
    colourSwitch('bb2d-spacerCells', pearlColourFilter, function(c){
      pearlColourFilter=c; render(false); syncControls(); });
    // smallest first - tiles read as a size ladder (owner request)
    PEARLS.slice().sort(function(a,b){
      var am=a.sizes?Math.min.apply(null,a.sizes):a.mm;
      var bm=b.sizes?Math.min.apply(null,b.sizes):b.mm;
      return am-bm;
    }).forEach(function(pl){
      if(pearlColourFilter!=='ALL' && pearlColourOf(pl).toUpperCase()!==pearlColourFilter) return;
      // RETIRED 9 Aug (owner): 'pairable' made the current pearl type render
      // as SELECTED with qty 0 the moment a pair was chosen - a pearl the
      // customer never picked. A tile now lights up only when a pearl is
      // really on the bracelet.
      var pairable=false;
      // stepper stays visible on the chosen design while a pair exists, so a
      // removed centre pearl can be added back without hunting for the tile
      var active=(state.spacerPos.length>0||pairPearlCount()>0||pairable)&&state.spacerType===pl.key;
      var l=document.createElement('label'); l.className='cell';
      // Tiles show TRUE RELATIVE SIZE so a 6mm coin visibly differs from a
      // 12mm one before choosing. 12mm maps to 44px and everything scales from
      // that, with a 20px floor so the 3mm ball stays visible. Dividing by the
      // photo's own fill cancels each crop, so the OBJECT is what scales.
      // Tiles only: the ring's own sizing is untouched.
      var tileMm=pl.sizes?Math.max.apply(null,pl.sizes):pl.mm;
      var tilePx=Math.max(20,Math.min(46,44*tileMm/12));
      var spPx=Math.round(tilePx/fillOf(pl.img,PEARL_FILL[pl.key]));
      var sizeRow='';
      if(active&&pl.sizes&&pl.sizes.length>1){
        var cur=state.spacerSize||pl.mm;
        sizeRow='<span class="sz">'+pl.sizes.map(function(m){
          return '<button type="button" class="szbtn'+(cur===m?' sel':'')+'" data-mm="'+m+'">'+m+'</button>';
        }).join('')+'</span>';
      }
      l.innerHTML='<input type="radio"'+(active?' checked':'')+'><span class="box"><span class="pearl-bay"><img src="'+pl.img+'" style="width:'+spPx+'px;height:'+spPx+'px" alt=""></span>'+
        '<span class="cl cl-link" role="button" aria-label="About the pearl of wisdom">'+pearlDesignOf(pl)+
          (pearlColourOf(pl)?'<span class="pix-colour">'+pearlColourOf(pl)+'</span>':'')+'</span>'+
        // show the CHOSEN size once selected, not the whole list
        '<span class="pearl-mm">'+((pl.sizes&&!active)?pl.sizes.join(' / '):(active&&state.spacerSize?state.spacerSize:pl.mm))+'MM</span>'+
        (active?'<span class="qty"><button type="button" class="qbtn">\u2212</button><span class="qn">'+totalPearlCount()+'</span><button type="button" class="qbtn">+</button></span>':'')+
        sizeRow+
        '</span>';
      function choose(){
        if(state.spacerType!==pl.key){ state.spacerType=pl.key; state.spacerSize=pl.sizes?pl.mm:null; }
      }
      hookDrag(l,{img:pl.img,
        drop:function(x,y){
          choose();
          if(overCentre(x,y)||hasPair()){ state.pairCentre='pearl'; return; }
          // drop adds another pearl at that spot rather than replacing
          if(canAddPearl()) state.spacerPos.push(insertionFromPoint(x,y));   // drop keeps the exact spot
        },
        tap:function(){
          var mine=state.spacerType===pl.key;
          if(mine&&(state.spacerPos.length||pairPearlCount())){
            // already on: tapping again clears them all (the stepper adds one
            // at a time, the tile is the on/off switch)
            state.spacerPos=[]; if(state.pairCentre==='pearl') state.pairCentre=null;
          } else {
            choose();
            // With a pixiu pair the first pearl belongs in the CENTRE.
            if(hasPair()) state.pairCentre='pearl';
            else state.spacerPos=[nextPearlPos()];
          }
        }});
      var spName=l.querySelector('.cl-link');
      ['mousedown','touchstart'].forEach(function(tt){ spName.addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
      spName.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); openSpacerInfo(pl.key); });
      l.querySelectorAll('.szbtn').forEach(function(sb){
        ['mousedown','touchstart'].forEach(function(tt){ sb.addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
        sb.addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          state.spacerSize=parseFloat(sb.getAttribute('data-mm'));
          render(false); syncControls();
        });
      });
      var btns=l.querySelectorAll('.qbtn');
      if(btns.length===2){
        [0,1].forEach(function(bi){
          ['mousedown','touchstart'].forEach(function(tt){ btns[bi].addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
          btns[bi].addEventListener('click',function(e){
            e.preventDefault(); e.stopPropagation();
            if(bi===0){
              // remove the last one added; the pair's centre pearl goes last
              if(state.spacerPos.length) state.spacerPos.pop();
              else if(pairPearlCount()) state.pairCentre=null;
            } else {
              // With a pair, the FIRST pearl fills the centre slot; further
              // ones go on the strand, spread as evenly as the bead count
              // allows. Capped by what actually fits the wrist.
              if(hasPair() && !pairPearlCount()) state.pairCentre='pearl';
              else if(canAddPearl()) addPearl();
            }
            render(false); syncControls();
          });
        });
      }
      sp.appendChild(l);
    });
    // charm strip: every charm is available at every bead size (restriction intentionally off)
    function charmFits(c){ return true; }
    if(state.charms.length){
      var att=CHARMS.filter(function(x){return x.key===state.charms[0].key;})[0];
      if(att && !charmFits(att)){ state.charms=[]; render(false); }
    }
    var strip=$id('charmStrip'); strip.innerHTML='';
    colourSwitch('bb2d-charmStrip', charmGroupFilter, function(c){
      charmGroupFilter=c; render(false); syncControls();
    }, ['ALL','PROTECTION','MANTRA','DEITIES','ZODIAC']);
    CHARMS.forEach(function(c){
      if(charmGroupFilter!=='ALL' && charmGroupKey(c.group)!==charmGroupFilter) return;
      var fits=charmFits(c);
      var d=document.createElement('div');
      d.className='charm-card'+(state.charms.some(function(x){return x.key===c.key;})?' attached':'')+(fits?'':' unavail');
      var att0=state.charms.length&&state.charms[0].key===c.key?state.charms[0]:null;
      // thumbnails scale with the charm's real size (12mm = full 40px)
      // tiles hint at real scale but never shrink so far the charm is unreadable
      // (6mm cinnabar): floor the drawn size, and sizeComp cancels each photo's crop
      var dispMm = c.charmSizes ? (c.charmSizes.length===1 ? c.charmSizes[0] : 10) : 10;
      var px = Math.round(Math.max(30, 40*dispMm/12) * sizeComp(c.img));
      var sizeOpts=CHARM_SIZE_OPTIONS[c.key];
      var curMm=(att0&&att0.size)||charmSizePref[c.key]||10;
      var szHtml=sizeOpts?'<span class="sz">'+sizeOpts.map(function(m){return '<button type="button" class="szbtn'+(curMm===m?' sel':'')+'" data-mm="'+m+'">'+m+'</button>';}).join('')+'</span>':'';
      d.innerHTML='<span class="charm-thumb"><img src="'+c.img+'" style="width:'+px+'px;height:'+px+'px" alt=""></span><span class="cl" role="button" aria-label="About '+c.rawName+'">'+c.name+(att0&&att0.zodiac?'<br>'+att0.zodiac.toUpperCase():'')+(fits?'':'<br>'+c.mm.join('/')+'MM ONLY')+'</span>'+szHtml;
      var chName=d.querySelector('.cl');
      ['mousedown','touchstart'].forEach(function(tt){ chName.addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
      // On touch the name fills most of the tile, so tapping it must ADD the
      // charm like the rest of the card; the story stays reachable from the
      // info dot. On desktop the name keeps opening the story on click.
      // The name opens the charm's story on EVERY device. Making it add the
      // charm on touch (to fix tap-to-add) silently removed the only way to
      // read a charm's info on a phone. The card itself handles adding.
      chName.addEventListener('click',function(e){
        e.preventDefault(); e.stopPropagation(); openCharmInfo(c);
      });
      d.querySelectorAll('.szbtn').forEach(function(sb){
        ['mousedown','touchstart'].forEach(function(tt){ sb.addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
        sb.addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          var mm=parseInt(sb.getAttribute('data-mm'),10);
          charmSizePref[c.key]=mm;
          if(state.charms.length&&state.charms[0].key===c.key) state.charms[0].size=mm;
          render(false); syncControls();
        });
      });
      if(fits) hookDragSource(d,c);
      strip.appendChild(d);
    });
    wireNativeDnD();
  }

  var stage=$id('stage'), ring=$id('ring');
  var reduce=matchMedia('(prefers-reduced-motion:reduce)').matches;
  var R=40, CIRC_PCT=2*Math.PI*R;   // ring circumference in stage-%

  // Bead-count maths copied from the 3D builder (frontend/src/utils/braceletMath.js):
  //   maxCircumference(wristCm) = wristCm*10 + 29   (ring auto-stretches inside its range)
  //   arcCapacity = maxCircumference - reserved charm widths
  //   bead count  = floor(arcCapacity / bead mm)
  // The drawn ring uses the ACTUAL chain length (beads + pixiu + charm), like the
  // auto-stretch ring, so beads always sit touching.
  // ring point in stage-% space, matching pos()
  function ringPoint(deg){ var a=(deg-90)*Math.PI/180; return {x:50+Math.cos(a)*R, y:50+Math.sin(a)*R}; }
  function pos(el,deg){ var a=(deg-90)*Math.PI/180; el.style.left=(50+Math.cos(a)*R)+'%'; el.style.top=(50+Math.sin(a)*R)+'%'; }

  // ── photo-crop compensation ─────────────────────────────────────────────
  // The crystal PNGs are hand-cropped, so the sphere fills each canvas
  // differently and identical mm rendered identically LOOKS different.
  // Measure each image's opaque bounding box once (canvas alpha scan) and
  // scale its drawn width so every 10mm bead reads as the same 10mm.
  var IMG_FILL={}, IMG_FILL_PENDING={};
  var REF_FILL=0.85;   // reference: sphere occupies 85% of its canvas
  // draw-only (owner, 10 Aug): beads and pearls render a touch wider so
  // neighbours read as just touching, like a strung bracelet. Positions,
  // physics and bead counts are untouched - this multiplies WIDTH only.
  // 1.21 -> 1.17 (owner, 24 Aug: beads overlapped a tiny bit too much on
  // 12mm jade in the register preview; both builders share this value)
  var BEAD_TIGHT=1.17;
  // While a photo is still unmeasured its width is mm*1 (slightly small);
  // the measurement then grows it to its final tightened size. Applying
  // BEAD_TIGHT before measuring made beads pop in oversized and shrink,
  // which read as "big then small" (owner, 10 Aug).
  function tightComp(src){
    var f=fillRatio(src);
    return f?Math.min(1.6,Math.max(0.7,REF_FILL/f))*BEAD_TIGHT:1;
  }
  function fillRatio(src){
    if(IMG_FILL[src]!=null) return IMG_FILL[src];
    if(!IMG_FILL_PENDING[src]){
      IMG_FILL_PENDING[src]=1;
      var im=new Image(); im.crossOrigin='anonymous';
      im.onload=function(){
        try{
          var N=128,cv=document.createElement('canvas'); cv.width=N; cv.height=N;
          var cx2=cv.getContext('2d'); cx2.drawImage(im,0,0,N,N);
          var d=cx2.getImageData(0,0,N,N).data;
          var minX=N,minY=N,maxX=-1,maxY=-1;
          for(var y=0;y<N;y++)for(var x=0;x<N;x++){
            if(d[(y*N+x)*4+3]>16){ if(x<minX)minX=x; if(x>maxX)maxX=x; if(y<minY)minY=y; if(y>maxY)maxY=y; }
          }
          // Beads are round, so the TRUE diameter is the larger of width/height:
          // a photo clipped at the edges reads short on that axis, and using the
          // max keeps such a crop from being drawn oversized. Averaging the two
          // when they are close smooths out ragged cutouts.
          var bw=(maxX-minX+1)/N, bh=(maxY-minY+1)/N;
          var r;
          if(maxX<0){ r=REF_FILL; }
          else if(Math.abs(bw-bh)<0.06){ r=(bw+bh)/2; }   // round-ish: average
          else { r=Math.max(bw,bh); }                     // clipped/odd: use the long axis
          IMG_FILL[src]=Math.min(1,Math.max(0.4,r));
        }catch(e){ IMG_FILL[src]=REF_FILL; }   // CORS-tainted canvas etc: no compensation
        // Re-render so the new measurement applies - but NOT while beads are
        // assembling: rebuilding mid-flight replaces the animating elements
        // and the animation vanishes (this is why picking 2+ crystals showed
        // no animation: the second photo finished measuring mid-assemble).
        var wait=animatingUntil-Date.now();
        var apply=function(){
          render(false);
          if(typeof syncControls==='function') syncControls();
        };
        if(wait>0) setTimeout(apply, wait+30); else apply();
      };
      im.onerror=function(){ IMG_FILL[src]=REF_FILL; };
      im.src=src;
    }
    return null;
  }
  function sizeComp(src){
    var f=fillRatio(src);
    return f?Math.min(1.6,Math.max(0.7,REF_FILL/f)):1;
  }

  // Mobile: the square stage leaves empty bands above/below small rings.
  // Crop them by exactly the measured whitespace so text below never
  // overlaps big (24cm) rings and never sits far from small ones.
  function cropStageToRing(scale){
    if(window.innerWidth>860){ stage.style.marginTop=''; stage.style.marginBottom=''; return; }
    var w=stage.getBoundingClientRect().width||stage.offsetWidth;
    // Ring radius is 40% of the stage times scale; the beads then stick out by
    // their own radius. That overhang used to be assumed at 8% of the stage,
    // which was fine while phones rendered small rings, but once the mobile
    // ring filled the screen the beads grew past it and the crop sliced the
    // top of the circle off. Measure the real overhang from the widest piece
    // actually on the ring, and keep the 8% as a floor.
    var over=0;
    ring.querySelectorAll('img').forEach(function(el){
      var bw=el.getBoundingClientRect().width;
      if(bw>over) over=bw;
    });
    var overPct=over? (over/2)/w : 0;
    var outer=w*(0.4*scale+Math.max(0.08, overPct));
    var crop=Math.max(0, w/2 - outer - 6);
    // The theme header is sticky on mobile, so pulling the stage up by the full
    // crop slid the top of the ring underneath it and the circle read as cut
    // off. Never crop more off the TOP than the space below the header.
    var hdr=document.querySelector('.header-mobile, [class*="header"][class*="sticky"], header');
    var hdrH=0;
    if(hdr){
      var hs=getComputedStyle(hdr);
      if(hs.position==='fixed'||hs.position==='sticky') hdrH=hdr.getBoundingClientRect().height;
    }
    var topCrop=Math.max(0, Math.min(crop, crop-hdrH));
    stage.style.marginTop=(-topCrop)+'px';
    stage.style.marginBottom=(-crop)+'px';
    // The ring is not vertically centred in the stage (the pixiu cluster sits
    // at the bottom and the pair is drawn wider), so one symmetric crop clipped
    // whichever side the art leaned towards. Measure what actually overflows
    // after the crop and give that edge its margin back.
    requestAnimationFrame(function(){
      var sr=stage.getBoundingClientRect(), top=Infinity, bot=-Infinity;
      ring.querySelectorAll('img').forEach(function(el){
        var r=el.getBoundingClientRect();
        if(r.top<top) top=r.top;
        if(r.bottom>bot) bot=r.bottom;
      });
      if(top===Infinity) return;
      var overTop=sr.top-top, overBot=bot-sr.bottom;
      if(overTop>0) stage.style.marginTop=(-Math.max(0,topCrop-overTop-4))+'px';
      if(overBot>0) stage.style.marginBottom=(-(crop-overBot-4))+'px';
    });
  }

  // Bead assemble animation. The element must be laid out in its start state
  // (opacity 0, scale .5) and PAINTED before 'in' is added, or the browser
  // collapses both states into one frame and nothing transitions - which is
  // why the beads used to just appear. offsetWidth forces that layout flush.
  var animatingUntil=0;
  function animateIn(el,i){
    el.offsetWidth;                       // flush: commit the start state
    var delay=i*34;
    animatingUntil=Math.max(animatingUntil, Date.now()+delay+450);  // +transition
    setTimeout(function(){ el.classList.add('in'); }, delay);
  }

  // ── undo / redo ─────────────────────────────────────────────────────────
  // The whole design lives in `state`, so history is just a stack of JSON
  // snapshots. push() is called AFTER each committed change; the flag stops a
  // snapshot being taken while undo/redo is itself applying one.
  var HIST=[], HPOS=-1, HAPPLY=false, HMAX=60;
  function snapshot(){ return JSON.stringify(state); }
  // Captured BEFORE the first render, which seeds default crystals - taking it
  // at histInit meant 'start over' restored a bracelet that was already built.
  var PRISTINE=JSON.stringify(state);
  function histInit(){ HIST=[snapshot()]; HPOS=0; histSync(); }
  // Start over. Restores the state the builder loaded with and pushes it onto
  // the history, so a reset can itself be undone if it was a mistake.
  window.BB2D_RESET=function(){
    if(!PRISTINE) return;
    var snap=JSON.parse(PRISTINE);
    HAPPLY=true;
    Object.keys(snap).forEach(function(k){ state[k]=snap[k]; });
    HAPPLY=false;
    render(false); syncControls(); histPush();
  };
  function histPush(){
    if(HAPPLY) return;
    var snap=snapshot();
    if(HPOS>=0 && HIST[HPOS]===snap) return;      // nothing actually changed
    HIST=HIST.slice(0,HPOS+1);                    // a new move clears the redo tail
    HIST.push(snap);
    if(HIST.length>HMAX){ HIST.shift(); }
    HPOS=HIST.length-1;
    histSync();
  }
  function histApply(i){
    if(i<0||i>=HIST.length) return;
    HPOS=i; HAPPLY=true;
    var snap=JSON.parse(HIST[i]);
    Object.keys(snap).forEach(function(k){ state[k]=snap[k]; });
    HAPPLY=false;
    render(false); syncControls(); histSync();
  }
  function histSync(){
    var u=$id('undo'), r=$id('redo');
    if(u) u.disabled = HPOS<=0;
    if(r) r.disabled = HPOS>=HIST.length-1;
  }
  window.BB2D_UNDO=function(){ histApply(HPOS-1); };
  window.BB2D_REDO=function(){ histApply(HPOS+1); };

  function render(animate){
    // keep the element panel in step with the bracelet
    if(window.renderElementPanel) try{ window.renderElementPanel(); }catch(_){}
    ring.innerHTML=''; beadEls=[]; centreEl=null; bridgeEls=[];
    var pixLen = state.pix.img ? state.pix.len : 0;
    var sc=state.spacerPos.length;
    maybeRebuild();
    var n=state.seq.length;
    var isEmpty = n===0;
    $id('ringEmpty').style.display = isEmpty?'flex':'none';
    var ringHint=$id('ringHint');
    if(ringHint) ringHint.style.display = isEmpty?'none':'flex';
    stage.classList.toggle('is-empty',isEmpty);
    $id('ground').style.display = '';
    $id('spec').style.display = isEmpty?'none':'';
    // clear the text too, not just hide it: after 'start over' the old
    // bracelet's description was still sitting in the DOM
    if(isEmpty) $id('spec').textContent='';
    if(isEmpty){
      // placeholder preview: dashed empty bead slots around the standard pixiu
      var phPixLen=state.pix.img?state.pix.len:0;
      var phN=Math.max(1,Math.floor(Math.max(0,(state.wrist*10+29)-phPixLen)/10));
      var phChain=Math.max(1,phN*10+phPixLen);
      var phStart=180+(phPixLen?360*phPixLen/phChain:0)/2, phSpan=Math.max(0.001,360-(phPixLen?360*phPixLen/phChain:0));
      var phW=360*10/phChain, phGap=(phSpan-phN*phW)/(phN+1), phCum=0;
      // Fixed square (412px) sized so a 24cm bracelet fills it. Bracelet size is
      // absolute (does NOT depend on window width); smaller bracelets render
      // proportionally smaller and centred, leftover space is just white.
      // same reference as the filled ring below, or the preview would resize
      // the moment the first bead is added
      var BB2D_MAXCHAIN=(window.innerWidth<=860 ? 19*10+29 : 24*10+29);
      var phRatio=Math.min(1,phChain/BB2D_MAXCHAIN);
      ring.style.transformOrigin='50% 50%';
      ring.style.transform='scale('+phRatio+')';
      cropStageToRing(phRatio);
      var phGround=document.getElementById('bb2d-ground');
      if(phGround){ phGround.style.transform='translate(-50%,-50%) scale('+phRatio+')'; }
      for(var pk=0;pk<phN;pk++){
        var dEl=document.createElement('div'); dEl.className='bead-ph';
        var dDeg=(phStart+phGap*(pk+1)+phCum+phW/2)%360; phCum+=phW;
        pos(dEl,dDeg);
        dEl.style.width=(CIRC_PCT*10/phChain)+'%';
        ring.appendChild(dEl);
      }
      if(state.pix.img){
        var php=document.createElement('img'); php.className='orn'; php.src=state.pix.img; php.alt='';
        pos(php,180); php.style.width=(2*R*Math.sin((360*phPixLen/phChain)*Math.PI/360))+'%';
        ring.appendChild(php);
      }
      updateAtc(); histPush(); return;
    }
    var pixBlock = pixiuBlockMm();          // one dragon, or the facing pair + bridge
    // matches the solo piece's tightened layout slot above - draw-only
    if(state.pix.img && state.pixCount<2) pixBlock = state.pix.len*0.74;
    // Ornaments REPLACE beads, so the beads they cover must come out of the
    // chain length; otherwise adding a charm lengthens the strand and every
    // other bead slides round the ring.
    // ONE rule for every ornament (charm and pearl alike): capacityMm() already
    // reserves its width, which is what shortened state.seq. So the chain is
    // simply the beads that survived plus the ornaments, with NOTHING
    // subtracted here. Subtracting a bead as well charged for the piece twice
    // and shrank the whole bracelet - it hit pearls first, then charms.
    var chain = Math.max(1, seqWidthMm() + pixBlock + charmStrandMm() + sc*pearlMm());
    function mmToDeg(mmLen){ return 360*mmLen/chain; }
    function mmToPct(mmLen){ return CIRC_PCT*mmLen/chain; }
    function chordPct(deg){ return 2*R*Math.sin(deg*Math.PI/360); }
    var idx=0;
    var pixDeg = pixLen ? mmToDeg(pixLen) : 0;
    var blockDeg = pixBlock ? mmToDeg(pixBlock) : 0;   // whole front cluster

    // ONE contiguous free arc from the front cluster's left flank around to its
    // right: a single equal-gap layout, so spacing is identical everywhere.
    // With a pair, the cluster is dragon+bead+pearl+bead+dragon, so the free
    // arc starts outside BOTH dragons.
    var start = 180 + blockDeg/2, span = Math.max(0.001, 360 - blockDeg);

    var slots=[];
    var inserts=state.spacerPos.map(function(p,idx2){return {pos:Math.min(Math.max(0,p),n), spId:idx2};});
    if(state.charms.length){
      var cp=state.charms[0].pos;
      if(cp==null){
        // default: balance the actual strand WIDTH (beads + spacers) on each
        // side, so spacers don't push the charm visually off-centre
        var totW=0; for(var q0=0;q0<n;q0++) totW+=sizeOf(state.seq[q0]);
        totW+=state.spacerPos.length*pearlMm();
        var best=Math.ceil(n/2), bestD=1e9;
        for(var cand=0;cand<=n;cand++){
          var lw=0;
          for(var q1=0;q1<cand;q1++) lw+=sizeOf(state.seq[q1]);
          state.spacerPos.forEach(function(p){ if(Math.min(Math.max(0,p),n)<=cand) lw+=pearlMm(); });
          var d=Math.abs(lw-(totW-lw));
          // <= so a tie resolves to the LATER position: with an odd bead count
          // there is no exact middle, and the rule is that the charm goes to
          // the RIGHT of centre (13 beads -> index 7, not 6).
          if(d<=bestD){ bestD=d; best=cand; }
        }
        cp=best;
      }
      inserts.push({pos:Math.min(Math.max(0,cp),n), ch:true});
    }
    inserts.sort(function(a,b){return a.pos-b.pos;});
    // A charm or pearl REPLACES the bead at its position rather than being
    // inserted beside it, so adding one never pushes the other beads round the
    // ring: everything else stays exactly where it was. The replaced bead is
    // skipped here; state.seq is untouched, so removing the charm brings it
    // straight back.
    // A CHARM stands IN a bead's place: it takes that slot and the bead is not
    // drawn, so no other bead moves. capacityMm() has already shortened
    // state.seq by the charm's width, so the strand length is unchanged too -
    // that is what stops the piece being paid for twice.
    // A PEARL sits BETWEEN beads at its own position (its width is likewise
    // already reserved).
    // charmReserveMm() is what decides this, and the two must agree:
    //   'replace' charms RESERVE their width in capacityMm(), so state.seq is
    //      already one bead shorter. They are therefore drawn as an EXTRA
    //      piece among those beads: 15 beads + 1 charm fills the space 16
    //      beads did, so nothing is pushed and nothing is paid for twice.
    //   'push' charms (protection, zodiac ring) reserve NOTHING, because they
    //      are thin cylinders that thread BETWEEN two beads. Every bead stays.
    // A PEARL likewise reserves its width, so it too is drawn as an extra.
    // A 'replace' charm shortens state.seq by one, so every bead index after it
    // shifts down. A pearl stored at index 11 would then land one bead further
    // round the ring than where the customer put it. Pull the pearls that sit
    // AFTER the charm back by one so they stay physically put.
    var charmIdx=null;
    inserts.forEach(function(it){ if(it.ch) charmIdx=Math.min(Math.max(0,it.pos),n); });
    var charmShifts = (charmIdx!==null && charmKind()!=='push') ? 1 : 0;
    for(var k2=0;k2<=n;k2++){
      inserts.forEach(function(it){
        var at=Math.min(Math.max(0,it.pos),n);
        if(!it.ch && charmShifts && at>charmIdx) at=Math.max(0,at-charmShifts);
        if(at!==k2) return;
        if(it.ch) slots.push({ch:true,w:charmStrandMm()});
        else slots.push({sp:true,w:pearlMm(),spId:it.spId});
      });
      if(k2>=n) break;
      slots.push({sp:false,i:k2,w:sizeOf(state.seq[k2])});
    }

    var wsum=slots.reduce(function(a,sl){return a+sl.w;},0);
    var wsumDeg=mmToDeg(wsum);
    if(wsumDeg<=span){
      var gap=(span-wsumDeg)/(slots.length+1), cum=0;
      slots.forEach(function(sl,i){ sl.deg=(start+gap*(i+1)+mmToDeg(cum+sl.w/2))%360; cum+=sl.w; });
    } else {
      var scale=span/wsumDeg, cum2=0;
      slots.forEach(function(sl){ sl.deg=(start+mmToDeg(cum2+sl.w/2)*scale)%360; cum2+=sl.w; });
    }
    slots.forEach(function(sl){ sl.t=(sl.deg-start+360)%360; });
    renderWalk=slots; renderG={start:start};
    // Fixed square (sized in CSS to fill the column) with the bracelet centred:
    // the 24cm bracelet fills the square, smaller ones sit centred and smaller.
    // Reference chain the ring is scaled against. Desktop keeps the 24cm
    // reference so a big bracelet still reads as big. On a phone the stage is
    // the whole screen and almost every customer is 14-19cm, so scaling those
    // against 24cm wasted up to a third of the display and made the beads of a
    // LARGER wrist look smaller. Phones reference 19cm instead: 14-19cm fill
    // most or all of the stage, and 21/24cm simply cap at full rather than
    // being clipped.
    var BB2D_MAXCHAIN=(window.innerWidth<=860 ? 19*10+29 : 24*10+29);
    var bbScale=Math.min(1,chain/BB2D_MAXCHAIN);
    ring.style.transformOrigin='50% 50%';
    ring.style.transform='scale('+bbScale+')';
    cropStageToRing(bbScale);
    var bbGround=document.getElementById('bb2d-ground');
    if(bbGround){ bbGround.style.transform='translate(-50%,-50%) scale('+bbScale+')'; }

    slots.forEach(function(sl){
      if(sl.deg==null) return;
      if(sl.ch){
        var a0=state.charms[0];
        var c0=CHARMS.filter(function(x){return x.key===a0.key;})[0];
        var ci=document.createElement('img'); ci.className='orn draggable'; ci.src=c0.img; ci.alt=c0.name;
        pos(ci,sl.deg);
        ci.style.transform='translate(-50%,-50%) rotate('+(((sl.deg%360)+360)%360)+'deg)';
        (function(el,kind){
          // A charm must paint by EXACTLY the same rule as a bead of the same
          // mm - mmToPct(mm * sizeComp) - or it reads a different size on the
          // ring. sizeComp measures each photo's opaque box, so crops cancel
          // out; it is async on first sight of an image, so re-apply on load
          // and once more when the measurement lands, otherwise the charm keeps
          // whatever width the un-measured first paint gave it.
          var mm=attachedCharmMm();
          var mmH=(state.charms[0]&&state.charms[0].size)||10;
          function fit(){
            // tightComp, not sizeComp: beads draw tightened, so a 10mm charm
            // must use the SAME factor or it reads smaller than a 10mm bead
            // and leaves a gap either side (owner, 10 Aug)
            var comp=tightComp(el.src);
            if(kind==='push'){
              // thin cylinder: the PICKED size is its height, width follows the
              // photo's own proportions so it stays a cylinder, not a sphere.
              var w=el.naturalWidth,h=el.naturalHeight;
              el.style.width=(mmToPct(mmH*comp)*(w&&h? w/h : 1))+'%';
            } else {
              el.style.width=mmToPct(mm*comp)+'%';
            }
          }
          fit();
          if(!el.complete) el.addEventListener('load',fit);
          // sizeComp resolves asynchronously the first time a photo is seen;
          // re-fit shortly after so the charm settles at the measured size.
          setTimeout(fit,120); setTimeout(fit,600);
        })(ci,charmKind());
        hookDrag(ci,{img:c0.img,any:true,fromRing:true,
          drop:function(x,y){
            var r=stageRect(0);
            var d=Math.hypot(x-r.cx,y-r.cy)/r.half;
            if(d>1.25) state.charms=[];
            else state.charms[0].pos=insertionFromPoint(x,y);
          },
          tap:function(){ openCharmChooser(ci); }});
        ring.appendChild(ci);
        return;
      }
      var img=document.createElement('img'); img.className='bead';
      if(sl.sp){
        // 'bead' keeps the shared styling and assemble animation, but a pearl
        // is NOT a bead: tag it so counting and measuring can tell them apart
        // (same reason the pair's centre piece carries data-centre).
        img.setAttribute('data-pearl','1');
        img.src=currentPearl().img; img.alt='pearl of wisdom';
        // gold pearl PNG has transparent padding; draw it a touch larger so it
        // reads as its true 9mm (physics still reserves SPACER_MM exactly)
        // draw so the PEARL reads 9mm, whichever photo's framing it comes from
        pos(img,sl.deg); img.style.width=mmToPct(pearlMm()*tightComp(currentPearl().img))+'%';
        img.style.cursor='grab'; img.style.touchAction='none';
        (function(spId,el){
          hookDrag(el,{img:el.src,any:true,fromRing:true,
            drop:function(x,y){
              var r=stageRect(0);
              var d=Math.hypot(x-r.cx,y-r.cy)/r.half;
              if(d>1.25) state.spacerPos.splice(spId,1);
              else state.spacerPos[spId]=insertionFromPoint(x,y);
            },
            tap:function(){ openPearlChooser(el); }});
        })(sl.spId,img);
        ring.appendChild(img);
        if(animate&&!reduce){ animateIn(img,idx); } else img.classList.add('in');
        idx++; return;
      }
      img.src=crystalById(state.seq[sl.i]).img; img.alt='';
      pos(img,sl.deg); img.style.width=mmToPct(sizeOf(state.seq[sl.i])*tightComp(crystalById(state.seq[sl.i]).img))+'%';
      ring.appendChild(img);
      beadEls.push({el:img,idx:sl.i});
      (function(bi,el){
        hookDrag(el,{img:el.src,fromRing:true,
          drop:function(x,y){
            if(overCentre(x,y)){ state.pairCentre=state.seq[bi]; return; }
            var bs=bridgeAt(x,y);
            if(bs){ setBridge(bs,state.seq[bi]); return; }
            var t=beadAt(x,y);
            if(t!=null&&t!==bi){ var a=state.seq[bi]; state.seq[bi]=state.seq[t]; state.seq[t]=a; syncCountsFromSeq(); } },
          tap:function(){ openBeadMenu(bi,el); }});
      })(sl.i,img);
      if(animate&&!reduce){ animateIn(img,idx); } else img.classList.add('in');
      idx++;
    });

    if(state.pix.img){
      var pairMode=state.pixCount>1;
      // Front cluster walking clockwise from the cluster's left edge:
      //   pair : dragon | bead | pearl | bead | dragon
      //   solo : dragon
      // Each piece is placed at the midpoint of its own mm span.
      var pieces;
      if(!pairMode){
        // draw-only (owner, 10 Aug): the solo dragon's LAYOUT slot is 0.62 of
        // its length so the beads sit against it (same as the register
        // preview); dw keeps the DRAWN size exactly as before, and
        // capacityMm() still reserves the real width so counts are untouched
        pieces=[{k:'pix',w:state.pix.len*0.74,dw:state.pix.len,flip:false}];
      } else {
        // reserve the narrower width so the beads sit tight against the pair
        var pixW=state.pix.side?state.pix.len*SIDE_LAYOUT_W:state.pix.len;
        if(state.pairCentre){
          // dragon | bead | CENTRE | bead | dragon. The centre holds a pearl
          // by default, or a crystal the customer dragged in.
          // the cluster walks from screen RIGHT to screen LEFT (clusterStart is
          // below 180deg), so the FIRST bead drawn is the right-hand one
          pieces=[{k:'pix',w:pixW,flip:false},{k:'bead',side:'R',w:bridgeMm('R')},
                  {k:'centre',w:pairCentreMm()},
                  {k:'bead',side:'L',w:bridgeMm('L')},{k:'pix',w:pixW,flip:true}];
        } else {
          // centre emptied: a single bead bridges the two dragons
          pieces=[{k:'pix',w:pixW,flip:false},{k:'bead',side:'L',w:bridgeMm('L')},
                  {k:'pix',w:pixW,flip:true}];
        }
      }
      var cursor=0, clusterStart=180-blockDeg/2;
      pieces.forEach(function(pc){
        var midDeg=clusterStart+mmToDeg(cursor+pc.w/2);
        cursor+=pc.w;
        if(pc.k==='pix'){
          var pi=document.createElement('img'); pi.className='orn';
          // A PAIR uses the side profile so the two dragons read as facing each
          // other; a single pixiu keeps the original top-down photo untouched.
          // Side profiles are DISABLED: repeated attempts to rotate the flat
          // profile onto the ring's curve all looked wrong (upright, tipped, or
          // mirrored oddly). The top-down photo already reads correctly at any
          // position, so the pair uses it until the side art can be redrawn
          // pre-rotated. Set to `pairMode&&state.pix.side` to re-enable.
          var useSide=pairMode&&state.pix.side;
          pi.src=useSide?state.pix.side:state.pix.img; pi.alt='';
          // draw-only tweak: PIX_DISPLAY never touches len, so bead-count physics
          // and the strand length stay exactly as measured from the real dragon
          // A dragon's mm is measured along its curved body as it wraps the
          // wrist; the side photo is a flat profile, so drawing the full mm as
          // flat width made it 2.5x a bead when the real piece reads ~1.5x and
          // sits inside the strand. SIDE_FORESHORTEN corrects that. Display
          // only: len is untouched, so bead counts and strand length stand.
          pos(pi,midDeg);
          pi.style.width=(chordPct(mmToDeg(pc.dw||pc.w))*(PIX_DISPLAY[state.pix.v]||1)*(useSide?SIDE_FORESHORTEN_W:1))+'%';
          // Side profiles follow the ring's curve. pos() places a piece at
          // screen angle (deg - 90), so the tangent there is (deg - 90) + 90 =
          // deg: rotating by exactly deg lays the dragon's long body ALONG the
          // arc, leaning with the circle like a bead. The second mirrors so the
          // pair face each other.
          // Tangent to the ring at this dragon's spot is (deg + 90) in screen
          // terms, which lays the horizontal side profile along the curve. The
          // second dragon flips on Y (not X): after rotation its local x axis
          // runs along the strand, so scaleY mirrors it nose-to-nose with the
          // first instead of turning it upside down.
          // Side profile follows the ring's curve. The photo is a horizontal
          // profile, so rotate it by the piece's SCREEN angle (ring deg - 90),
          // which is the tangent direction: the dragon then leans with the arc
          // at ANY wrist size (the curve differs per bracelet, so this has to be
          // computed rather than baked into the artwork). Second mirrors on X so
          // the pair meet nose to nose. Verified locally against six options.
          var screenDeg=(((midDeg-90)%360)+360)%360;
          // +180 keeps the dragon upright once the tangent rotation carries it
          // onto the lower half of the ring (without it both dragons render
          // upside down), and the second mirrors on Y so the pair meet nose to
          // nose with their feet toward the strand. Verified locally across six
          // rotation/mirror combinations before shipping.
          // Rotation = the chord from the dragon's OUTER end (up the arc) to its
          // INNER end (nearer the bracelet's centre-bottom). A span centred on
          // the piece is circular -- it returns the piece's own ring position --
          // which is why earlier attempts stood the dragons on end. This adapts
          // to wrist size and to 1 vs 3 bridge beads on its own.
          // The mirror goes on the NON-flipped dragon: with the mirror on the
          // flipped one the left dragon faced away from the pair. Verified in a
          // local copy of this builder before shipping.
          var sp=mmToDeg(pc.w);
          var ie=ringPoint(pc.flip?(midDeg-sp/2):(midDeg+sp/2));
          var oe=ringPoint(pc.flip?(midDeg+sp/2):(midDeg-sp/2));
          var pairAng=Math.atan2(ie.y-oe.y, ie.x-oe.x)*180/Math.PI+180;
          // Each dragon needs a DIFFERENT correction, which is why no single
          // mirror worked: the left one (pc.flip false) needs scaleX and scaleY,
          // the right one (pc.flip true) needs scaleX alone. Established by
          // testing variants in a local copy of this builder: flipY fixed the
          // left, swapmirror fixed the right, so the two are combined per side.
          // +180 on the chord angle: without it both dragons render on their
          // heads. Confirmed by comparing variants in a local copy of this
          // builder (rot180 was the one that read correctly).
          var pairMir = pc.flip ? ' scaleX(-1)' : ' scaleX(-1) scaleY(-1)';
          if(useSide) pi.style.transform='translate(-50%,-50%) rotate('+(pairAng+180).toFixed(1)+'deg)'+pairMir;
          else if(pc.flip) pi.style.transform='translate(-50%,-50%) scaleX(-1)';
          pi.style.cursor='pointer'; pi.style.pointerEvents='auto'; pi.style.touchAction='none';
          hookDrag(pi,{img:state.pix.img,fromRing:true,drop:function(){},tap:function(){ openPixiuMenu(pi); }});
          ring.appendChild(pi);
        } else if(pc.k==='centre'){
          // The pair's centre piece: a pearl by default, or any crystal the
          // customer drags in. Tapping it opens a chooser (swap or remove)
          // rather than silently deleting it.
          var isPearl=state.pairCentre==='pearl';
          var cObj=isPearl?null:crystalById(state.pairCentre);
          // 'bead' keeps the shared styling/animation; data-centre marks it as
          // the pair's centre piece so bead counts do not include it.
          var ce=document.createElement('img'); ce.className='bead in';
          ce.setAttribute('data-centre','1');
          ce.src=isPearl?currentPearl().img:(cObj?cObj.img:currentPearl().img);
          ce.alt=isPearl?'pearl of wisdom':(cObj?cObj.name:'');
          pos(ce,midDeg);
          ce.style.width=mmToPct(pairCentreMm()*tightComp(ce.src))+'%';
          ce.style.cursor='pointer'; ce.style.pointerEvents='auto'; ce.style.touchAction='none';
          ce.title='Tap to change or remove';
          centreEl=ce;
          hookDrag(ce,{img:ce.src,
            drop:function(x,y){
              // dragging the centre piece off the ring removes it
              var r=stageRect(0);
              if(Math.hypot(x-r.cx,y-r.cy)/r.half>1.25){ state.pairCentre=null; }
            },
            tap:function(){ openCentreMenu(ce); }});
          ring.appendChild(ce);
        } else {
          var brId=bridgeId(pc.side);
          if(!brId) return;
          var bi=document.createElement('img'); bi.className='bead in';
          var bc=crystalById(brId);
          bi.src=bc.img; bi.alt=bc.name;
          pos(bi,midDeg); bi.style.width=mmToPct(pc.w*tightComp(bc.img))+'%';
          // the bridge beads are the customer's to change, exactly like the
          // centre: tap for a chooser, or drop another crystal onto them
          bi.style.cursor='pointer'; bi.style.pointerEvents='auto'; bi.style.touchAction='none';
          bi.title='Tap to change';
          bridgeEls.push({el:bi,side:pc.side});
          (function(side,el){
            hookDrag(el,{img:el.src,drop:function(){},
              tap:function(){ openBridgeMenu(side,el); }});
          })(pc.side,bi);
          ring.appendChild(bi);
        }
      });
    }

    var pixTxt=state.pix.img?' · '+state.pix.label+' PIXIU'+(state.pixCount>1?' PAIR':''):'';
    var chTxt='';
    if(state.charms.length){
      var ac=CHARMS.filter(function(x){return x.key===state.charms[0].key;})[0];
      chTxt=' · '+(ac?ac.name:'CHARM')+(state.charms[0].zodiac?' · '+state.charms[0].zodiac.toUpperCase():'');
    }
    var centreTxt='';
    if(hasPair()&&state.pairCentre&&state.pairCentre!=='pearl'){
      var cc=crystalById(state.pairCentre);
      if(cc) centreTxt=' · '+cc.name+' CENTRE';
    }
    var pearlN=sc+pairPearlCount();
    var spTxt=pearlN>0?' · '+pearlN+' '+currentPearl().name.toUpperCase()+' PEARL'+(pearlN>1?'S':''):'';
    var mids=activeIds();
    var mix=mids.length>3? mids.length+' CRYSTAL MIX' :
      mids.map(function(id){return crystalById(id).name+' '+sizeOf(id)+'MM'+(mids.length>1?' ×'+state.counts[id]:'');}).join(' + ');
    // The pair's bridge beads are drawn as part of the front cluster, not in
    // state.seq, so they must be added or the spec undercounts what is on the
    // ring (14 stated vs 15 drawn). One bead each side of the centre.
    // Count the beads ACTUALLY DRAWN rather than re-deriving the number from
    // state. Every previous attempt to compute it drifted from the picture as
    // soon as another rule landed (pair bridge beads, ornaments replacing a
    // bead, an empty centre). renderWalk holds the strand slots this render
    // just laid out, and the pair's bridge beads are drawn from `pieces`, so
    // add those explicitly. Single source of truth: what is on the ring.
    var strandBeads = renderWalk ? renderWalk.filter(function(sl){ return sl.sp===false; }).length : 0;
    // pair bridge: dragon | bead | [centre] | bead | dragon -> always 2 beads
    // when a centre piece sits between them, 1 when the centre is empty
    var bridgeBeads = (hasPair() && activeIds().length) ? (state.pairCentre?2:1) : 0;
    var shownBeads = strandBeads + bridgeBeads;
    BEADS_ON_RING = shownBeads;   // the cart reads this, so both always agree
    $id('spec').textContent=isEmpty ? '' : mix+' · '+shownBeads+' BEADS'+pixTxt+centreTxt+chTxt+spTxt;
    updateAtc(); histPush();
    // Design changed: store it in the background so Add to Cart is quick.
    if(!isEmpty) armPreupload();
  }

  // ── drag & drop on plain mouse + touch events (no PointerEvent dependency) ──
  var drag=null, ringDrag=null;
  var BEADS_ON_RING=0;   // beads the last render actually drew (spec + cart truth)
  function stageRect(pad){
    var r=stage.getBoundingClientRect(); pad=pad||0;
    return {left:r.left-pad,right:r.right+pad,top:r.top-pad,bottom:r.bottom+pad,
            cx:r.left+r.width/2,cy:r.top+r.height/2,half:r.width/2};
  }
  function inRect(x,y,r){return x>=r.left&&x<=r.right&&y>=r.top&&y<=r.bottom;}
  function angleAt(x,y){var r=stageRect(0);var deg=Math.atan2(y-r.cy,x-r.cx)*180/Math.PI+90;return (deg+360)%360;}
  function pt(e){ return e.touches&&e.touches.length?e.touches[0]:(e.changedTouches&&e.changedTouches.length?e.changedTouches[0]:e); }

  function startDrag(e,payload){
    var p=pt(e);
    // pending only: the ghost + drop circle appear once the pointer actually moves
    drag={payload:payload,ghost:null,moved:false,x0:p.clientX,y0:p.clientY};
  }
  // On a phone the option rows sit well below the bracelet, so dragging a card
  // up onto the ring means a long, awkward drag that usually fails. Touch
  // devices therefore do NOT start a drag from the option cards: a tap adds
  // the piece instead (the tap handler each card already carries). Dragging
  // pieces that are ALREADY on the ring still works everywhere, since that is
  // a short drag - see hookDrag calls on ring elements, which pass fromRing.
  var COARSE = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
  function hookDrag(card,payload){
    card.addEventListener('mousedown',function(e){ if(e.button!==0)return; startDrag(e,payload); });
    card.addEventListener('touchstart',function(e){
      if(COARSE && !payload.fromRing){
        // No drag from the option rows on touch. payload.tap() normally fires
        // from endDrag, which never runs if no drag started, so call it here
        // ourselves once the finger lifts without moving.
        var t0=pt(e), x0=t0.clientX, y0=t0.clientY, moved=false;
        var onMove=function(ev){ var q=pt(ev);
          if(Math.hypot(q.clientX-x0,q.clientY-y0)>10) moved=true; };
        var onEnd=function(ev){
          card.removeEventListener('touchmove',onMove);
          card.removeEventListener('touchend',onEnd);
          card.removeEventListener('touchcancel',onEnd);
          if(!moved && payload.tap){
            // stop the browser's synthetic click, which would otherwise reach
            // the label/name handlers and open an info popup as well
            if(ev&&ev.cancelable) ev.preventDefault();
            var swallow=function(ce){ ce.stopPropagation(); ce.preventDefault(); };
            card.addEventListener('click',swallow,true);
            setTimeout(function(){ card.removeEventListener('click',swallow,true); }, 400);
            payload.tap(); render(false); syncControls();
          }
        };
        card.addEventListener('touchmove',onMove,{passive:true});
        card.addEventListener('touchend',onEnd);
        card.addEventListener('touchcancel',onEnd);
        return;   // no preventDefault: the page must still scroll
      }
      e.preventDefault(); startDrag(e,payload);
    },{passive:false});
  }
  // Two or three sentences per guardian, shown once a sign is picked. Written
  // from the traditional descriptions of each figure's domain and iconography.
  // Editable here; no metafield needed since these never change per product.
  var GUARDIAN_INFO={
    guanyin:'Guanyin is the bodhisattva of compassion, said to hear every cry in the world and to turn towards it. She is called on for mercy, for protection, and for the steadying of a household.',
    akasagarbha:'Akasagarbha takes his name from open space, and his wisdom and merit are described as boundless in the same way. He is turned to for clarity of mind and for a memory that holds what matters.',
    manjushri:'Manjushri is the bodhisattva of wisdom, the one who cuts through confusion to see a thing as it actually is. He is called on for clear thinking and for the confidence to say what is true.',
    samantabhadra:'Samantabhadra stands for practice: the patient carrying out of what wisdom sees. Known for his ten great vows, he is called on for follow through, for finishing what has been begun.',
    mahasthamaprapta:'Mahasthamaprapta means the arrival of great strength, and the strength meant is that of wisdom itself. He is said to light the way ahead so that a path can be walked without stumbling.',
    vairocana:'Vairocana is the cosmic buddha whose name means the sun, and whose light is said to reach everywhere without exception. He represents reality as it is, steady underneath everything that changes.',
    acala:'Acala is the immovable one, a fierce protector rather than a gentle one. He is called on to break through obstacles and to hold firm when something needs to be endured.',
    amitabha:'Amitabha is the buddha of infinite light and infinite life. He vowed that anyone who called on him sincerely would be received, and he is turned to for compassion without condition.'
  };

  var zodiacOverlay=$id('zodiacOverlay');
  var zodiacPendingKey=null;
  function openZodiac(charmKey){
    zodiacPendingKey=charmKey;
    var grid=$id('zodiacGrid'); grid.innerHTML='';
    ZODIAC.forEach(function(z){
      var g=GUARDIANS[z[1]]||['',''];
      var b=document.createElement('button'); b.type='button'; b.className='zo-item';
      b.innerHTML='<span class="zn">'+z[0].toUpperCase()+'</span><span class="zg">'+g[0]+'</span><span class="zh2">'+g[1]+'</span>';
      b.addEventListener('click',function(){ showGuardian(z,g); });
      grid.appendChild(b);
    });
    var det=$id('zodiacDetail'); if(det) det.hidden=true;
    grid.hidden=false;
    var head=zodiacOverlay.querySelector('h2, .sub');
    zodiacOverlay.classList.remove('is-detail');
    zodiacOverlay.classList.add('open');
  }
  // Step two: the chosen sign's guardian, a few sentences, then confirm or back.
  function showGuardian(z,g){
    var det=$id('zodiacDetail'); var grid=$id('zodiacGrid');
    if(!det){   // no detail markup: keep the old one-tap behaviour
      // carry the size picked on the card (ring and cube come in 8 and 10mm);
      // without this the choice was silently dropped by the sign picker
      state.charms=[{key:zodiacPendingKey,angle:0,zodiac:z[0],guardian:g[0],
        size:(CHARM_SIZE_OPTIONS[zodiacPendingKey]? (charmSizePref[zodiacPendingKey]||10) : undefined)}];
      zodiacOverlay.classList.remove('open'); zodiacPendingKey=null;
      render(false); syncControls(); return;
    }
    var key=null;
    Object.keys(GUARDIANS).forEach(function(k){ if(GUARDIANS[k]&&GUARDIANS[k][0]===g[0]) key=k; });
    $id('zdSign').textContent=String(z[0]).toUpperCase();
    $id('zdName').textContent=g[0]||'';
    $id('zdChar').textContent=g[1]||'';
    $id('zdText').textContent=(key&&GUARDIAN_INFO[key])||'';
    det.hidden=false; grid.hidden=true;
    zodiacOverlay.classList.add('is-detail');
    var conf=$id('zdConfirm'), back=$id('zdBack');
    conf.onclick=function(){
      // carry the size picked on the card (ring and cube come in 8 and 10mm);
      // without this the choice was silently dropped by the sign picker
      state.charms=[{key:zodiacPendingKey,angle:0,zodiac:z[0],guardian:g[0],
        size:(CHARM_SIZE_OPTIONS[zodiacPendingKey]? (charmSizePref[zodiacPendingKey]||10) : undefined)}];
      zodiacOverlay.classList.remove('open','is-detail'); zodiacPendingKey=null;
      det.hidden=true; grid.hidden=false;
      render(false); syncControls();
    };
    back.onclick=function(){
      det.hidden=true; grid.hidden=false;
      zodiacOverlay.classList.remove('is-detail');
    };
  }
  $id('zodiacClose').addEventListener('click',function(){ zodiacOverlay.classList.remove('open'); zodiacPendingKey=null; });
  zodiacOverlay.addEventListener('click',function(e){ if(e.target===zodiacOverlay){ zodiacOverlay.classList.remove('open'); zodiacPendingKey=null; } });

  // wrist size guide (same helper as the register listings)
  var sizeGuideOverlay=$id('sizeGuideOverlay');
  if(sizeGuideOverlay){
    var sizeHelp=$id('sizeHelp');
    if(sizeHelp) sizeHelp.addEventListener('click',function(e){ e.preventDefault(); sizeGuideOverlay.classList.add('open'); });
    $id('sizeGuideClose').addEventListener('click',function(){ sizeGuideOverlay.classList.remove('open'); });
    sizeGuideOverlay.addEventListener('click',function(e){ if(e.target===sizeGuideOverlay) sizeGuideOverlay.classList.remove('open'); });
  }

  var charmSizeOverlay=$id('charmSizeOverlay');
  $id('charmSizeClose').addEventListener('click',function(){ charmSizeOverlay.classList.remove('open'); });
  charmSizeOverlay.addEventListener('click',function(e){ if(e.target===charmSizeOverlay) charmSizeOverlay.classList.remove('open'); });
  function openCharmSize(c,options){
    var grid=$id('charmSizeGrid'); grid.innerHTML='';
    options.forEach(function(mm){
      var b=document.createElement('button'); b.type='button'; b.className='zo-item';
      b.innerHTML='<span class="zn">'+mm+' MM</span>';
      b.addEventListener('click',function(){
        state.charms=[{key:c.key,angle:0,size:mm}];
        charmSizeOverlay.classList.remove('open');
        render(false); syncControls();
      });
      grid.appendChild(b);
    });
    charmSizeOverlay.classList.add('open');
  }
  function attachCharm(c){
    if(c.key.indexOf('zodiac')===0){ openZodiac(c.key); return; }
    // charms with a size row on the card attach at the picked size, no popup
    if(CHARM_SIZE_OPTIONS[c.key]){ state.charms=[{key:c.key,angle:0,size:charmSizePref[c.key]||10}]; return; }
    if(c.charmSizes){
      if(c.charmSizes.length===1){ state.charms=[{key:c.key,angle:0,size:c.charmSizes[0]}]; return; }
      var ds=[]; activeIds().forEach(function(id){ var m=sizeOf(id); if(ds.indexOf(m)<0) ds.push(m); });
      var opts=ds.filter(function(m){return c.charmSizes.indexOf(m)>=0;});
      if(!opts.length) opts=c.charmSizes.slice();
      if(opts.length===1){ state.charms=[{key:c.key,angle:0,size:opts[0]}]; return; }
      openCharmSize(c,opts.sort(function(a,b){return a-b;}));
      return;
    }
    state.charms=[{key:c.key,angle:0}];
  }
  function hookDragSource(card,c){          // charm cards
    hookDrag(card,{img:c.img,
      drop:function(){ attachCharm(c); },
      tap:function(){ var ex=state.charms.filter(function(q){return q.key===c.key;})[0];
                      if(ex) state.charms=[]; else attachCharm(c); }});
  }
  function moveDrag(e){
    if(drag){
      var p=pt(e);
      if(!drag.moved && Math.hypot(p.clientX-drag.x0,p.clientY-drag.y0)>6){
        drag.moved=true;
        drag.ghost=document.createElement('img'); drag.ghost.className='bb2d-ghost'; drag.ghost.src=drag.payload.img;
        document.body.appendChild(drag.ghost);
        stage.classList.add('droptarget');
      }
      if(drag.ghost){ drag.ghost.style.left=p.clientX+'px'; drag.ghost.style.top=p.clientY+'px'; }
      if(e.cancelable) e.preventDefault();
    }
    if(ringDrag){
      var p2=pt(e), r=stageRect(0);
      var deg=angleAt(p2.clientX,p2.clientY);
      var clamped=deg>180?Math.max(deg,285):Math.min(deg,75);
      pos(ringDrag.el,clamped);
      var d=Math.hypot(p2.clientX-r.cx,p2.clientY-r.cy)/r.half;
      ringDrag.el.style.opacity=d>1.25?0.35:1;
      if(e.cancelable) e.preventDefault();
    }
  }
  function endDrag(e){
    var p=pt(e);
    if(drag){
      var payload=drag.payload, moved=drag.moved;
      if(drag.ghost) drag.ghost.remove();
      stage.classList.remove('droptarget'); drag=null;
      if(moved && (payload.any || inRect(p.clientX,p.clientY,stageRect(70)))) payload.drop(p.clientX,p.clientY);
      else if(!moved) payload.tap();
      render(false); syncControls();
    }
    if(ringDrag){
      var r=stageRect(0);
      var d=Math.hypot(p.clientX-r.cx,p.clientY-r.cy)/r.half;
      if(d>1.25) state.charms=state.charms.filter(function(q){return q!==ringDrag.ch;});
      ringDrag=null;
      render(false); syncControls();
    }
  }
  document.addEventListener('mousemove',moveDrag);
  document.addEventListener('mouseup',endDrag);
  document.addEventListener('touchmove',moveDrag,{passive:false});
  document.addEventListener('touchend',endDrag);
  document.addEventListener('touchcancel',endDrag);

  // ── parallel channel: native HTML5 drag & drop (independent of our JS tracking) ──
  function hookNativeDnD(card,payload){
    card.setAttribute('draggable','true');
    card.addEventListener('dragstart',function(e){
      try{ e.dataTransfer.setData('text/plain','x'); e.dataTransfer.effectAllowed='copy'; }catch(_){}
      if(drag){ if(drag.ghost) drag.ghost.remove(); drag=null; }   // native channel wins
      window._bb2dNativePayload=payload;
      stage.classList.add('droptarget');
    });
    card.addEventListener('dragend',function(){ stage.classList.remove('droptarget'); });
  }
  stage.addEventListener('dragover',function(e){ e.preventDefault(); try{e.dataTransfer.dropEffect='copy';}catch(_){}} );
  stage.addEventListener('drop',function(e){
    e.preventDefault(); stage.classList.remove('droptarget');
    var payload=window._bb2dNativePayload; window._bb2dNativePayload=null;
    if(payload){ payload.drop(e.clientX,e.clientY); render(false); syncControls(); }
  });
  // wire native DnD onto every card each time the rows are (re)built
  function wireNativeDnD(){
    var ids=activeIds();
    $id('crystalCells').querySelectorAll('.cell.slotcell').forEach(function(cell,i){
      var c=crystalById(ids[i]); if(!c) return;
      hookNativeDnD(cell,{img:c.img,drop:function(x,y){ var t=beadAt(x,y);
        if(t!=null){ state.seq[t]=c.id; syncCountsFromSeq(); }
        else changeCount(c.id,1); },tap:function(){}});
    });
    var j=0;
    rootEl.querySelectorAll('.charm-card').forEach(function(card){
      var c=CHARMS[j++]; if(!c) return;
      hookNativeDnD(card,{img:c.img,drop:function(){ attachCharm(c); },tap:function(){}});
    });
  }

  // ── arrange for me: cycles the 3D builder's patterns (no random), counts kept ──
  var ARRANGEMENTS=['even','mirrored','grouped-2','grouped-3','grouped-4'];
  var ARR_LABELS={even:'EVEN SPACING',mirrored:'MIRRORED','grouped-2':'GROUPED ×2','grouped-3':'GROUPED ×3','grouped-4':'GROUPED ×4'};
  var arrIdx=-1;
  function typeRoundRobinEven(N){  // the bresenham even distribution (rebuildSeq's layout)
    var ids=activeIds(), placed={}; ids.forEach(function(id){placed[id]=0;});
    var out=[];
    for(var i=0;i<N;i++){
      var best=ids[0],bs=-1e9;
      ids.forEach(function(id){ var sc2=state.counts[id]*(i+1)/N - placed[id]; if(sc2>bs+1e-9){bs=sc2;best=id;} });
      placed[best]++; out.push(best);
    }
    return out;
  }
  // Grouped-by-N arrangement. The ring is a CLOSED LOOP, so this has to be
  // careful in three ways the naive version was not:
  //   1. split each crystal into near-equal groups (ceil(count/size)) so
  //      leftovers become slightly smaller groups, never one long tail;
  //   2. interleave groups so the same crystal is never adjacent;
  //   3. pick the rotation with the shortest longest-run, and split further
  //      if the seam still forces a run over target.
  function typeGroupByN(N,size){
    var ids=activeIds();
    function build(extra){
      var groups=[];
      ids.forEach(function(id){
        var c=state.counts[id]; if(!c) return;
        var k=Math.min(c, Math.ceil(c/size)+(extra[id]||0));
        var base=Math.floor(c/k), rem=c%k;
        for(var i=0;i<k;i++) groups.push({id:id,n:base+(i<rem?1:0)});
      });
      return groups;
    }
    function arrange(groups){
      var byId={};
      groups.forEach(function(g){ (byId[g.id]=byId[g.id]||[]).push(g); });
      var ordered=[], prev=null;
      while(Object.keys(byId).some(function(id){return byId[id].length;})){
        var avail=Object.keys(byId).filter(function(id){return byId[id].length;});
        var cand=avail.filter(function(id){return id!==prev;});
        var pool=cand.length?cand:avail;
        pool.sort(function(a,b){return byId[b].length-byId[a].length;});
        ordered.push(byId[pool[0]].shift()); prev=pool[0];
      }
      var best=ordered, bestMax=Infinity;
      for(var r=0;r<ordered.length;r++){
        var rot=ordered.slice(r).concat(ordered.slice(0,r));
        var merged=[];
        rot.forEach(function(g){
          var l=merged[merged.length-1];
          if(l&&l.id===g.id) l.n+=g.n; else merged.push({id:g.id,n:g.n});
        });
        if(merged.length>1&&merged[0].id===merged[merged.length-1].id) merged[0].n+=merged.pop().n;
        var mx=Math.max.apply(null,merged.map(function(m){return m.n;}));
        if(mx<bestMax){ bestMax=mx; best=rot; }
      }
      return {ordered:best,max:bestMax};
    }
    var extra={}; ids.forEach(function(id){ extra[id]=0; });
    var bestResult=null;
    for(var round=0;round<=3;round++){
      var res=arrange(build(extra));
      if(!bestResult||res.max<bestResult.max) bestResult=res;
      if(res.max<=size) break;
      var biggest=ids.slice().sort(function(a,b){return state.counts[b]-state.counts[a];})[0];
      extra[biggest]=(extra[biggest]||0)+1;
    }
    var out=[];
    bestResult.ordered.forEach(function(g){
      for(var i=0;i<g.n&&out.length<N;i++) out.push(g.id);
    });
    return out;
  }
  // Mirrored: reflect across the ring's vertical axis. Beads are placed in
  // MIRRORED PAIRS working outward, with odd leftovers filling the centre, so
  // the arrangement can never gain or lose a bead (the spec line and the cart
  // must always match the ring). Mixes with several odd counts cannot be
  // perfectly symmetric; those odd beads sit together at the axis.
  function typeMirrored(N){
    var ids=activeIds();
    var out=new Array(N), rem={};
    ids.forEach(function(id){ rem[id]=state.counts[id]; });
    var order=ids.slice().sort(function(a,b){ return state.counts[b]-state.counts[a]; });
    var l=0, r=N-1;
    order.forEach(function(id){
      while(rem[id]>=2 && l<r){ out[l++]=id; out[r--]=id; rem[id]-=2; }
    });
    var mid=[];
    order.forEach(function(id){ while(rem[id]>0){ mid.push(id); rem[id]--; } });
    var m=0;
    for(var i=l;i<=r;i++) out[i]=mid[m++];
    for(var j=0;j<N;j++) if(!out[j]) out[j]=order[0];
    return out;
  }

  $id('arrangeBtn').addEventListener('click',function(){
    if(!activeIds().length) return;
    arrIdx=(arrIdx+1)%ARRANGEMENTS.length;
    var pat=ARRANGEMENTS[arrIdx], N=state.seq.length;
    if(pat==='even') state.seq=typeRoundRobinEven(N);
    else if(pat==='mirrored') state.seq=typeMirrored(N);
    else state.seq=typeGroupByN(N,parseInt(pat.split('-')[1],10));
    $id('arrLabel').textContent=ARR_LABELS[pat];
    render(false); syncControls();
  });

  // ── bead chooser: tap a bead, pick which chosen crystal it becomes ──
  var beadMenu=null;
  function closeBeadMenu(){ if(beadMenu){ beadMenu.remove(); beadMenu=null; } }
  document.addEventListener('mousedown',function(e){ if(beadMenu&&!beadMenu.contains(e.target)) closeBeadMenu(); },true);
  document.addEventListener('touchstart',function(e){ if(beadMenu&&!beadMenu.contains(e.target)) closeBeadMenu(); },true);
  function openBeadMenu(bi,el){
    closeBeadMenu();
    var mix=activeIds(); if(mix.length<2) return;
    beadMenu=document.createElement('div'); beadMenu.className='bb2d-bead-menu';
    mix.forEach(function(id){
      var c=crystalById(id);
      var b=document.createElement('button'); b.type='button';
      b.className=(state.seq[bi]===id?'cur':'');
      b.innerHTML='<img src="'+c.img+'" alt="'+c.name+'">';
      b.title=c.name;
      b.addEventListener('click',function(){
        state.seq[bi]=id; syncCountsFromSeq();
        closeBeadMenu(); render(false); syncControls();
      });
      beadMenu.appendChild(b);
    });
    document.body.appendChild(beadMenu);
    var r=el.getBoundingClientRect(), mw=beadMenu.offsetWidth, mh=beadMenu.offsetHeight;
    var left=Math.max(8,Math.min(window.innerWidth-mw-8, r.left+r.width/2-mw/2));
    var top=r.top-mh-10; if(top<8) top=r.bottom+10;
    beadMenu.style.left=left+'px'; beadMenu.style.top=top+'px';
  }

  // ── charm chooser: tap the charm ON THE RING to swap or remove it ──
  // Shows every charm plus NONE, so the ring itself is a way in rather than
  // only the strip below.
  function openCharmChooser(el){
    closeBeadMenu();
    beadMenu=document.createElement('div'); beadMenu.className='bb2d-bead-menu bb2d-menu-wrap';
    CHARMS.forEach(function(c){
      var b=document.createElement('button'); b.type='button';
      b.className=(state.charms.length&&state.charms[0].key===c.key?'cur':'');
      b.innerHTML='<img src="'+c.img+'" alt="'+c.rawName+'">';
      b.title=c.rawName;
      b.addEventListener('click',function(){
        closeBeadMenu(); attachCharm(c); render(false); syncControls();
      });
      beadMenu.appendChild(b);
    });
    var none=document.createElement('button'); none.type='button';
    none.className='bb2d-centre-remove'; none.textContent='NONE';
    none.addEventListener('click',function(){
      state.charms=[]; closeBeadMenu(); render(false); syncControls();
    });
    beadMenu.appendChild(none);
    placeMenu(el);
  }

  // ── pearl chooser: tap a pearl ON THE RING ──
  function openPearlChooser(el){
    closeBeadMenu();
    beadMenu=document.createElement('div'); beadMenu.className='bb2d-bead-menu bb2d-menu-wrap';
    PEARLS.forEach(function(pl){
      var b=document.createElement('button'); b.type='button';
      b.className=(state.spacerType===pl.key?'cur':'');
      b.innerHTML='<img src="'+pl.img+'" alt="'+pl.name+'">';
      b.title=pl.name+' '+pl.mm+'mm';
      b.addEventListener('click',function(){
        state.spacerType=pl.key; state.spacerSize=pl.sizes?pl.mm:null;
        closeBeadMenu(); render(false); syncControls();
      });
      beadMenu.appendChild(b);
    });
    var none=document.createElement('button'); none.type='button';
    none.className='bb2d-centre-remove'; none.textContent='NONE';
    none.addEventListener('click',function(){
      state.spacerPos=[]; closeBeadMenu(); render(false); syncControls();
    });
    beadMenu.appendChild(none);
    placeMenu(el);
  }

  // shared placement for the ring choosers
  function placeMenu(el){
    document.body.appendChild(beadMenu);
    var r=el.getBoundingClientRect(), mw=beadMenu.offsetWidth, mh=beadMenu.offsetHeight;
    var left=Math.max(8,Math.min(window.innerWidth-mw-8, r.left+r.width/2-mw/2));
    var top=r.top-mh-10; if(top<8) top=r.bottom+10;
    beadMenu.style.left=left+'px'; beadMenu.style.top=top+'px';
  }

  // ── bridge chooser: tap a bead sitting beside a pixiu of the pair ──
  // Offers every crystal already in the mix, so the beads either side of the
  // dragons are the customer's choice, not whichever crystal came first.
  function openBridgeMenu(side,el){
    closeBeadMenu();
    var mix=activeIds(); if(mix.length<2) return;
    beadMenu=document.createElement('div'); beadMenu.className='bb2d-bead-menu';
    var cur=bridgeId(side);
    mix.forEach(function(id){
      var c=crystalById(id);
      var b=document.createElement('button'); b.type='button';
      b.className=(cur===id?'cur':'');
      b.innerHTML='<img src="'+c.img+'" alt="'+c.name+'">';
      b.title=c.name;
      b.addEventListener('click',function(){
        setBridge(side,id);
        closeBeadMenu(); render(false); syncControls();
      });
      beadMenu.appendChild(b);
    });
    placeMenu(el);
  }

  // ── centre chooser: tap the piece between a pixiu pair ──
  // Offers the pearl, every crystal already in the mix, and a remove option,
  // so tapping never silently deletes the piece.
  function openCentreMenu(el){
    closeBeadMenu();
    beadMenu=document.createElement('div'); beadMenu.className='bb2d-bead-menu';
    var opts=[];
    opts.push({key:'pearl',img:currentPearl().img,label:currentPearl().name});
    activeIds().forEach(function(id){
      var c=crystalById(id);
      opts.push({key:id,img:c.img,label:c.name});
    });
    opts.forEach(function(o){
      var b=document.createElement('button'); b.type='button';
      b.className=(state.pairCentre===o.key?'cur':'');
      b.innerHTML='<img src="'+o.img+'" alt="'+o.label+'">';
      b.title=o.label;
      b.addEventListener('click',function(){
        state.pairCentre=o.key;
        closeBeadMenu(); render(false); syncControls();
      });
      beadMenu.appendChild(b);
    });
    var rm=document.createElement('button'); rm.type='button';
    rm.className='bb2d-centre-remove'; rm.title='Remove';
    rm.textContent='REMOVE';
    rm.addEventListener('click',function(){
      state.pairCentre=null;
      closeBeadMenu(); render(false); syncControls();
    });
    beadMenu.appendChild(rm);
    document.body.appendChild(beadMenu);
    var r=el.getBoundingClientRect(), mw=beadMenu.offsetWidth, mh=beadMenu.offsetHeight;
    var left=Math.max(8,Math.min(window.innerWidth-mw-8, r.left+r.width/2-mw/2));
    var top=r.top-mh-10; if(top<8) top=r.bottom+10;
    beadMenu.style.left=left+'px'; beadMenu.style.top=top+'px';
  }

  // ── pixiu chooser: tap the pixiu on the ring, pick another (or none) ──
  function openPixiuMenu(el){
    closeBeadMenu();
    beadMenu=document.createElement('div'); beadMenu.className='bb2d-bead-menu';
    PIXIUS.forEach(function(p){
      var b=document.createElement('button'); b.type='button';
      b.className=(state.pix.v===p.v?'cur':'');
      b.innerHTML=p.img?'<img src="'+p.img+'" alt="'+p.label+'">':'<span class="pxnone">NONE</span>';
      b.title=p.label;
      b.addEventListener('click',function(){
        state.pix=p;
        closeBeadMenu(); render(false); syncControls();
      });
      beadMenu.appendChild(b);
    });
    document.body.appendChild(beadMenu);
    var r=el.getBoundingClientRect(), mw=beadMenu.offsetWidth, mh=beadMenu.offsetHeight;
    var left=Math.max(8,Math.min(window.innerWidth-mw-8, r.left+r.width/2-mw/2));
    var top=r.top-mh-10; if(top<8) top=r.bottom+10;
    beadMenu.style.left=left+'px'; beadMenu.style.top=top+'px';
  }

  // ── crystal library popup ──
  var libFilter='ALL', libColour='ALL', libSize='ALL', libQ='', libIntents=[];
  var libOverlay=$id('libOverlay');
  // The library edits the mix live, but the RING must not change until Confirm.
  // Snapshot the mix on open: Confirm keeps the edits (and replays the assemble
  // animation), cancelling (x, backdrop, Esc) restores the snapshot untouched.
  var libSnapshot=null, libSuppressRender=false;
  function snapshotMix(){
    return {counts:JSON.parse(JSON.stringify(state.counts)),order:state.order.slice(),
            seq:state.seq.slice(),sizes:JSON.parse(JSON.stringify(state.sizes))};
  }
  function restoreMix(sn){
    state.counts=sn.counts; state.order=sn.order; state.seq=sn.seq; state.sizes=sn.sizes;
  }
  function openLibrary(){
    libSnapshot=snapshotMix();
    libSuppressRender=true;      // ring holds its current look while choosing
    libOverlay.classList.add('open');
    buildLib();
  }
  // the element panel (appended below, outside this closure) opens the
  // library with a preset element filter
  window.bb2dOpenLibrary = function(){
    var ovEl=document.getElementById('bb2d-libOverlay');
    if(ovEl) ovEl.classList.remove('lib--element-locked');
    return openLibrary.apply(this, arguments);
  };
  window.bb2dState = function(){ return state; };

  /* ── desktop zoom ─────────────────────────────────────────────────────────
     A quiet drag pill above the stage. Scales the bracelet visually
     (transform, origin top centre) and pads the layout below so nothing
     overlaps. The MAX is whatever the screen allows - recomputed on resize,
     never a fixed 3x on a screen that cannot fit it. Rect-based tap and
     capture math already handles CSS scale (see captureRing notes). */
  (function(){
    if(window.matchMedia('(max-width: 860px)').matches) return;
    var zwrap=document.createElement('div'); zwrap.className='bb2d-zoom';
    zwrap.innerHTML='<span class="bb2d-zoom-l">ZOOM</span>'
      +'<span class="bb2d-zoom-wrap">'
      +'<input type="range" min="1" max="3" step="0.05" value="1" aria-label="Zoom the bracelet">'
      +'<span class="bb2d-zoom-v">1x</span></span>';
    stage.parentNode.insertBefore(zwrap, stage);
    var zin=zwrap.querySelector('input');
    var zv=zwrap.querySelector('.bb2d-zoom-v');
    // the little readout rides under the thumb
    function syncReadout(){
      var v=parseFloat(zin.value)||1, mx=parseFloat(zin.max)||3;
      var pct=mx>1 ? (v-1)/(mx-1) : 0;
      zv.style.left=(pct*(zin.offsetWidth-13)+6.5)+'px';
      zv.textContent=(Math.round(v*10)/10).toString().replace(/\.0$/,'')+'x';
    }
    function unscaledH(){ return stage.getBoundingClientRect().height/(parseFloat(zin.value)||1); }
    function maxScale(){
      // the bracelet scales around its CENTRE, so the cap is set by the
      // nearer of: zoom bar below-edge (above) and element chart top (below)
      // - the enlarged ring may never overlap either.
      var v=parseFloat(zin.value)||1;
      var r=stage.getBoundingClientRect();
      var w=r.width/v, h=r.height/v;
      var cy=(r.top+r.bottom)/2;
      // cap against the COLUMN top (the header line), not the corner pill -
      // with the bracelet anchored high, capping at the pill strangled the
      // zoom range; the pill sits in the corner clear of the ring anyway
      var zb=stage.parentElement.getBoundingClientRect().top+8;
      var panel=document.getElementById('bb2d-elPanel');
      var pt=panel?panel.getBoundingClientRect().top:window.innerHeight;
      var topRoom=cy-zb-4, botRoom=pt-cy-4;
      // the beads sit inside ~90% of the stage box, so divide by the ART
      // height, not the box - buys real extra zoom before anything touches
      var byBand=2*Math.min(topRoom,botRoom)/(h*0.90);
      var byW=(window.innerWidth-32)/w;
      return Math.max(1, Math.min(3, byBand, byW));
    }
    function syncMax(){
      var m=maxScale();
      zin.max=m.toFixed(2);
      if(parseFloat(zin.value)>m){ zin.value=m.toFixed(2); apply(); }
      // no headroom on this screen: the pill says so by disappearing
      zwrap.style.display = m<=1.05 ? 'none' : '';
    }
    function apply(){
      var v=parseFloat(zin.value)||1;
      // centre origin: the bracelet's middle stays fixed while it grows
      stage.style.transformOrigin='center center';
      stage.style.transform = v===1 ? '' : 'scale('+v+')';
      // NO layout compensation and NO z-raise: the element box owns the
      // bottom of the screen unconditionally (owner's rule) - an oversized
      // bracelet slides UNDER the box rather than pushing it off-screen.
      stage.style.zIndex='';
      stage.style.marginBottom='';
      // the centre hint text stays 1x while the ring scales - counter-scale
      // the hint layers by the inverse
      ['bb2d-ringEmpty','bb2d-ringHint'].forEach(function(id){
        var el=document.getElementById(id); if(!el) return;
        el.style.transformOrigin='center center';
        el.style.transform = v===1 ? '' : 'scale('+(1/v)+')';
      });
    }
    zin.addEventListener('input',function(){ apply(); syncReadout(); });
    window.addEventListener('resize',function(){ syncMax(); syncReadout(); });
    setTimeout(function(){ syncMax(); syncReadout(); },300);
  })();
  window.bb2dCrystalById = crystalById;
  // tapping the empty placeholder ring opens the library
  stage.addEventListener('click',function(){ if(!state.seq.length) openLibrary(); });
  function cancelLibrary(){
    if(libSnapshot) restoreMix(libSnapshot);
    libSnapshot=null; libSuppressRender=false;
    libOverlay.classList.remove('open');
    render(false); syncControls();
  }
  function confirmLibrary(){
    var hadBeads=libSnapshot&&libSnapshot.seq.length>0;
    libSnapshot=null; libSuppressRender=false;
    libOverlay.classList.remove('open');
    // animate the assemble every time the mix is confirmed, not just first fill
    render(true); syncControls();
  }
  $id('libClose').addEventListener('click',cancelLibrary);
  libOverlay.addEventListener('click',function(e){ if(e.target===libOverlay) cancelLibrary(); });
  document.addEventListener('keydown',function(e){
    if(e.key==='Escape'&&libOverlay.classList.contains('open')) cancelLibrary();
  });
  var libConfirmBtn=$id('libConfirm');
  if(libConfirmBtn) libConfirmBtn.addEventListener('click',confirmLibrary);
  var FEL_HAN={WOOD:'木',FIRE:'火',EARTH:'土',METAL:'金',WATER:'水'};
  var SWATCH={red:'#b23a2e',green:'#6f8f6a',pink:'#d9a8ad',purple:'#7d6b9e',blue:'#5b7b9c',black:'#232323',
    white:'#f1efe9',yellow:'#d9b95c',orange:'#cf8a4e',brown:'#8a6a4f',grey:'#9a9a9a',
    multi:'conic-gradient(#b23a2e,#d9b95c,#6f8f6a,#5b7b9c,#7d6b9e,#b23a2e)'};
  function swatchHtml(colour){
    var key=String(colour||'').toLowerCase(), v=SWATCH[key];
    if(!v) return '';
    var bg=v.indexOf('gradient')>=0?('background:'+v):('background:'+v);
    return '<span class="cd" style="'+bg+'"></span>';
  }
  function fillSelect(sel,opts,labelFn,want){
    sel.innerHTML='';
    opts.forEach(function(o){ var op=document.createElement('option'); op.value=o; op.textContent=labelFn?labelFn(o):o; sel.appendChild(op); });
    sel.value = (want!=null&&opts.indexOf(want)>=0) ? want : 'ALL';
    if(sel._bb2dSync) sel._bb2dSync();
  }
  var fEl=$id('fEl'), fCol=$id('fCol'), fInt=$id('fInt');
  // fSz may be absent while edge-cached page HTML predates the size filter:
  // every use is guarded so the builder keeps working against stale markup.
  var fSz=$id('fSz');
  var elLabel=function(o){return o==='ALL'?'All':o.charAt(0)+o.slice(1).toLowerCase()+(FEL_HAN[o]?' '+FEL_HAN[o]:'');};
  var colLabel=function(o){return o==='ALL'?'All':o.charAt(0)+o.slice(1).toLowerCase();};
  var intLabel=function(o){return o==='ALL'?'All':o.charAt(0)+o.slice(1).toLowerCase();};
  var szLabel=function(o){return o==='ALL'?'All':o+'mm';};
  // cascading filters: each dropdown only offers values that still match the
  // OTHER active filters + search, so no combination ever lands on an empty grid
  function matchesExcept(c,skip){
    if(skip!=='el' && libFilter!=='ALL' && c.el.toUpperCase()!==libFilter) return false;
    if(skip!=='col' && libColour!=='ALL' && (c.colour||'').toUpperCase()!==libColour) return false;
    if(skip!=='sz' && libSize!=='ALL' && SIZES_AVAILABLE(c.id).indexOf(+libSize)<0) return false;
    if(skip!=='int' && libIntents.length && !(c.intentions||[]).some(function(i2){return libIntents.indexOf(i2.toUpperCase())>=0;})) return false;
    if(libQ && c.name.indexOf(libQ.toUpperCase())<0) return false;
    return true;
  }
  function availOptions(skip,getVals){
    var out=[];
    CRYSTALS.forEach(function(c){
      if(!matchesExcept(c,skip)) return;
      getVals(c).forEach(function(v){ var u=String(v).toUpperCase(); if(u&&out.indexOf(u)<0) out.push(u); });
    });
    out.sort();
    return ['ALL'].concat(out);
  }
  function refreshFilters(){
    // the lib* vars are the source of truth; a rebuilt list that no longer
    // contains the wanted value falls back to ALL cleanly
    fillSelect(fEl,availOptions('el',function(c){return [c.el];}),elLabel,libFilter);
    fillSelect(fCol,availOptions('col',function(c){return [c.colour];}),colLabel,libColour);
    if(fSz){
      // numeric sort, not availOptions: its lexicographic sort puts 10 before 6
      var availSz=[];
      CRYSTALS.forEach(function(c){
        if(!matchesExcept(c,'sz')) return;
        SIZES_AVAILABLE(c.id).forEach(function(m){ var s=String(m); if(availSz.indexOf(s)<0) availSz.push(s); });
      });
      availSz.sort(function(a,b){return a-b;});
      fillSelect(fSz,['ALL'].concat(availSz),szLabel,libSize);
      libSize=fSz.value||'ALL';
    }
    var availInt=availOptions('int',function(c){return c.intentions||[];});
    libIntents=libIntents.filter(function(iv){return availInt.indexOf(iv)>=0;});
    libFilter=fEl.value||'ALL';
    libColour=fCol.value||'ALL';
    if(fInt._bb2dSync) fInt._bb2dSync();
  }
  fEl.addEventListener('change',function(){ libFilter=this.value; buildLib(); });
  // Setting fEl.value from outside does nothing: the theme swaps the native
  // select for its own widget, so the change never reaches libFilter. Expose
  // a setter that drives the real state and syncs the widget.
  // Clearing a slot from the mobile sheet: faking an input change and
  // clicking a minus button never reached the builder's state, so Remove
  // silently did nothing. Drive the real state and re-render.
  window.bb2dClearSlot=function(kind){
    if(kind==='charm'){ state.charms=[]; }
    else if(kind==='pearl'){ state.spacerPos=[]; state.pairCentre=null; }
    else if(kind==='pixiu'){ state.pix=PIX_NONE; state.pixCount=1; }
    else if(kind==='crystal'){ state.order=[]; state.counts={}; state.seq=[]; }
    else return;
    rebuildSeq();
    render(false);
    syncControls();
  };

  window.bb2dSetElementFilter=function(el){
    libFilter=String(el||'ALL').toUpperCase();
    if(fEl){
      fEl.value=libFilter;
      if(fEl._bb2dSync) fEl._bb2dSync();
    }
    buildLib();
  };
  fCol.addEventListener('change',function(){ libColour=this.value; buildLib(); });
  if(fSz) fSz.addEventListener('change',function(){ libSize=this.value; buildLib(); });
  // search input was removed from the markup; the filters cover it. Guarded
  // so this keeps working if it is ever added back.
  var libSearchEl=$id('libSearch');
  if(libSearchEl) libSearchEl.addEventListener('input',function(){ libQ=this.value; buildLib(); });
  var libClear=$id('libClear');
  function syncClearBtn(){
    if(!libClear) return;
    var active=libFilter!=='ALL'||libColour!=='ALL'||libSize!=='ALL'||libIntents.length>0||!!libQ;
    libClear.classList.toggle('active',active);
  }
  if(libClear) libClear.addEventListener('click',function(){
    libFilter='ALL'; libColour='ALL'; libSize='ALL'; libIntents=[]; libQ='';
    if(libSearchEl) libSearchEl.value='';
    buildLib();
  });
  var crystalInfoOverlay=$id('crystalInfoOverlay');
  $id('crystalInfoClose').addEventListener('click',function(){ crystalInfoOverlay.classList.remove('open'); });
  crystalInfoOverlay.addEventListener('click',function(e){ if(e.target===crystalInfoOverlay) crystalInfoOverlay.classList.remove('open'); });
  var EL_HAN={wood:'木',fire:'火',earth:'土',metal:'金',water:'水'};
  function openCrystalInfo(c){
    var body=$id('crystalInfoBody');
    body.innerHTML='<div class="ci-img"><img src="'+bigImg(c.img)+'" alt=""></div>'+
      '<div class="ci-text"><h3>'+c.dname+'</h3>'+
      (c.tagline?'<p class="ci-tag">'+c.tagline+'</p>':'')+
      '<p class="ci-meta">'+c.el.toUpperCase()+' '+(EL_HAN[c.el]||'')+(c.chakra?' · '+c.chakra.toUpperCase():'')+'</p>'+
      (c.intentions&&c.intentions.length?'<p class="ci-meta ci-energy">'+c.intentions.map(function(i2){return String(i2).toUpperCase();}).join(' · ')+'</p>':'')+
      (c.summary?'<p class="ci-sum">'+c.summary+'</p>':'')+
      (c.benefits&&c.benefits.length?'<ul class="ci-ben">'+c.benefits.map(function(b2){return '<li>'+b2+'</li>';}).join('')+'</ul>':'')+
      (c.tip?'<p class="ci-tip">'+c.tip+'</p>':'')+
      (c.origin?'<p class="ci-meta" style="margin:14px 0 4px">ORIGIN</p><p class="ci-sum" style="margin-bottom:0">'+c.origin+'</p>':'')+
      '</div>';
    crystalInfoOverlay.classList.add('open');
  }
  // pearl of wisdom (spacer) story panel, copy comes from section settings
  function openSpacerInfo(type){
    var si=D.spacerInfo||{};
    var body=$id('crystalInfoBody');
    var pl=pearlByKey(type);   // works for every design, not just gold/silver
    body.innerHTML='<div class="ci-img"><img src="'+bigImg(pl.img)+'" alt=""></div>'+
      '<div class="ci-text"><h3>'+(si.title||'Pearl of Wisdom')+'</h3>'+
      '<p class="ci-meta">'+pl.name.toUpperCase()+' · '+pl.mm+'MM</p>'+
      (si.tagline?'<p class="ci-tag">'+si.tagline+'</p>':'')+
      (si.story?'<div class="ci-story">'+si.story+'</div>':'')+
      '</div>';
    crystalInfoOverlay.classList.add('open');
  }
  // charm story panel: tap a charm's name, reuses the crystal info overlay
  // Pixiu story: lore is shared, the material line differs by finish and the
  // size line by design, so the copy is assembled per tile rather than
  // stored six times over.
  function openPixiuInfo(p){
    var cfg=(D && D.pixiuInfo) || {};
    var size=pixSizeOf(p)||'';                   // comes back uppercase: MINI
    var colour=(pixColourOf(p)||'').toLowerCase();
    var material=(colour.indexOf('gold')>=0) ? cfg.materialGold : cfg.materialSilver;
    // match the settings keys (Mini/Classic/Grande) case-insensitively
    var sizes=cfg.sizes||{}, sizeLine='';
    Object.keys(sizes).forEach(function(k){
      if(k.toLowerCase()===size.toLowerCase()) sizeLine=sizes[k];
    });
    var body=$id('crystalInfoBody');
    body.innerHTML='<div class="ci-img"><img src="'+bigImg(p.img||'')+'" alt=""></div>'+
      '<div class="ci-text"><h3>'+size+' '+pixColourOf(p)+'</h3>'+
      (cfg.tagline?'<p class="ci-tag">'+cfg.tagline+'</p>':'')+
      '<div class="ci-story">'+
        (cfg.lore?'<p>'+cfg.lore+'</p>':'')+
        (material?'<p>'+material+'</p>':'')+
        (sizeLine?'<p>'+sizeLine+'</p>':'')+
      '</div></div>';
    crystalInfoOverlay.classList.add('open');
  }

  function openCharmInfo(c){
    var body=$id('crystalInfoBody');
    body.innerHTML='<div class="ci-img"><img src="'+bigImg(c.img)+'" alt=""></div>'+
      '<div class="ci-text"><h3>'+c.rawName+'</h3>'+
      (c.info?'<p class="ci-tag">'+c.info+'</p>':'')+
      (c.story?'<div class="ci-story">'+c.story+'</div>':'')+
      '</div>';
    crystalInfoOverlay.classList.add('open');
  }
  function buildLib(){
    refreshFilters();
    syncClearBtn();
    // Confirm is only meaningful once at least one crystal is in the mix
    var cbtn=$id('libConfirm');
    if(cbtn){
      var n=activeIds().length;
      cbtn.disabled=n===0;
      cbtn.classList.toggle('ready',n>0);
    }
    var grid=$id('libGrid'); grid.innerHTML='';
    var visible=CRYSTALS.filter(function(c){
      if(libFilter!=='ALL' && c.el.toUpperCase()!==libFilter) return false;
      if(libColour!=='ALL' && (c.colour||'').toUpperCase()!==libColour) return false;
      if(libSize!=='ALL' && SIZES_AVAILABLE(c.id).indexOf(+libSize)<0) return false;
      if(libIntents.length && !(c.intentions||[]).some(function(i2){return libIntents.indexOf(i2.toUpperCase())>=0;})) return false;
      if(libQ && c.name.indexOf(libQ.toUpperCase())<0) return false;
      return true;
    });
    // slot strip: chosen crystals first, then the empty squares left to fill
    var MAXMIX=MAX_CRYSTALS;
    var strip=$id('libSlots'); strip.innerHTML='';
    activeIds().forEach(function(id){
      var c2=crystalById(id);
      var d=document.createElement('div'); d.className='lib-slot';
      d.innerHTML='<img src="'+c2.img+'" alt="'+c2.name+'"><button type="button" class="slot-x" aria-label="Remove">×</button>'
        +'<span class="lib-el"><img src="/cdn/shop/t/30/assets/wuxing-'+c2.el
        +'.png" alt="">'+c2.el.toUpperCase()+'</span>';
      d.querySelector('.slot-x').addEventListener('click',function(){
        removeCrystalPreserving(id);
        if(!libSuppressRender){ render(false); syncControls(); }
        buildLib();
      });
      strip.appendChild(d);
    });
    // one inviting empty box; the next appears as each crystal is chosen
    if(activeIds().length<MAXMIX){
      var ph=document.createElement('div'); ph.className='lib-slot emptyslot'; ph.textContent='+';
      strip.appendChild(ph);
    }
    visible.forEach(function(c){
      var it=document.createElement('button'); it.type='button';
      var inmix=(state.counts[c.id]||0)>0;
      it.className='lib-item'+(inmix?' inmix':'');
      it.innerHTML='<img src="'+c.img+'" alt=""><span class="cl" role="button" aria-label="About '+c.dname+'">'+c.name+'</span>'
        +((c.intentions&&c.intentions.length)
          ?'<span class="lib-energy">'+c.intentions.slice(0,2).join(' \u00b7 ')+'</span>':'');
      var nameEl=it.querySelector('.cl');
      ['mousedown','touchstart'].forEach(function(tt){ nameEl.addEventListener(tt,function(e){e.stopPropagation();},{passive:true}); });
      nameEl.addEventListener('click',function(e){ e.preventDefault(); e.stopPropagation(); openCrystalInfo(c); });
      it.addEventListener('click',function(){
        var wasEmpty=!state.seq.length;
        if((state.counts[c.id]||0)>0){
          removeCrystalPreserving(c.id);
        } else {
          if(activeIds().length>=MAX_CRYSTALS) return;   // mix is full, remove one first
          // snapshot so an add with no physical room left can be refused
          // cleanly instead of overflowing the ring
          var pre={counts:JSON.parse(JSON.stringify(state.counts)), order:state.order.slice(),
                   seq:state.seq.slice(), sizes:JSON.parse(JSON.stringify(state.sizes))};
          // a crystal added while the size filter is set arrives IN that size
          // (filtering to 6mm then receiving a 10mm bead reads as a bug)
          var avail=SIZES_AVAILABLE(c.id);
          var want=(libSize!=='ALL'?+libSize:10);
          if(avail.indexOf(want)<0) want=avail[avail.length-1];
          state.sizes[c.id]=state.sizes[c.id]||want;
          if(state.order.indexOf(c.id)<0) state.order.push(c.id);
          if(libSnapshot && libSnapshot.seq.length){
            // the bracelet was already built when the library opened (owner,
            // 9 Aug): a later addition joins as ONE bead at the very end -
            // never re-split an arrangement the customer already accepted.
            // Room is made by borrowing single beads from the most numerous
            // other crystal, middle occurrence, so the look barely moves.
            state.seq.push(c.id);
            syncCountsFromSeq();
            var roomGuard=0;
            while(seqWidthMm()>capacityMm() && roomGuard++<50){
              var donor=activeIds().filter(function(d){return d!==c.id&&state.counts[d]>1;})
                .sort(function(a,b){return state.counts[b]-state.counts[a];})[0];
              if(!donor) break;
              var occ=[]; state.seq.forEach(function(x,i2){ if(x===donor) occ.push(i2); });
              state.seq.splice(occ[Math.floor(occ.length/2)],1);
              syncCountsFromSeq();
            }
          } else {
            // first fill: split the mix EVENLY across all chosen crystals
            // (equal ratios; rebuildSeq scales them to capacity).
            // The +/- counters on the slot cards still trade one bead at a time.
            state.counts[c.id]=1;
            activeIds().forEach(function(id){ state.counts[id]=1; });
            rebuildSeq();
          }
          if(seqWidthMm()>capacityMm()){
            state.counts=pre.counts; state.order=pre.order; state.seq=pre.seq; state.sizes=pre.sizes;
            return;   // the ring is physically full of distinct beads
          }
        }
        if(!libSuppressRender){ render(wasEmpty); syncControls(); }
        buildLib();
      });
      grid.appendChild(it);
    });
    syncLibMore();
  }

  // ── scroll affordance ────────────────────────────────────────────────────
  // The grid holds far more crystals than fit, and nothing signalled that.
  // Fade the bottom edge while there is anything left below, and clear it
  // once the customer reaches the end.
  function syncLibMore(){
    var grid=$id('libGrid'), more=$id('libMore');
    if(!grid||!more) return;
    var left=grid.scrollHeight-grid.clientHeight-grid.scrollTop;
    var hasMore=left>12;
    more.hidden=!hasMore;
    more.setAttribute('aria-hidden', hasMore?'false':'true');
  }
  (function wireLibMore(){
    // fade only - the button is gone, the gradient carries the signal
    var grid=$id('libGrid');
    if(grid) grid.addEventListener('scroll',syncLibMore,{passive:true});
    window.addEventListener('resize',syncLibMore);
  })();

  // ── editorial dropdowns: replace native select popups with styled panels ──
  function enhanceSelect(sel,decorate){
    var wrap=document.createElement('div'); wrap.className='dd';
    sel.parentNode.insertBefore(wrap, sel); wrap.appendChild(sel);
    var btn=document.createElement('button'); btn.type='button'; btn.className='dd-btn';
    var panel=document.createElement('div'); panel.className='dd-panel';
    function label(){ var o=sel.options[sel.selectedIndex]; return o?o.textContent:''; }
    function deco(v){ return decorate?decorate(v):''; }
    function syncBtn(){ btn.innerHTML='<span>'+deco(sel.value)+label()+'</span><svg class="chev" viewBox="0 0 10 7" fill="none"><polyline points="1,1 5,5 9,1" stroke="currentColor" stroke-width="1" fill="none"/></svg>'; }
    sel._bb2dSync=syncBtn;
    function close(){ wrap.classList.remove('open'); }
    function openP(){
      panel.innerHTML='';
      Array.prototype.forEach.call(sel.options,function(op){
        var it=document.createElement('button'); it.type='button';
        it.className='dd-item'+(op.value===sel.value?' sel':'');
        it.innerHTML=deco(op.value)+op.textContent;
        it.addEventListener('click',function(){
          sel.value=op.value;
          sel.dispatchEvent(new Event('change',{bubbles:true}));
          close(); syncBtn();
        });
        panel.appendChild(it);
      });
      wrap.classList.add('open');
    }
    btn.addEventListener('click',function(e){ e.stopPropagation(); wrap.classList.contains('open')?close():openP(); });
    document.addEventListener('mousedown',function(e){ if(!wrap.contains(e.target)) close(); },true);
    sel.addEventListener('change',syncBtn);
    wrap.appendChild(btn); wrap.appendChild(panel); syncBtn();
  }
  enhanceSelect(wristSel);
  // The same decorate hook the colour filter uses for its swatch. The path
  // is built here rather than read from ICON, which is declared ~200 lines
  // further down - referencing it threw "ICON is not defined" and killed
  // the whole builder script.
  enhanceSelect(fEl,function(v){
    // The real wuxing icons (owner's call, replacing the emoji stopgap).
    // Size is INLINE because the dropdown panel sits outside every styled
    // scope - relying on a class is what made the PNGs render huge before.
    var e2=String(v).toLowerCase();
    if(e2==='all') return '';
    return '<img class="dd-elicon" src="/cdn/shop/t/30/assets/wuxing-'+e2
      +'.png" alt="" style="display:inline-block;width:13px;height:13px;vertical-align:-2px;margin-right:6px">';
  });
  enhanceSelect(fCol,function(v){ return v==='ALL'?'':swatchHtml(v); });
  if(fSz) enhanceSelect(fSz);
  // intention opens the big sheet
  (function(){
    var wrap=document.createElement('div'); wrap.className='dd';
    fInt.parentNode.insertBefore(wrap,fInt); wrap.appendChild(fInt);
    var btn=document.createElement('button'); btn.type='button'; btn.className='dd-btn';
    function label(){
      if(!libIntents.length) return 'All';
      if(libIntents.length===1){ var v=libIntents[0]; return v.charAt(0)+v.slice(1).toLowerCase(); }
      return libIntents.length+' intentions';
    }
    function syncBtn(){ btn.innerHTML='<span>'+label()+'</span><svg class="chev" viewBox="0 0 10 7" fill="none"><polyline points="1,1 5,5 9,1" stroke="currentColor" stroke-width="1" fill="none"/></svg>'; }
    fInt._bb2dSync=syncBtn;
    btn.addEventListener('click',function(e){ e.stopPropagation(); openIntentSheet(); });
    wrap.appendChild(btn); syncBtn();
  })();
  var intentOverlay=$id('intentOverlay');
  $id('intentClose').addEventListener('click',function(){ intentOverlay.classList.remove('open'); });
  intentOverlay.addEventListener('click',function(e){ if(e.target===intentOverlay) intentOverlay.classList.remove('open'); });
  function openIntentSheet(){
    var grid=$id('intentGrid'); grid.innerHTML='';
    availOptions('int',function(c){return c.intentions||[];}).forEach(function(iv){
      var b=document.createElement('button'); b.type='button';
      if(iv==='ALL'){
        b.className=libIntents.length?'':'sel';
        b.textContent='ALL INTENTIONS';
        b.addEventListener('click',function(){
          libIntents=[];
          buildLib();
          intentOverlay.classList.remove('open');
        });
      } else {
        b.className=libIntents.indexOf(iv)>=0?'sel':'';
        b.textContent=iv;
        b.addEventListener('click',function(){
          var at=libIntents.indexOf(iv);
          if(at>=0) libIntents.splice(at,1); else libIntents.push(iv);
          // Toggle IN PLACE. Rebuilding the sheet on every tap reset its
          // scroll and replaced the button under the finger - the "glitch".
          b.className = at>=0 ? '' : 'sel';
          var allBtn=grid.firstChild;
          if(allBtn) allBtn.className=libIntents.length?'':'sel';
          buildLib();          // grid + counts update behind the sheet
          if(fInt._bb2dSync) fInt._bb2dSync();
        });
      }
      grid.appendChild(b);
    });
    intentOverlay.classList.add('open');
  }

  // ── guided start ────────────────────────────────────────────────────────
  // Optional walkthrough. Each step BORROWS the real control (wrist select,
  // crystal +, pixiu row, pearl row, charm strip) by moving the live node into
  // the step and putting it back afterwards, so there is no duplicate UI to
  // keep in sync and nothing to maintain twice. Remove the whole feature by
  // unticking "Show the guided start" in the theme editor.
  (function(){
    var guide=document.querySelector('[data-bb2d-guide]');
    if(!guide) return;
    var KEY='bb2d-guide-seen';
    var screens=[].slice.call(guide.querySelectorAll('[data-bb2d-screen]'));
    var stepScreens=screens.filter(function(s){ return s.getAttribute('data-bb2d-screen')!=='intro'; });
    // which live control each step borrows, and where to put it back
    var SOURCES={
      wrist:   '.bb2d-wristsel',
      crystal: '#bb2d-crystalCells',
      pixiu:   '#bb2d-pixCells',
      pearl:   '#bb2d-spacerCells',
      charm:   '#bb2d-charmStrip'
    };
    var homes={};
    function borrow(key){
      var el=document.querySelector(SOURCES[key]);
      var slot=guide.querySelector('[data-bb2d-guide-slot="'+key+'"]');
      if(!el||!slot||slot.contains(el)) return;
      if(!homes[key]){ homes[key]={parent:el.parentNode,next:el.nextSibling}; }
      slot.appendChild(el);
    }
    function returnAll(){
      Object.keys(homes).forEach(function(k){
        var el=document.querySelector(SOURCES[k]); var h=homes[k];
        if(el&&h&&h.parent) h.parent.insertBefore(el, h.next||null);
      });
      homes={};
    }
    var idx=-1;   // -1 = intro
    function show(i){
      idx=i;
      screens.forEach(function(s){ s.classList.remove('is-active'); });
      if(i<0){ screens[0].classList.add('is-active'); return; }
      var sc=stepScreens[i];
      if(!sc){ finish(); return; }
      var key=sc.getAttribute('data-bb2d-screen');
      borrow(key);
      sc.classList.add('is-active');
      var panel=guide.querySelector('.bb2d-guide__panel');
      if(panel){
        panel.scrollTop=0;
        // the wrist step must not scroll or it clips its own dropdown
        panel.classList.toggle('is-nooverflow', key==='wrist');
      }
      // #bb2d-crystalCells is just the "+" tile, so the crystal step looked
      // empty. Open the real library over the guide instead.
      var behind = (key==='crystal');
      guide.classList.toggle('is-behind', behind);
      if(behind&&typeof openLibrary==='function') openLibrary();
    }
    function open(){ guide.hidden=false; document.body.style.overflow='hidden'; show(-1); }
    function finish(){
      returnAll();
      var lo=$id('libOverlay'); if(lo) lo.classList.remove('open');
      guide.classList.remove('is-behind');
      guide.hidden=true;
      document.body.style.overflow='';
      try{ localStorage.setItem(KEY,'1'); }catch(e){}
      syncControls(); render(false);
    }
    guide.addEventListener('click',function(e){ if(e.target===guide) finish(); });
    var closeBtn=$id('guideClose'); if(closeBtn) closeBtn.addEventListener('click',finish);
    var startBtn=$id('guideStart'); if(startBtn) startBtn.addEventListener('click',function(){ show(0); });
    var skipBtn=$id('guideSkip'); if(skipBtn) skipBtn.addEventListener('click',finish);
    guide.querySelectorAll('[data-bb2d-guide-next]').forEach(function(b){
      b.addEventListener('click',function(){ show(idx+1); });
    });
    guide.querySelectorAll('[data-bb2d-guide-back]').forEach(function(b){
      b.addEventListener('click',function(){ show(idx-1); });
    });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape'&&!guide.hidden) finish(); });
    // show once per visitor; ?guide=1 forces it for testing
    var forced=/[?&]guide=1/.test(location.search);
    var seen=false; try{ seen=localStorage.getItem(KEY)==='1'; }catch(e){}
    if(forced||!seen) setTimeout(open, 400);
    window.BB2D_OPEN_GUIDE=open;
  })();

  (function(){
    var u=$id('undo'), r=$id('redo');
    if(u) u.addEventListener('click',function(){ window.BB2D_UNDO(); });
    var rs=$id('reset');
    if(rs) rs.addEventListener('click',function(){ window.BB2D_RESET(); });
    if(r) r.addEventListener('click',function(){ window.BB2D_REDO(); });
    // the usual keyboard shortcuts, ignored while typing in the search box
    document.addEventListener('keydown',function(e){
      if(!(e.metaKey||e.ctrlKey)) return;
      var t=e.target, tag=t&&t.tagName;
      if(tag==='INPUT'||tag==='TEXTAREA'||(t&&t.isContentEditable)) return;
      if(e.key==='z'&&!e.shiftKey){ e.preventDefault(); window.BB2D_UNDO(); }
      else if((e.key==='z'&&e.shiftKey)||e.key==='y'){ e.preventDefault(); window.BB2D_REDO(); }
    });
  })();
  // ── restore a saved design (?d=CODE) ────────────────────────────────────
  // The cart's EDIT link sends the customer back here with their design code.
  // The worker holds the whole builder state, so put it back exactly as they
  // left it. Anything missing or stale just falls through to a fresh build -
  // a broken code must never leave them staring at an empty builder.
  function restoreDesign(code){
    return fetch(WORKER+'/design/'+encodeURIComponent(code))
      .then(function(r){ if(!r.ok) throw new Error('design '+r.status); return r.json(); })
      .then(function(d){
        var s=d&&d.state; if(!s) throw new Error('no state');
        if(s.wrist!=null) state.wrist=s.wrist;
        if(s.pixCount!=null) state.pixCount=s.pixCount;
        if(s.pixV){
          var p=PIXIUS.filter(function(x){return x.label===s.pixV||x.v===s.pixV;})[0];
          if(p) state.pix=p;
        }
        if(s.seq) state.seq=s.seq.slice();
        if(s.counts) state.counts=JSON.parse(JSON.stringify(s.counts));
        if(s.sizes) state.sizes=JSON.parse(JSON.stringify(s.sizes));
        if(s.counts) state.order=Object.keys(s.counts);
        if(s.spacerType) state.spacerType=s.spacerType;
        if(s.spacerSize!=null) state.spacerSize=s.spacerSize;
        if(s.spacerPos) state.spacerPos=s.spacerPos.slice();
        state.pairCentre=(s.pairCentre!==undefined)?s.pairCentre:null;
        state.bridgeL=(s.bridgeL!==undefined)?s.bridgeL:null;
        state.bridgeR=(s.bridgeR!==undefined)?s.bridgeR:null;
        if(s.charms) state.charms=JSON.parse(JSON.stringify(s.charms));
      });
  }
  (function(){
    // ?line=<cart line key> means we were sent here by the cart's Edit link:
    // adding should REPLACE that line, not append a second bracelet.
    var lm=/[?&]line=([^&]+)/.exec(location.search);
    if(lm){
      try{ EDIT_LINE=decodeURIComponent(lm[1]); }catch(e){ EDIT_LINE=lm[1]; }
      // say what the button will do, so 'add' does not look like a duplicate
      if(atcBtn) ATC.add=ATC.update||'UPDATE MY BRACELET';
    }
    var m=/[?&]d=([A-Za-z0-9_-]+)/.exec(location.search);
    if(!m){ syncControls(); render(true); histInit(); return; }
    restoreDesign(m[1])
      .catch(function(err){ if(window.console&&console.warn) console.warn('bb2d: could not restore design:',err); })
      .then(function(){ syncControls(); render(true); histInit(); });
  })();
})();

/* ── Element panel ────────────────────────────────────────────────────────
   Shows the bracelet's own five-element balance and, when the visitor has
   completed the bazi reading (localStorage key "serenity_bazi", written by
   sections/bazi-reading.liquid), their chart alongside it.
   ------------------------------------------------------------------------ */
(function(){
  var ORDER=['Wood','Fire','Earth','Metal','Water'];
  var ZH={Wood:'木',Fire:'火',Earth:'土',Metal:'金',Water:'水'};
  var PASTEL={Wood:'#b9cdb0',Fire:'#e8b3a8',Earth:'#cfd9b4',Metal:'#ecdcb6',Water:'#aec9dd'};
  var ICON={};
  ORDER.forEach(function(e){
    ICON[e]='/cdn/shop/t/30/assets/wuxing-'+e.toLowerCase()+'.png';
  });

  function savedReading(){
    try{
      var raw=localStorage.getItem('serenity_bazi');
      if(!raw) return null;
      var o=JSON.parse(raw);
      return (o && o.reading && o.reading.percentage) ? o.reading : null;
    }catch(_){ return null; }
  }

  // The bracelet's mix:每 bead counts once, by its crystal's element.
  function braceletMix(){
    var tally={Wood:0,Fire:0,Earth:0,Metal:0,Water:0}, total=0;
    var st=(window.bb2dState?window.bb2dState():null);
    ((st&&st.seq)||[]).forEach(function(id){
      var c=window.bb2dCrystalById?window.bb2dCrystalById(id):null; if(!c||!c.el) return;
      var el=String(c.el).replace(/[^A-Za-z]/g,'');
      el=el.charAt(0).toUpperCase()+el.slice(1).toLowerCase();
      if(tally.hasOwnProperty(el)){ tally[el]++; total++; }
    });
    var pct={};
    ORDER.forEach(function(e){ pct[e]= total ? Math.round(tally[e]/total*1000)/10 : 0; });
    return pct;
  }

  function levelOf(v){
    if(v>=45) return ['Very High','#a5584a'];
    if(v>=25) return ['High','#9c8544'];
    if(v>=12) return ['Balanced','#5f7a54'];
    if(v>=1)  return ['Low','#4a7593'];
    return ['Very Low','#a5584a'];
  }

  function chartHTML(pct, withTags){
    var max=Math.max.apply(null,ORDER.map(function(e){return pct[e];}))||1;
    // withTags was accepted but never used, so the bracelet chart never
    // showed which elements the saved reading is short of.
    var need={};
    if(withTags){
      var rr=savedReading();
      ((rr&&rr.like)||[]).forEach(function(e){ need[e]=true; });
    }
    return ORDER.map(function(e){
      var lvl=levelOf(pct[e]);
      return '<div class="bb2d-ce">'
        // px, not %: the track is display:flex and a percentage height on a
        // flex child collapses to zero
        +'<div class="bb2d-cetrack"><div class="bb2d-cefill" data-h="'
          +Math.max(3,pct[e]/max*100)+'" style="background:'+PASTEL[e]+'"></div></div>'
        +'<div class="bb2d-ceicon"><img src="'+ICON[e]+'" alt="'+e+'"></div>'
        +'<div class="bb2d-cename">'+e.toUpperCase()+'</div>'
        +'<div class="bb2d-cezh">'+ZH[e]+'</div>'
        +'<div class="bb2d-cepct">'+pct[e]+'%</div>'
        // Sits UNDER the percentage. Columns without a tag still render an
        // empty one, so every column is the same height and the names and
        // percentages stay on a common baseline - otherwise the tagged
        // columns grew 4px and lifted their own text out of line.
        +(need[e]
            ? '<div class="bb2d-cetag bb2d-cetag--need">NEED</div>'
            : '<div class="bb2d-cetag bb2d-cetag--blank" aria-hidden="true">&nbsp;</div>')
        +'</div>';
    }).join('');
  }

  function mineHTML(r){
    if(!r){
      return ''
        +'<div class="bb2d-elempty"><p>Not sure which crystals you need? A free '
        +'element reading shows which stones bring <em>your</em> chart into balance.</p>'
        +'<a class="bb2d-elcta" href="/pages/free-bazi-reading?view=bazi">DO MY ELEMENT READING</a></div>';
    }
    var need=r.like||[];
    return '<div class="bb2d-elhrow"><span class="bb2d-elh">YOUR ELEMENTS</span>'
      +'<button type="button" class="bb2d-fullbtn" id="bb2d-fullReading">SEE MY FULL READING</button></div>'
      +'<p class="bb2d-readp">'+((r.reading&&r.reading[0])||'')+'</p>'
      +'<div class="bb2d-needh">LACKING</div>'
      // ranked: Cantian returns these most-needed first, so number them
      +need.map(function(e,i){
        return '<div class="bb2d-beadrow'+(i===0?' bb2d-beadrow--first':'')+'">'
          +'<span class="bb2d-rank">'+(i+1)+'</span>'
          +'<span class="bb2d-beadic"><img src="'+ICON[e]+'" alt=""></span>'
          +'<span class="bb2d-beadname">'+e+'</span>'
          +'<span class="bb2d-beadpct">'+(r.percentage[e])+'%</span>'
          +'<button type="button" class="bb2d-beadbtn" data-el="'+e.toUpperCase()+'">ADD '
          +e.toUpperCase()+' CRYSTALS</button></div>';
      }).join('')
      ;  // panel shows LACKING only — the full reading covers abundant
  }



  // What each element means, plus why this chart scored it that way. The
  // "why" lines are the API's own energy factors, not our writing.
  var ELEMENT_ABOUT={
    Wood:{zh:'木',season:'spring',is:'growth, flexibility and new beginnings',
      body:'Wood is the element of starting: shoots pushing up, plans taking shape. It bends without breaking, and it wants room to grow.'},
    Fire:{zh:'火',season:'summer',is:'warmth, visibility and expression',
      body:'Fire is the element of being seen: warmth, enthusiasm, the spark that draws people in. It burns bright and needs fuel to last.'},
    Earth:{zh:'土',season:'the turn of each season',is:'stability, nourishment and grounding',
      body:'Earth is the element of holding: steady ground underfoot, patience, the centre things settle into. It nourishes, and it can hold on too long.'},
    Metal:{zh:'金',season:'autumn',is:'clarity, structure and refinement',
      body:'Metal is the element of edges: clear thinking, boundaries, what remains after everything unnecessary is cut away.'},
    Water:{zh:'水',season:'winter',is:'intuition, flow and depth',
      body:'Water is the element of moving: intuition, adaptability, depth beneath a still surface. It finds the way around rather than through.'}
  };

  function openElementInfo(el, r){
    var a=ELEMENT_ABOUT[el]; if(!a) return;
    var pct=(r&&r.percentage&&r.percentage[el]);
    var stateTxt='';
    if(r){
      if((r.like||[]).indexOf(el)>-1) stateTxt='This is one of the elements your chart is lacking.';
      else if((r.unlike||[]).indexOf(el)>-1) stateTxt='Your chart already carries plenty of this.';
    }
    var why=(r&&r.energy&&r.energy[el])||[];

    var html='<div class="bb2d-frsheet bb2d-elsheet"><div class="bb2d-frhead">'
      +'<span>'+el.toUpperCase()+' '+a.zh+'</span>'
      +'<button type="button" class="bb2d-frclose" aria-label="Close">&times;</button></div>'
      +'<div class="bb2d-frbody">'
      +'<div class="bb2d-eltop"><img src="'+ICON[el]+'" alt="">'
        +'<div><div class="bb2d-elname">'+el+' '+a.zh+'</div>'
        +'<div class="bb2d-elis">'+a.is+'</div></div></div>'
      +'<p class="bb2d-readp">'+a.body+'</p>'
      +'<p class="bb2d-readp"><b>Season</b> '+a.season+'</p>'
      +(pct!=null?'<div class="bb2d-elyour"><span>In your chart</span><b>'+pct+'%</b></div>':'')
      +(stateTxt?'<p class="bb2d-readp">'+stateTxt+'</p>':'')
      +(why.length?'<div class="bb2d-frsec"><div class="bb2d-needh">WHY IT READS THIS WAY</div>'
        +'<ul class="bb2d-elwhy">'+why.map(function(f){
            return '<li>'+(f.note||'')+'</li>';}).join('')+'</ul></div>':'')
      +'</div></div>';

    var ov=document.createElement('div');
    ov.className='bb2d-frmodal bb2d-frmodal--el'; ov.innerHTML=html;
    document.body.appendChild(ov);
    function close(){ ov.remove(); }
    ov.querySelector('.bb2d-frclose').addEventListener('click',close);
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
  }

  // ---- full reading modal -------------------------------------------------
  var fullReadingBody=null;
  // Builds the reading markup and caches it in fullReadingBody. Passing
  // {silent:true} skips opening the modal, so callers can embed the body.
  function openFullReading(r, opts){
    if(!r) return;
    var silent=!!(opts&&opts.silent);
    var p=r.percentage||{}, max=Math.max.apply(null,ORDER.map(function(e){return p[e]||0;}))||1;
    var yy=r.yinYang||{}, tot=(yy.yang||0)+(yy.yin||0), yang=tot?Math.round(yy.yang/tot*100):50;
    var z=r.zodiac||null;

    // label each column from the reading itself, not a percentage threshold:
    // the API already says which elements are wanted and which are in excess
    var likeSet={}, unlikeSet={};
    (r.like||[]).forEach(function(e,i){ likeSet[e]=i+1; });
    (r.unlike||[]).forEach(function(e){ unlikeSet[e]=true; });

    var chart=ORDER.map(function(e){
      var tag='', cls='';
      // "NEED" rather than "Lacking": it is the instruction, not a diagnosis
      if(likeSet[e]){ tag='NEED'; cls=' bb2d-cetag--need'; }
      else if(unlikeSet[e]){ tag='ABUNDANT'; cls=' bb2d-cetag--much'; }
      return '<div class="bb2d-ce">'
        +'<div class="bb2d-cetrack"><div class="bb2d-cefill" data-h="'+Math.max(3,(p[e]||0)/max*100)
          +'" style="background:'+PASTEL[e]+'"></div></div>'
        +'<button type="button" class="bb2d-elinfo" data-el="'+e+'" aria-label="About '+e+'">'
          +'<span class="bb2d-ceicon"><img src="'+ICON[e]+'" alt=""></span>'
          +'<span class="bb2d-cename">'+e.toUpperCase()+'</span>'
          +'<span class="bb2d-cezh">'+ZH[e]+'</span></button>'
        +'<div class="bb2d-cepct">'+(p[e]||0)+'%</div>'
        +(tag?'<div class="bb2d-cetag'+cls+'">'+tag+'</div>':'<div class="bb2d-cetag">&nbsp;</div>')
        +'</div>';
    }).join('');

    // Two columns with a rank number: Cantian returns these most-needed
    // first, so the order carries meaning and should be shown.
    var chips=function(list){
      return '<div class="bb2d-chips bb2d-chips--ranked">'+(list||[]).map(function(e,i){
        return '<span class="bb2d-chip">'
          +'<span class="bb2d-chiprank">'+(i+1)+'</span>'
          +'<img src="'+ICON[e]+'" alt="">'+e
          +' <span class="bb2d-chippct">'+(p[e]||0)+'%</span></span>';}).join('')+'</div>';
    };

    var taiji=(function(){
      var R=50,cx=50,cy=50,y=Math.max(.1,Math.min(.9,yang/100));
      var r1=R*y,r2=R-r1,split=cy-R+2*R*y;
      var d='M '+cx+' '+(cy-R)+' A '+R+' '+R+' 0 0 1 '+cx+' '+(cy+R)
           +' A '+r2+' '+r2+' 0 0 1 '+cx+' '+split
           +' A '+r1+' '+r1+' 0 0 0 '+cx+' '+(cy-R)+' Z';
      return '<svg class="bb2d-taiji" viewBox="0 0 100 100" aria-hidden="true">'
        +'<circle cx="50" cy="50" r="50" fill="#efe9de"></circle>'
        +'<path d="'+d+'" fill="#33302c"></path></svg>';
    })();

    // who this reading belongs to — same fields as the reading page summary
    var inp=r.input||{};
    var MON=['January','February','March','April','May','June','July',
             'August','September','October','November','December'];
    var pad=function(n){return String(n).padStart(2,'0');};
    var dateStr=inp.year? inp.day+' '+MON[(inp.month||1)-1]+' '+inp.year : '';
    var h24=(inp.hour===0||inp.hour)?inp.hour:null;
    var timeStr=(h24===null)?'Not given'
      :((h24%12)||12)+':'+pad(inp.minute||0)+' '+(h24<12?'am':'pm');
    var t=r.trueSolarTime;
    var tst=t?pad(t.hour)+':'+pad(t.minute)+':'+pad(t.second||0):'';

    var summary='<div class="bb2d-frsum">'
      +'<div class="bb2d-frsumav">'+(z&&z.zh?'<span>'+z.zh+'</span>':'')+'</div>'
      +'<div class="bb2d-frsumrows">'
      +'<div class="bb2d-frsumname">'+((z&&z.label)||'Your reading')+'</div>'
      +'<div class="bb2d-frsumrow"><span>Gender</span><b>'
        +(inp.gender===0?'Female':inp.gender===1?'Male':'—')+'</b></div>'
      +'<div class="bb2d-frsumrow"><span>Birthplace</span><b>'+(inp.location||'—')+'</b></div>'
      +'<div class="bb2d-frsumrow"><span>Date of birth</span><b>'+(dateStr||'—')+'</b></div>'
      +'<div class="bb2d-frsumrow"><span>Time of birth</span><b>'+timeStr+'</b></div>'
      +(tst?'<div class="bb2d-frsumrow"><span>True solar time</span><b>'+tst+'</b></div>':'')
      +(r.bazi?'<div class="bb2d-frsumrow"><span>Four pillars</span><b class="bb2d-frpil">'+r.bazi+'</b></div>':'')
      +'</div></div>';

    var body=""
      +summary
      +'<div class="bb2d-elchart">'+chart+'</div>'
      +'<p class="bb2d-readp">'+((r.reading&&r.reading[0])||'')+'</p>'
      +'<div class="bb2d-needh">LACKING</div>'+chips(r.like)
      +((r.unlike||[]).length?'<div class="bb2d-needh" style="margin-top:14px">ABUNDANT</div>'+chips(r.unlike):'')
      +(z?'<div class="bb2d-frsec"><div class="bb2d-needh">CHINESE ZODIAC 生肖</div>'
          +'<div class="bb2d-zotop"><span class="bb2d-zoname">'+(z.animal||z.zh||'')+'</span>'
          +'<span class="bb2d-zosub">'+(z.element?z.element+' '+z.animal:(z.label||''))+'</span>'
          +'<span class="bb2d-zozh">'+(z.zh||'')+'</span></div>'
          +((z.traits||[]).length?'<ul class="bb2d-zot">'+z.traits.map(function(t){
              return '<li><b>'+t.label+'</b> '+t.text+'</li>';}).join('')+'</ul>':'')
          +'</div>':'')
      +(yy.note?'<div class="bb2d-frsec"><div class="bb2d-needh">YIN AND YANG 阴阳</div>'
          +'<div class="bb2d-yyrow">'+taiji+'<div><div class="bb2d-yykey">'
          +'<span><i class="bb2d-d bb2d-dy"></i>Yang '+yang+'%</span>'
          +'<span><i class="bb2d-d bb2d-di"></i>Yin '+(100-yang)+'%</span></div>'
          +'<p class="bb2d-readp" style="margin:8px 0 0">'+yy.note+'</p></div></div></div>':'')
      +'<div class="bb2d-frfoot">'
        +'<a class="bb2d-fragain" href="/pages/free-bazi-reading?view=bazi">READ MY ELEMENTS AGAIN</a>'
      +'</div>';

    // cached so the bracelet chart can show this inline instead of opening a
    // second modal on top of the first
    fullReadingBody=body;

    var html='<div class="bb2d-frsheet"><div class="bb2d-frhead">'
      +'<span>YOUR FULL ELEMENT READING</span>'
      +'<button type="button" class="bb2d-frclose" aria-label="Close">&times;</button></div>'
      +'<div class="bb2d-frbody">'+body+'</div></div>';

    if(silent) return;

    var ov=document.createElement('div');
    ov.className='bb2d-frmodal'; ov.innerHTML=html;
    document.body.appendChild(ov);
    // the bars need px heights here too
    ov.querySelectorAll('.bb2d-cefill').forEach(function(f){
      var t=f.parentElement, th=t.clientHeight||92;
      f.style.height=Math.round(th*(parseFloat(f.dataset.h)||0)/100)+'px';
    });
    function close(){ ov.remove(); }
    ov.querySelector('.bb2d-frclose').addEventListener('click',close);
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
    ov.querySelectorAll('.bb2d-elinfo').forEach(function(btn){
      btn.addEventListener('click',function(ev){ ev.stopPropagation(); openElementInfo(btn.dataset.el, r); });
    });
  }

  // ── compact summary under the bracelet ───────────────────────────────────
  // The full chart is a modal now: on a phone the panel pushed wrist size,
  // crystals and add-to-cart off the screen.
  function dominantElement(){
    var mix=braceletMix(), best=null, bestV=0;
    ORDER.forEach(function(e){ if(mix[e]>bestV){ bestV=mix[e]; best=e; } });
    return bestV>0 ? {el:best, pct:bestV} : null;
  }
  function renderElSummary(isMobile){
    var bar=document.getElementById('bb2d-elSummary'),
        txt=document.getElementById('bb2d-elSummaryText');
    if(!bar||!txt) return;
    if(isMobile===false){ bar.hidden=true; return; }
    var st=(window.bb2dState?window.bb2dState():null);
    var d=(st&&st.seq&&st.seq.length) ? dominantElement() : null;
    var cta=bar.querySelector('.bb2d-elsummary-cta');
    // Always show the bar. Before any crystal is chosen it either points at
    // the bazi reading or, if one is saved, names the element to look for.
    if(d){
      // one line, no preamble, with the element's own icon before its name
      txt.innerHTML='Dominant element '
        +'<img class="bb2d-elsummary-icon" src="'+ICON[d.el]+'" alt="" aria-hidden="true">'
        +'<strong>'+d.el.toUpperCase()+'</strong>';
      if(cta){
        // With a saved reading, the CTA lists what the wearer is SHORT of,
        // ranked - "Need 1. Water 2. Fire +" - instead of the generic
        // "See element chart". Tapping still opens the chart.
        var rNeed=savedReading();
        if(rNeed && rNeed.like && rNeed.like.length){
          cta.textContent='Need '+rNeed.like.slice(0,2).map(function(e2,i2){
            var n2=String(e2);
            return (i2+1)+'. '+n2.charAt(0).toUpperCase()+n2.slice(1).toLowerCase();
          }).join(' ')+' +';
        } else cta.textContent='See element chart';
      }
      bar.dataset.mode='chart';
    } else {
      var r=savedReading();
      var need=r && r.like && r.like.length ? String(r.like[0]) : null;
      if(need){
        // Two separate actions on one line: the underlined phrase opens the
        // customer's own reading, the link on the right jumps straight to
        // the picker filtered to the element they are short of.
        txt.innerHTML='<span class="bb2d-elsummary-link">Your reading suggests</span> '
          +'<strong>'+need.toUpperCase()+'</strong> crystals';
        if(cta) cta.textContent='Add '+need.toLowerCase()+' element';
        bar.dataset.mode='addel';
        bar.dataset.el=need;
      } else {
        txt.innerHTML='Do your personal reading to see which crystals suit you';
        if(cta) cta.textContent='Start your reading';
        bar.dataset.mode='reading';
      }
    }
    bar.hidden=false;
  }
  // Modal holding the bracelet's own chart plus, when the customer has a
  // saved bazi reading, their side of it. openFullReading() is the bazi
  // modal and returns early without a reading, so it cannot serve here.
  // The bracelet chart used to carry a "SEE MY FULL READING" button, which
  // opened a modal on top of a modal. Show the reading inline instead.
  function fullReadingInline(r){
    openFullReading(r,{silent:true});
    var body=fullReadingBody||mineHTML(r);
    // strip the nested opener - the content it led to is already right here
    return '<div class="bb2d-frinline">'
      + '<h3 class="bb2d-frinline-h">YOUR BAZI READING</h3>'
      + body.replace(/<button[^>]*class="bb2d-fullbtn"[^>]*>.*?<\/button>/g,'')
      + '</div>';
  }

  function openBraceletChart(){
    var r=savedReading();
    var st=(window.bb2dState?window.bb2dState():null);
    var empty=!(st&&st.seq&&st.seq.length);
    // reuse the theme's own sheet structure - a bespoke panel class had no
    // background rule and rendered transparent over the page
    var html='<div class="bb2d-frsheet" role="dialog" aria-modal="true" aria-label="Bracelet element chart">'
      +'<div class="bb2d-frhead"><span>BRACELET ELEMENT CHART</span>'
        +'<button type="button" class="bb2d-frclose" aria-label="Close">&times;</button></div>'
      +'<div class="bb2d-frbody">'
        // Name what they are short of at the very top, before the chart -
        // it is the one thing a shopper is here to find out.
        +(function(){
            var need=(r&&r.like)?r.like:[];
            if(!need.length) return '<p class="bb2d-frsub">What this bracelet carries</p>';
            var names=need.map(function(e){
              return '<img class="bb2d-needicon" src="'+ICON[e]+'" alt="">'
                +'<strong>'+String(e).toUpperCase()+'</strong>'; });
            return '<p class="bb2d-needline">You need '
              + (names.length>1
                  ? names.slice(0,-1).join(', ')+' and '+names[names.length-1]
                  : names[0])
              + (names.length>1 ? ' elements' : ' element') + '</p>';
          })()
        +'<div class="bb2d-elchart">'
          +(empty ? '<p class="bb2d-elnone">Choose your crystals and this chart fills in.</p>'
                  : chartHTML(braceletMix(), true))
        +'</div>'
        +(r
            ? '<div class="bb2d-frsec">'+fullReadingInline(r)+'</div>'
            // No saved reading is the MOST important case to serve: this is
            // where a shopper is told the reading exists at all.
            : '<div class="bb2d-frsec bb2d-frnoread">'
                +'<h3 class="bb2d-frinline-h">YOUR BAZI READING</h3>'
                +'<p class="bb2d-frnoread-p">Find out which element suits you!</p>'
                +'<a class="bb2d-elcta" href="/pages/bazi">READ MY ELEMENTS</a>'
              +'</div>')
      +'</div>'
      +'</div>';
    var ov=document.createElement('div');
    ov.className='bb2d-frmodal'; ov.innerHTML=html;
    document.body.appendChild(ov);
    // bars need real px heights, same as the inline panel
    ov.querySelectorAll('.bb2d-cefill').forEach(function(f){
      var t=f.parentElement, th=t.clientHeight||92;
      f.style.height=Math.round(th*(parseFloat(f.dataset.h)||0)/100)+'px';
    });
    function close(){ ov.remove(); }
    ov.querySelector('.bb2d-frclose').addEventListener('click',close);
    ov.addEventListener('click',function(e){ if(e.target===ov) close(); });
    ov.querySelectorAll('.bb2d-elinfo').forEach(function(btn){
      btn.addEventListener('click',function(ev){ ev.stopPropagation(); openElementInfo(btn.dataset.el, r); });
    });
  }
  // crossing the breakpoint has to re-evaluate, or the panel/bar state sticks
  (function watchBreakpoint(){
    var mq=window.matchMedia('(max-width: 860px)');
    var on=function(){ if(window.renderElementPanel) try{ window.renderElementPanel(); }catch(_){} };
    if(mq.addEventListener) mq.addEventListener('change',on);
    else if(mq.addListener) mq.addListener(on);
  })();

  (function wireElSummary(){
    var bar=document.getElementById('bb2d-elSummary');
    if(!bar) return;
    // Always open the chart. Navigating straight to /pages/bazi meant a
    // shopper without a reading could never see what their bracelet carries,
    // and never met the reading offer in context - the modal now carries a
    // "Find out which element suits you!" prompt for that case.
    bar.addEventListener('click',function(e){
      // the underlined phrase opens the reading itself
      if(e.target.closest && e.target.closest('.bb2d-elsummary-link')){
        e.stopPropagation();
        openBraceletChart();
        return;
      }
      // "Add <element> element" opens the picker pre-filtered to it
      if(bar.dataset.mode==='addel' && bar.dataset.el){
        var el=bar.dataset.el;
        if(window.bb2dOpenLibrary) window.bb2dOpenLibrary();
        if(window.bb2dSetElementFilter) window.bb2dSetElementFilter(el);
        // Arriving from "Add <element> element" means the element is already
        // decided - hide the other filters so the sheet stays about that one.
        // on the OVERLAY, not .lib - the search and filter rows sit outside
        // .lib, so a class there could never reach them
        var ovEl=document.getElementById('bb2d-libOverlay');
        if(ovEl) ovEl.classList.add('lib--element-locked');
        return;
      }
      openBraceletChart();
    });
  })();
  window.bb2dRenderElSummary=renderElSummary;

  window.renderElementPanel=function(){
    var panel=document.getElementById('bb2d-elPanel');
    if(!panel) return;
    // MOBILE ONLY. Desktop keeps the inline element panel exactly as it was;
    // only on a phone does it collapse to the summary bar + modal, because
    // there it pushed wrist size, crystals and add-to-cart off the screen.
    var isMobile=window.matchMedia('(max-width: 860px)').matches;
    renderElSummary(isMobile);
    var st0=(window.bb2dState?window.bb2dState():null);
    var empty=!(st0&&st0.seq&&st0.seq.length);
    // owner 17 Aug: the YOUR ELEMENTS side (reading, or the do-my-reading
    // prompt) shows from page load; only the bracelet chart column waits
    // for the first crystal. Panel keeps its box so the bracelet never moves.
    panel.hidden=isMobile;
    panel.style.visibility='';
    var chartEl=document.getElementById('bb2d-elChart');
    var chartCol=chartEl?chartEl.closest('.bb2d-elcol'):null;
    if(chartCol) chartCol.style.display=empty?'none':'';
    panel.style.gridTemplateColumns=empty?'1fr':'';
    // no reading yet: drop the white panel chrome and sit the prompt higher
    panel.classList.toggle('bb2d-elpanel--bare', empty && !savedReading());
    document.getElementById('bb2d-elChart').innerHTML= empty
      ? '<p class="bb2d-elnone">Choose your crystals and this chart fills in.</p>'
      : chartHTML(braceletMix(), true);
    var mine=document.getElementById('bb2d-elMine');
    var r=savedReading();
    mine.innerHTML=mineHTML(r);

    // close the gap under the bracelet without overlapping it: measure where
    // the ring actually ends inside the square stage
    (function(){
      var stage=document.getElementById('bb2d-stage'),
          ring=document.getElementById('bb2d-ring'),
          panel=document.getElementById('bb2d-elPanel');
      if(!stage||!ring||!panel) return;
      // Measure the PIECES, not #bb2d-ring. The ring is position:absolute with
      // inset:0, so before any bead exists its rect collapses to the top of the
      // stage: slack came out as the whole stage height and the panel was
      // pulled up ~560px, sitting on the bracelet for a second before settling.
      // RETIRED (28 Jul): the panel now pins to the bottom of the sticky
      // preview column via margin-top:auto in CSS - it rides the screen
      // bottom while building and releases with the column at page end.
      // The measured pull-up fought that pinning (and could slide the
      // panel behind the zoomed bracelet), so it only clears itself now.
      panel.style.marginTop='';
    })();

    // resolve the bar heights against the track's real pixel height
    document.querySelectorAll('#bb2d-elChart .bb2d-cefill').forEach(function(f){
      var track=f.parentElement, th=track.clientHeight||92;
      f.style.height=Math.round(th*(parseFloat(f.dataset.h)||0)/100)+'px';
    });

    var fr=document.getElementById('bb2d-fullReading');
    if(fr) fr.addEventListener('click',function(){ openFullReading(savedReading()); });

    // "SEE WOOD CRYSTALS" opens the existing library with the element filter set
    mine.querySelectorAll('.bb2d-beadbtn').forEach(function(b){
      b.addEventListener('click',function(){
        // use the builder's own opener so the snapshot / render-suppression
        // logic runs, then pre-set the element filter it already supports
        if(typeof window.bb2dOpenLibrary==='function') window.bb2dOpenLibrary();
        var sel=document.getElementById('bb2d-fEl');
        if(sel){ sel.value=b.dataset.el; sel.dispatchEvent(new Event('change')); }
      });
    });
  };

  // paint on load so the panel is there before any crystal is chosen
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){ try{ window.renderElementPanel(); }catch(_){} });
  } else {
    setTimeout(function(){ try{ window.renderElementPanel(); }catch(_){} },0);
  }
})();



/* ── Progressive right column ─────────────────────────────────────────────
   Reads builder state through window.bb2dState() only - never pokes the
   builder's internals. The CSS that hides locked sections is desktop-only,
   so on mobile these classes are inert and the sheet flow is unchanged. */
(function(){
  var ctrl=document.querySelector('.bb2d-ctrl'); if(!ctrl) return;
  var fields=[].slice.call(ctrl.querySelectorAll('.bb2d-field'));
  var byId=function(id){ return fields.filter(function(f){ return f.querySelector('#'+id); })[0]; };
  var F={ wrist:byId('bb2d-wrist'), crystal:byId('bb2d-crystalCells'), pix:byId('bb2d-pixCells'),
          pearl:byId('bb2d-spacerCells'), charm:byId('bb2d-charmStrip'), buy:byId('bb2d-atc') };
  if(!F.wrist||!F.crystal) return;

  // wrist starts EMPTY: display-only placeholder; the builder's internal
  // default geometry is untouched so the empty ring still draws correctly
  var sel=document.getElementById('bb2d-wrist');
  var ph=document.createElement('option');
  ph.value=''; ph.textContent='Select your wrist size'; ph.disabled=true; ph.selected=true;
  sel.insertBefore(ph, sel.firstChild);
  sel.value='';
  if(sel._bb2dSync) sel._bb2dSync();

  // red nudge (owner-approved option 3, 18 Oct 2026): the field carries
  // bb2d-wrist-unset while no size is chosen; CSS draws the cue off it
  var syncWristNudge=function(){ F.wrist.classList.toggle('bb2d-wrist-unset', sel.value===''); };
  syncWristNudge();

  var wristChosen=false, pixTouched=false, crystalConfirmed=false;
  sel.addEventListener('change', function(){ if(sel.value!=='') wristChosen=true; syncWristNudge(); sync(); });
  // the crystal step completes on the library's CONFIRM, not on the first
  // pick - otherwise the next section appears behind the open overlay
  document.addEventListener('click', function(e){
    if(e.target && e.target.closest && e.target.closest('#bb2d-libConfirm')){
      crystalConfirmed=true; setTimeout(sync,120);
    }
  }, true);
  // The pixiu is OPTIONAL (owner, 9 Aug): any action in the section counts
  // as done - choosing a dragon, or tapping the default off to have none.
  // Same rule down the chain: touching pearls reveals charms, touching
  // charms reveals add to cart. Optional steps progress on interaction,
  // not on selection.
  var pearlTouched=false, charmTouched=false;
  if(F.pix)   F.pix.addEventListener('click',   function(){ pixTouched=true;   setTimeout(sync,80); }, true);
  // clicking ahead counts the skipped steps too: the default pixiu IS a
  // choice, so a click anywhere on Pearl of Wisdom must reveal charms
  // (owner, 9 Aug) even when the customer never touched the pixiu section
  if(F.pearl) F.pearl.addEventListener('click', function(){ pixTouched=true; pearlTouched=true; setTimeout(sync,80); }, true);
  if(F.charm) F.charm.addEventListener('click', function(){ pixTouched=true; pearlTouched=true; charmTouched=true; setTimeout(sync,80); }, true);

  function lock(f){ if(f && !f.classList.contains('bb2d-step-locked')){ f.classList.add('bb2d-step-locked'); f.classList.remove('bb2d-step-open'); } }
  function open(f){ if(f && f.classList.contains('bb2d-step-locked')){ f.classList.remove('bb2d-step-locked'); f.classList.add('bb2d-step-open'); } }
  function sync(){
    var st=window.bb2dState ? window.bb2dState() : null;
    var hasCrystal=crystalConfirmed && !!(st && st.seq && st.seq.length);
    // the running price shows as soon as crystals are chosen (owner, 9 Aug)
    // even while the rest of the buy section waits for the later steps
    var priceEl=document.getElementById('bb2d-price');
    if(priceEl) priceEl.classList.toggle('bb2d-price-early', hasCrystal);
    // add to cart is NEVER hidden (owner, 9 Aug): the button itself
    // explains what is missing while disabled, so F.buy is never locked
    open(F.buy);
    if(!wristChosen){ lock(F.crystal); lock(F.pix); lock(F.pearl); lock(F.charm); return; }
    open(F.crystal);
    if(!hasCrystal){ lock(F.pix); lock(F.pearl); lock(F.charm); return; }
    open(F.pix);
    if(!pixTouched){ lock(F.pearl); lock(F.charm); return; }
    // pearls and charms show TOGETHER (owner, 9 Aug) - no gate between them
    open(F.pearl); open(F.charm);
  }
  sync();
  ['click','change'].forEach(function(ev){ ctrl.addEventListener(ev, function(){ setTimeout(sync,80); }, true); });
  setInterval(sync, 600);
})();





